export class ObtenerIds{
  static idsCuentasP5(id: string, tipo: string, objeto?: boolean){
    switch(tipo){
      case 'bal':
        const idsBal = {
          'A1':           [{nivel: 1, pos: 1}],
          'A101':         [{nivel: 2, pos: 2}],
          'A102':         [{nivel: 2, pos: 3}],
          'A103':         [{nivel: 2, pos: 4}],
          'A104':         [{nivel: 2, pos: 5}],
          'A10401':       [{nivel: 3, pos: 6}],
          'A10402':       [{nivel: 3, pos: 7}],
          'A10403':       [{nivel: 3, pos: 8}],
          'A105':         [{nivel: 2, pos: 9}],
          'A10501':       [{nivel: 3, pos: 10}],
          'A10502':       [{nivel: 3, pos: 11}],
          'A10503':       [{nivel: 3, pos: 12}],
          'A106':         [{nivel: 2, pos: 13}],
          'A10601':       [{nivel: 3, pos: 14}],
          'A1060101':     [{nivel: 4, pos: 15}],
          'A106010101':   [{nivel: 5, pos: 16}],
          'A106010102':   [{nivel: 5, pos: 17}],
          'A106010103':   [{nivel: 5, pos: 18}],
          'A10602':       [{nivel: 3, pos: 19}],
          'A107':         [{nivel: 2, pos: 20}],
          'A108':         [{nivel: 2, pos: 21}],
          'A109':         [{nivel: 2, pos: 22}],
          'A110':         [{nivel: 2, pos: 23}],
          'A111':         [{nivel: 2, pos: 24}],
          'A112':         [{nivel: 2, pos: 25}],
          'A113':         [{nivel: 2, pos: 26}],
          'P2':           [{nivel: 1, pos: 27}],
          'P201':         [{nivel: 2, pos: 28}],
          'P20101':       [{nivel: 3, pos: 29}],
          'P20102':       [{nivel: 3, pos: 30}],
          'P20103':       [{nivel: 3, pos: 31}],
          'P202':         [{nivel: 2, pos: 32}],
          'P20201':       [{nivel: 3, pos: 33}],
          'P20202':       [{nivel: 3, pos: 34}],
          'P203':         [{nivel: 2, pos: 35}],
          'P204':         [{nivel: 2, pos: 36}],
          'P205':         [{nivel: 2, pos: 37}],
          'P206':         [{nivel: 2, pos: 38}],
          'P3':           [{nivel: 1, pos: 39}],
          'P301':         [{nivel: 2, pos: 40}],
          'P302':         [{nivel: 2, pos: 41}],
          'P30201':       [{nivel: 3, pos: 42}],
          'P30202':       [{nivel: 3, pos: 43}],
          'P30203':       [{nivel: 3, pos: 44}],
          'P30204':       [{nivel: 3, pos: 45}],
          'P30205':       [{nivel: 3, pos: 46}],
          'P30206':       [{nivel: 3, pos: 47}],
          'P30207':       [{nivel: 3, pos: 48}],
          'P30208':       [{nivel: 3, pos: 49}],
          'P30209':       [{nivel: 3, pos: 50}],
          'P30210':       [{nivel: 3, pos: 51}],
          'P30211':       [{nivel: 3, pos: 52}],
          'P30212':       [{nivel: 3, pos: 53}],
          'P303':         [{nivel: 2, pos: 54}],
        }
        if(objeto) return idsBal;
        return idsBal[id] ?? undefined;
      case 'est':
        const idsEst = {
          'I501'     : [{nivel: 2, pos: 1}],
          'I50101':      [{nivel: 3, pos: 2}],
          'I50102'  : [{nivel: 3, pos: 3}],
          'I50103'  : [{nivel: 3, pos: 4}],
          'I50104'  : [{nivel: 3, pos: 5}],
          'I5010401'  : [{nivel: 4, pos: 6}],
          'I5010402'    : [{nivel: 4, pos: 7}],
          'I5010403'     : [{nivel: 4, pos: 8}],
          'I50105':      [{nivel: 3, pos: 9}],
          'I5010501': [{nivel: 4, pos: 10}],
          'I5010502': [{nivel: 4, pos: 11}],
          'I5010503': [{nivel: 4, pos: 12}],
          'I50106': [{nivel: 3, pos: 13}],
          'I5010601':      [{nivel: 4, pos: 14}],
          'I5010602': [{nivel: 4, pos: 15}],
          'I5010603': [{nivel: 4, pos: 16}],
          'I50107': [{nivel: 3, pos: 17}],
          'I50108': [{nivel: 3, pos: 18}],
          'G601':      [{nivel: 2, pos: 19}],
          'G60101': [{nivel: 3, pos: 20}],
          'G60102': [{nivel: 3, pos: 21}],
          'G60103': [{nivel: 3, pos: 22}],
          'G60104': [{nivel: 3, pos: 23}],
          'G60105':      [{nivel: 3, pos: 24}],
          'G60106'  : [{nivel: 3, pos: 25}],
          'G60107'  : [{nivel: 3, pos: 26}],
          'I502'  : [{nivel: 2, pos: 27}],
          'VT01':      [{nivel: 1, pos: 28}],
          'G602'  : [{nivel: 2, pos: 29}],
          'G60201':      [{nivel: 3, pos: 30}],
          'G6020101'     : [{nivel: 4, pos: 31}],
          'G602010101'    : [{nivel: 5, pos: 32}],
          'G602010102'    : [{nivel: 5, pos: 33}],
          'G602010103'    : [{nivel: 5, pos: 34}],
          'G60202'    : [{nivel: 3, pos: 35}],
          'G60203'    : [{nivel: 3, pos: 36}],
          'VT02'  : [{nivel: 1, pos: 37}],
          'I503'    : [{nivel: 2, pos: 38}],
          'G603'     : [{nivel: 2, pos: 39}],
          'I504':      [{nivel: 2, pos: 40}],
          'I505'  : [{nivel: 2, pos: 41}],
          'G604'    : [{nivel: 2, pos: 42}],
          'VT03':      [{nivel: 1, pos: 43}],
          'I506'  : [{nivel: 2, pos: 44}],
          'VT04':      [{nivel: 1, pos: 45}],
          'I507':      [{nivel: 2, pos: 46}],
          'VT05'    : [{nivel: 1, pos: 47}],
        }
        if(objeto) return idsEst;
        return idsEst[id] ?? undefined;
    }
  }
  static idsCuentasP7(id: string, tipo: string, objeto?: boolean){
    switch(tipo){
      case 'bal':
        const idsBal = {
          'A1':         [{nivel: 1, pos: 1}],
          'VT042':      [{nivel: 2, pos: 2}],
          'A11101':     [{nivel: 3, pos: 3}],
          'A11102':     [{nivel: 3, pos: 4}],
          'A11103':     [{nivel: 3, pos: 5}],
          'VT048':      [{nivel: 2, pos: 6}],
          'A11104':     [{nivel: 3, pos: 7}],
          'A121':       [{nivel: 3, pos: 8}],
          'VT005':      [{nivel: 2, pos: 9}],
          'VT007':      [{nivel: 3, pos: 10}],
          'VT043':      [{nivel: 4, pos: 11}],
          'V026':       [{nivel: 5, pos: 12}],
          'V027':       [{nivel: 5, pos: 13}],
          'V028':       [{nivel: 5, pos: 14}],
          'VT013':      [{nivel: 4, pos: 15}],
          'V029':       [{nivel: 5, pos: 16}],
          'V030':       [{nivel: 5, pos: 17}],
          'V031':       [{nivel: 5, pos: 18}],
          'V032':       [{nivel: 5, pos: 19}],
          'V033':       [{nivel: 5, pos: 20}],
          'VT014':      [{nivel: 3, pos: 21}],
          'VT015':      [{nivel: 4, pos: 22}],
          'V034':       [{nivel: 5, pos: 23}],
          'V035':       [{nivel: 5, pos: 24}],
          'VT016':      [{nivel: 4, pos: 25}],
          'V036':       [{nivel: 5, pos: 26}],
          'V037':       [{nivel: 5, pos: 27}],
          'V038':       [{nivel: 5, pos: 28}],
          'V039':       [{nivel: 5, pos: 29}],
          'V040':       [{nivel: 5, pos: 30}],
          'A124':       [{nivel: 2, pos: 31}],
          'A11203':     [{nivel: 2, pos: 32}],
          'A12504':     [{nivel: 2, pos: 33}],
          'VT040':      [{nivel: 2, pos: 34}],
          'A11402':     [{nivel: 3, pos: 35}],
          'A12502':     [{nivel: 3, pos: 36}],
          'A12503':     [{nivel: 3, pos: 37}],
          'VT041':      [{nivel: 2, pos: 38}],
          'A113':       [{nivel: 3, pos: 39}],
          'A11204':     [{nivel: 3, pos: 40}],
          'A11205':     [{nivel: 3, pos: 41}],
          'A11401':     [{nivel: 3, pos: 42}],
          'A12203':     [{nivel: 3, pos: 43}],
          'A12204':     [{nivel: 3, pos: 44}],
          'A123':       [{nivel: 3, pos: 45}],
          'A12501':     [{nivel: 3, pos: 46}],
          'P2':         [{nivel: 1, pos: 47}],
          'VT008':      [{nivel: 2, pos: 48}],
          'VT017':      [{nivel: 3, pos: 49}],
          'P211010101': [{nivel: 4, pos: 50}],
          'P211010102': [{nivel: 4, pos: 51}],
          'P211010201': [{nivel: 4, pos: 52}],
          'P211010202': [{nivel: 4, pos: 53}],
          'VT050':      [{nivel: 3, pos: 54}],
          'VT021':      [{nivel: 4, pos: 55}],
          'P211010103': [{nivel: 5, pos: 56}],
          'P211010104': [{nivel: 5, pos: 57}],
          'P211010203': [{nivel: 5, pos: 58}],
          'P211010204': [{nivel: 5, pos: 59}],
          'VT052':      [{nivel: 4, pos: 60}],
          'P221010101': [{nivel: 5, pos: 61}],
          'P221010102': [{nivel: 5, pos: 62}],
          'P221010201': [{nivel: 5, pos: 63}],
          'P221010202': [{nivel: 5, pos: 64}],
          'VT053':      [{nivel: 3, pos: 65}],
          'VT054':      [{nivel: 4, pos: 66}],
          'P211010105': [{nivel: 5, pos: 67}],
          'P211010106': [{nivel: 5, pos: 68}],
          'P211010205': [{nivel: 5, pos: 69}],
          'P211010206': [{nivel: 5, pos: 70}],
          'VT055':      [{nivel: 4, pos: 71}],
          'P221010103': [{nivel: 5, pos: 72}],
          'P221010104': [{nivel: 5, pos: 73}],
          'P221010203': [{nivel: 5, pos: 74}],
          'P221010204': [{nivel: 5, pos: 75}],
          'VT025':      [{nivel: 2, pos: 76}],
          'VT056':      [{nivel: 3, pos: 77}],
          'P2110103':   [{nivel: 4, pos: 78}],
          'P21102':     [{nivel: 4, pos: 79}],
          'VT046':      [{nivel: 3, pos: 80}],
          'P2210103':   [{nivel: 4, pos: 81}],
          'P22102':     [{nivel: 4, pos: 82}],
          'VT044':      [{nivel: 2, pos: 83}],
          'P21203':     [{nivel: 3, pos: 84}],
          'P22202':     [{nivel: 3, pos: 85}],
          'VT026':      [{nivel: 2, pos: 86}],
          'P21103':     [{nivel: 3, pos: 87}],
          'P22103':     [{nivel: 3, pos: 88}],
          'VT058':      [{nivel: 2, pos: 89}],
          'VT059':      [{nivel: 3, pos: 90}],
          'P21201':     [{nivel: 4, pos: 91}],
          'P21202':     [{nivel: 4, pos: 92}],
          'P21204':     [{nivel: 4, pos: 93}],
          'VT060':      [{nivel: 3, pos: 94}],
          'P22201':     [{nivel: 4, pos: 95}],
          'P22203':     [{nivel: 4, pos: 96}],
          'P3':         [{nivel: 1, pos: 97}],
          'P311':       [{nivel: 2, pos: 98}],
          'P312':       [{nivel: 2, pos: 99}],
          'P31201':     [{nivel: 3, pos: 100}],
          'P31202':     [{nivel: 3, pos: 101}],
        }
        if(objeto) return idsBal;
        return idsBal[id] ?? undefined;
      case 'est':
        const idsEst = {
          'VT035'     : [{nivel: 2, pos: 1}],
          'VT061':      [{nivel: 3, pos: 2}],
          'I4110101'  : [{nivel: 4, pos: 3}],
          'I4110103'  : [{nivel: 4, pos: 4}],
          'I4110104'  : [{nivel: 4, pos: 5}],
          'I4110105'  : [{nivel: 4, pos: 6}],
          'I41103'    : [{nivel: 3, pos: 7}],
          'VT036'     : [{nivel: 2, pos: 8}],
          'VT062':      [{nivel: 3, pos: 9}],
          'G511010101': [{nivel: 4, pos: 10}],
          'G511010102': [{nivel: 4, pos: 11}],
          'G511010201': [{nivel: 4, pos: 12}],
          'G511010202': [{nivel: 4, pos: 13}],
          'VT063':      [{nivel: 3, pos: 14}],
          'G511010103': [{nivel: 4, pos: 15}],
          'G511010104': [{nivel: 4, pos: 16}],
          'G511010203': [{nivel: 4, pos: 17}],
          'G511010204': [{nivel: 4, pos: 18}],
          'VT064':      [{nivel: 3, pos: 19}],
          'G511010105': [{nivel: 4, pos: 20}],
          'G511010106': [{nivel: 4, pos: 21}],
          'G511010205': [{nivel: 4, pos: 22}],
          'G511010206': [{nivel: 4, pos: 23}],
          'VT065':      [{nivel: 3, pos: 24}],
          'G5110103'  : [{nivel: 4, pos: 25}],
          'G5110105'  : [{nivel: 4, pos: 26}],
          'G5110106'  : [{nivel: 4, pos: 27}],
          'VT049':      [{nivel: 1, pos: 28}],
          'G5110201'  : [{nivel: 2, pos: 29}],
          'VT067':      [{nivel: 1, pos: 30}],
          'VT037'     : [{nivel: 2, pos: 31}],
          'G51104'    : [{nivel: 3, pos: 32}],
          'G51105'    : [{nivel: 3, pos: 33}],
          'G51202'    : [{nivel: 3, pos: 34}],
          'G51301'    : [{nivel: 3, pos: 35}],
          'G51303'    : [{nivel: 3, pos: 36}],
          'G5110202'  : [{nivel: 3, pos: 37}],
          'G51103'    : [{nivel: 3, pos: 38}],
          'VT038'     : [{nivel: 2, pos: 39}],
          'VT068':      [{nivel: 3, pos: 40}],
          'I4110102'  : [{nivel: 4, pos: 41}],
          'I41102'    : [{nivel: 4, pos: 42}],
          'VT069':      [{nivel: 3, pos: 43}],
          'G5110104'  : [{nivel: 4, pos: 44}],
          'VT070':      [{nivel: 1, pos: 45}],
          'VT071':      [{nivel: 2, pos: 46}],
          'I41104'    : [{nivel: 3, pos: 47}],
          'I41105'    : [{nivel: 3, pos: 48}],
          'I42'       : [{nivel: 3, pos: 49}],
          'VT072':      [{nivel: 2, pos: 50}],
          'G51201'    : [{nivel: 3, pos: 51}],
          'G51203'    : [{nivel: 3, pos: 52}],
          'G51302'    : [{nivel: 3, pos: 53}],
          'G52'       : [{nivel: 3, pos: 54}],
          'VT029'     : [{nivel: 1, pos: 55}],
        }
        if(objeto) return idsEst;
        return idsEst[id] ?? undefined;
    }
  }
  static idsCuentasP9(id: string, tipo: string, objeto?: boolean){
    switch(tipo){
      case 'bal':
        const idsBal = {
          'A1':         [{nivel: 1, pos: 1}],
          'VT042':      [{nivel: 2, pos: 2}],
          'A11101':     [{nivel: 3, pos: 3}],
          'A11102':     [{nivel: 3, pos: 4}],
          'A11103':     [{nivel: 3, pos: 5}],
          'VT048':      [{nivel: 2, pos: 6}],
          'A11104':     [{nivel: 3, pos: 7}],
          'A121':       [{nivel: 3, pos: 8}],
          'VT005':      [{nivel: 2, pos: 9}],
          'VT007':      [{nivel: 3, pos: 10}],
          'VT043':      [{nivel: 4, pos: 11}],
          // 'V026':       [{nivel: 5, pos: 12}],
          // 'V027':       [{nivel: 5, pos: 13}],
          // 'V028':       [{nivel: 5, pos: 14}],
          'VT013':      [{nivel: 4, pos: 15}],
          // 'V029':       [{nivel: 5, pos: 16}],
          // 'V030':       [{nivel: 5, pos: 17}],
          // 'V031':       [{nivel: 5, pos: 18}],
          // 'V032':       [{nivel: 5, pos: 19}],
          // 'V033':       [{nivel: 5, pos: 20}],
          'VT014':      [{nivel: 3, pos: 21}],
          'VT015':      [{nivel: 4, pos: 22}],
          'V034':       [{nivel: 5, pos: 23}],
          'V035':       [{nivel: 5, pos: 24}],
          'VT016':      [{nivel: 4, pos: 25}],
          'V036':       [{nivel: 5, pos: 26}],
          'V037':       [{nivel: 5, pos: 27}],
          'V038':       [{nivel: 5, pos: 28}],
          'V039':       [{nivel: 5, pos: 29}],
          'V040':       [{nivel: 5, pos: 30}],
          'A124':       [{nivel: 2, pos: 31}],
          'A11203':     [{nivel: 2, pos: 32}],
          'A12504':     [{nivel: 2, pos: 33}],
          'VT040':      [{nivel: 2, pos: 34}],
          'A11402':     [{nivel: 3, pos: 35}],
          'A12502':     [{nivel: 3, pos: 36}],
          'A12503':     [{nivel: 3, pos: 37}],
          'VT041':      [{nivel: 2, pos: 38}],
          'A113':       [{nivel: 3, pos: 39}],
          'A11204':     [{nivel: 3, pos: 40}],
          'A11205':     [{nivel: 3, pos: 41}],
          'A11401':     [{nivel: 3, pos: 42}],
          'A12203':     [{nivel: 3, pos: 43}],
          'A12204':     [{nivel: 3, pos: 44}],
          'A123':       [{nivel: 3, pos: 45}],
          'A12501':     [{nivel: 3, pos: 46}],
          'P2':         [{nivel: 1, pos: 47}],
          'VT008':      [{nivel: 2, pos: 48}],
          'VT017':      [{nivel: 3, pos: 49}],
          'P211010101': [{nivel: 4, pos: 50}],
          'P211010102': [{nivel: 4, pos: 51}],
          'P211010201': [{nivel: 4, pos: 52}],
          'P211010202': [{nivel: 4, pos: 53}],
          'VT050':      [{nivel: 3, pos: 54}],
          'VT021':      [{nivel: 4, pos: 55}],
          'P211010103': [{nivel: 5, pos: 56}],
          'P211010104': [{nivel: 5, pos: 57}],
          'P211010203': [{nivel: 5, pos: 58}],
          'P211010204': [{nivel: 5, pos: 59}],
          'VT052':      [{nivel: 4, pos: 60}],
          'P221010101': [{nivel: 5, pos: 61}],
          'P221010102': [{nivel: 5, pos: 62}],
          'P221010201': [{nivel: 5, pos: 63}],
          'P221010202': [{nivel: 5, pos: 64}],
          'VT053':      [{nivel: 3, pos: 65}],
          'VT054':      [{nivel: 4, pos: 66}],
          'P211010105': [{nivel: 5, pos: 67}],
          'P211010106': [{nivel: 5, pos: 68}],
          'P211010205': [{nivel: 5, pos: 69}],
          'P211010206': [{nivel: 5, pos: 70}],
          'VT055':      [{nivel: 4, pos: 71}],
          'P221010103': [{nivel: 5, pos: 72}],
          'P221010104': [{nivel: 5, pos: 73}],
          'P221010203': [{nivel: 5, pos: 74}],
          'P221010204': [{nivel: 5, pos: 75}],
          'VT025':      [{nivel: 2, pos: 76}],
          'VT056':      [{nivel: 3, pos: 77}],
          'P2110103':   [{nivel: 4, pos: 78}],
          'P21102':     [{nivel: 4, pos: 79}],
          'VT046':      [{nivel: 3, pos: 80}],
          'P2210103':   [{nivel: 4, pos: 81}],
          'P22102':     [{nivel: 4, pos: 82}],
          'VT044':      [{nivel: 2, pos: 83}],
          'P21203':     [{nivel: 3, pos: 84}],
          'P22202':     [{nivel: 3, pos: 85}],
          'VT026':      [{nivel: 2, pos: 86}],
          'P21103':     [{nivel: 3, pos: 87}],
          'P22103':     [{nivel: 3, pos: 88}],
          'VT058':      [{nivel: 2, pos: 89}],
          'VT059':      [{nivel: 3, pos: 90}],
          'P21201':     [{nivel: 4, pos: 91}],
          'P21202':     [{nivel: 4, pos: 92}],
          'P21204':     [{nivel: 4, pos: 93}],
          'VT060':      [{nivel: 3, pos: 94}],
          'P22201':     [{nivel: 4, pos: 95}],
          'P22203':     [{nivel: 4, pos: 96}],
          'P3':         [{nivel: 1, pos: 97}],
          'P311':       [{nivel: 2, pos: 98}],
          'P312':       [{nivel: 2, pos: 99}],
          'P31201':     [{nivel: 3, pos: 100}],
          'P31202':     [{nivel: 3, pos: 101}],
          'P313':       [{nivel: 2, pos: 102}],
        }
        if(objeto) return idsBal;
        return idsBal[id] ?? undefined;
      case 'est':
        const idsEst = {
          'VT035'     : [{nivel: 2, pos: 1}],
          'VT061':      [{nivel: 3, pos: 2}],
          'I4110101'  : [{nivel: 4, pos: 3}],
          'I4110103'  : [{nivel: 4, pos: 4}],
          'I4110104'  : [{nivel: 4, pos: 5}],
          'I4110105'  : [{nivel: 4, pos: 6}],
          'I41103'    : [{nivel: 3, pos: 7}],
          'VT036'     : [{nivel: 2, pos: 8}],
          'VT062':      [{nivel: 3, pos: 9}],
          'G511010101': [{nivel: 4, pos: 10}],
          'G511010102': [{nivel: 4, pos: 11}],
          'G511010201': [{nivel: 4, pos: 12}],
          'G511010202': [{nivel: 4, pos: 13}],
          'VT063':      [{nivel: 3, pos: 14}],
          'G511010103': [{nivel: 4, pos: 15}],
          'G511010104': [{nivel: 4, pos: 16}],
          'G511010203': [{nivel: 4, pos: 17}],
          'G511010204': [{nivel: 4, pos: 18}],
          'VT064':      [{nivel: 3, pos: 19}],
          'G511010105': [{nivel: 4, pos: 20}],
          'G511010106': [{nivel: 4, pos: 21}],
          'G511010205': [{nivel: 4, pos: 22}],
          'G511010206': [{nivel: 4, pos: 23}],
          'VT065':      [{nivel: 3, pos: 24}],
          'G5110103'  : [{nivel: 4, pos: 25}],
          'G5110105'  : [{nivel: 4, pos: 26}],
          'G5110106'  : [{nivel: 4, pos: 27}],
          'VT049':      [{nivel: 1, pos: 28}],
          'G5110201'  : [{nivel: 2, pos: 29}],
          'VT067':      [{nivel: 1, pos: 30}],
          'VT037'     : [{nivel: 2, pos: 31}],
          'G51104'    : [{nivel: 3, pos: 32}],
          'G51105'    : [{nivel: 3, pos: 33}],
          'G51202'    : [{nivel: 3, pos: 34}],
          'G51301'    : [{nivel: 3, pos: 35}],
          'G51303'    : [{nivel: 3, pos: 36}],
          'G5110202'  : [{nivel: 3, pos: 37}],
          'G51103'    : [{nivel: 3, pos: 38}],
          'VT038'     : [{nivel: 2, pos: 39}],
          'VT068':      [{nivel: 3, pos: 40}],
          'I4110102'  : [{nivel: 4, pos: 41}],
          'I41102'    : [{nivel: 4, pos: 42}],
          'VT069':      [{nivel: 3, pos: 43}],
          'G5110104'  : [{nivel: 4, pos: 44}],
          'VT070':      [{nivel: 1, pos: 45}],
          'VT071':      [{nivel: 2, pos: 46}],
          'I41104'    : [{nivel: 3, pos: 47}],
          'I41105'    : [{nivel: 3, pos: 48}],
          'I42'       : [{nivel: 3, pos: 49}],
          'VT072':      [{nivel: 2, pos: 50}],
          'G51201'    : [{nivel: 3, pos: 51}],
          'G51203'    : [{nivel: 3, pos: 52}],
          'G51302'    : [{nivel: 3, pos: 53}],
          'G52'       : [{nivel: 3, pos: 54}],
          'VT029'     : [{nivel: 1, pos: 55}],
        }
        if(objeto) return idsEst;
        return idsEst[id] ?? undefined;
    }
  }
  static idsCuentasP8(id: string, tipo: string, objeto?: boolean){
    switch(tipo){
      case 'bal':
        const idsBal = {
          'A1':         [{ nivel: 1, pos: 1}],
          'A101':       [{ nivel: 2, pos: 2}],
          'VT002':      [{ nivel: 2, pos: 3}],
          'VT008':      [{ nivel: 2, pos: 4}],
          'A103':       [{ nivel: 3, pos: 5}],
          'VT003':      [{ nivel: 4, pos: 6}],
          'VT004':      [{ nivel: 4, pos: 7}],
          'VT005':      [{ nivel: 4, pos: 8}],
          'VT006':      [{ nivel: 3, pos: 9}],
          'VT010':      [{ nivel: 2, pos: 10}],
          'A104':       [{ nivel: 3, pos: 11}],
          'VT009':      [{ nivel: 3, pos: 12}],
          'VT011':      [{ nivel: 2, pos: 13}],
          'A109':       [{ nivel: 3, pos: 14}],
          'A12020101':  [{ nivel: 3, pos: 15}],
          'A1204':      [{ nivel: 3, pos: 16}],
          'VT012':      [{ nivel: 2, pos: 17}],
          'A105':       [{ nivel: 3, pos: 18}],
          'VT013':      [{ nivel: 3, pos: 19}],
          'VT014':      [{ nivel: 2, pos: 20}],
          'A110':       [{ nivel: 3, pos: 21}],
          'A12030101':  [{ nivel: 3, pos: 22}],
          'VT019':      [{ nivel: 2, pos: 23}],
          'VT016':      [{ nivel: 3, pos: 24}],
          'A106':       [{ nivel: 4, pos: 25}],
          'VT015':      [{ nivel: 4, pos: 26}],
          'VT018':      [{ nivel: 3, pos: 27}],
          'A107':       [{ nivel: 4, pos: 28}],
          'VT017':      [{ nivel: 4, pos: 29}],
          'A111':       [{ nivel: 3, pos: 30}],
          'A112':       [{ nivel: 3, pos: 31}],
          'VT042':      [{ nivel: 3, pos: 32}],
          'A113':       [{ nivel: 4, pos: 33}],
          'A1213':      [{ nivel: 4, pos: 34}],
          'A1299':      [{ nivel: 3, pos: 35}],
          'P3':         [{ nivel: 1, pos: 36}],
          'P301':       [{ nivel: 2, pos: 37}],
          'VT020':      [{ nivel: 3, pos: 38}],
          'VT021':      [{ nivel: 3, pos: 39}],
          'VT022':      [{ nivel: 3, pos: 40}],
          'VT023':      [{ nivel: 3, pos: 41}],
          'VT024':      [{ nivel: 3, pos: 42}],
          'VT025':      [{ nivel: 3, pos: 43}],
          'P302':       [{ nivel: 2, pos: 44}],
          'VT026':      [{ nivel: 3, pos: 45}],
          'VT027':      [{ nivel: 3, pos: 46}],
          'VT028':      [{ nivel: 3, pos: 47}],
          'VT029':      [{ nivel: 3, pos: 48}],
          'VT030':      [{ nivel: 3, pos: 49}],
          'VT031':      [{ nivel: 3, pos: 50}],
          'P305':       [{ nivel: 2, pos: 51}],
          'P306':       [{ nivel: 2, pos: 52}],
          'P307':       [{ nivel: 2, pos: 53}],
          'P309':       [{ nivel: 2, pos: 54}],
          'P312':       [{ nivel: 2, pos: 55}],
          'P313':       [{ nivel: 2, pos: 56}],
          'P4':         [{ nivel: 2, pos: 57}],
          'VT040':      [{ nivel: 1, pos: 58}],
          'P501':       [{ nivel: 2, pos: 59}],
          'P501101':    [{ nivel: 3, pos: 60}],
          'P503':       [{ nivel: 2, pos: 61}],
          'P503101':    [{ nivel: 3, pos: 62}],
          'P503104':    [{ nivel: 3, pos: 63}],
          'P503199':    [{ nivel: 3, pos: 64}],
          'P504':       [{ nivel: 2, pos: 65}],
          'P504101':    [{ nivel: 3, pos: 66}],
          'P504102':    [{ nivel: 3, pos: 67}],
          'P504103':    [{ nivel: 3, pos: 68}],
          'P504104':    [{ nivel: 3, pos: 69}],
          'P504199':    [{ nivel: 3, pos: 70}],
          'P505':       [{ nivel: 2, pos: 71}],
          'P505101':    [{ nivel: 3, pos: 72}],
          'P505102':    [{ nivel: 3, pos: 73}],
          'P512':       [{ nivel: 2, pos: 74}],
          'P512101':    [{ nivel: 3, pos: 75}],
          'P512102':    [{ nivel: 3, pos: 76}],
          'VT039':      [{ nivel: 2, pos: 77}],
        }
        if(objeto) return idsBal;
        return idsBal[id] ?? undefined;
      case 'est':
        const idsEst = {
          'I601':        [{nivel: 2, pos: 1}],
          'I601101':     [{nivel: 3, pos: 2}],
          'I601102':     [{nivel: 3, pos: 3}],
          'I601103':     [{nivel: 3, pos: 4}],
          'G701':        [{nivel: 2, pos: 5}],
          'G701101':     [{nivel: 3, pos: 6}],
          'G701102':     [{nivel: 3, pos: 7}],
          'G701103':     [{nivel: 3, pos: 8}],
          'G701104':     [{nivel: 3, pos: 9}],
          'G701105':     [{nivel: 3, pos: 10}],
          'G701106':     [{nivel: 3, pos: 11}],
          'VT046':       [{nivel: 1, pos: 12}],
          'VT041':       [{nivel: 2, pos: 13}],
          'G705101':     [{nivel: 3, pos: 14}],
          'G705102':     [{nivel: 3, pos: 15}],
          'VT047':       [{nivel: 1, pos: 16}],
          'G706':        [{nivel: 2, pos: 17}],
          'G706101':     [{nivel: 3, pos: 18}],
          'G706102':     [{nivel: 3, pos: 19}],
          'G706103':     [{nivel: 3, pos: 20}],
          'G706104':     [{nivel: 3, pos: 21}],
          'G706105':     [{nivel: 3, pos: 22}],
          'G706106':     [{nivel: 3, pos: 23}],
          'G706107':     [{nivel: 3, pos: 24}],
          'G706108':     [{nivel: 3, pos: 25}],
          'G706109':     [{nivel: 3, pos: 26}],
          'G706110':     [{nivel: 3, pos: 27}],
          'G706199':     [{nivel: 3, pos: 28}],
          'VT048':       [{nivel: 1, pos: 29}],
          'VT049':       [{nivel: 2, pos: 30}],
          'I602':        [{nivel: 3, pos: 31}],
          'I602101':     [{nivel: 4, pos: 32}],
          'I602102':     [{nivel: 4, pos: 33}],
          'I602104':     [{nivel: 4, pos: 34}],
          'I602106':     [{nivel: 4, pos: 35}],
          'I603':        [{nivel: 3, pos: 36}],
          'I603101':     [{nivel: 4, pos: 37}],
          'I604':        [{nivel: 3, pos: 38}],
          'I604101':     [{nivel: 4, pos: 39}],
          'I604102':     [{nivel: 4, pos: 40}],
          'I604199':     [{nivel: 4, pos: 41}],
          'I605':        [{nivel: 3, pos: 42}],
          'I605101':     [{nivel: 4, pos: 43}],
          'I605102':     [{nivel: 4, pos: 44}],
          'I607':        [{nivel: 3, pos: 45}],
          'I607101':     [{nivel: 4, pos: 46}],
          'I607102':     [{nivel: 4, pos: 47}],
          'I607103':     [{nivel: 4, pos: 48}],
          'I607104':     [{nivel: 4, pos: 49}],
          'I607199':     [{nivel: 4, pos: 50}],
          'I608':        [{nivel: 3, pos: 51}],
          'I608101':     [{nivel: 4, pos: 52}],
          'I608102':     [{nivel: 4, pos: 53}],
          'I612':        [{nivel: 3, pos: 54}],
          'I612102':     [{nivel: 4, pos: 56}],
          'I612101':     [{nivel: 4, pos: 55}],
          'I613':        [{nivel: 3, pos: 57}],
          'I613101':     [{nivel: 4, pos: 58}],
          'I613102':     [{nivel: 4, pos: 59}],
          'I613103':     [{nivel: 4, pos: 60}],
          'I613104':     [{nivel: 4, pos: 61}],
          'I613105':     [{nivel: 4, pos: 62}],
          'VT050':       [{nivel: 2, pos: 63}],
          'G702':        [{nivel: 3, pos: 64}],
          'G702101':     [{nivel: 4, pos: 65}],
          'G703':        [{nivel: 3, pos: 66}],
          'G703101':     [{nivel: 4, pos: 67}],
          'G704':        [{nivel: 3, pos: 68}],
          'G704101':     [{nivel: 4, pos: 69}],
          'G704102':     [{nivel: 4, pos: 70}],
          'G704199':     [{nivel: 4, pos: 71}],
          'G708':        [{nivel: 3, pos: 72}],
          'G708101':     [{nivel: 4, pos: 73}],
          'G708102':     [{nivel: 4, pos: 74}],
          'G708103':     [{nivel: 4, pos: 75}],
          'G708104':     [{nivel: 4, pos: 76}],
          'G708199':     [{nivel: 4, pos: 77}],
          'VT051':       [{nivel: 3, pos: 78}],
          'G705103':     [{nivel: 4, pos: 79}],
          'G705104':     [{nivel: 4, pos: 80}],
          'G705105':     [{nivel: 4, pos: 81}],
          'G705106':     [{nivel: 4, pos: 82}],
          'G705107':     [{nivel: 4, pos: 83}],
          'G712':        [{nivel: 3, pos: 84}],
          'G712101':     [{nivel: 4, pos: 85}],
          'G712102':     [{nivel: 4, pos: 86}],
          'G713':        [{nivel: 3, pos: 87}],
          'G713101':     [{nivel: 4, pos: 88}],
          'G713102':     [{nivel: 4, pos: 89}],
          'G713103':     [{nivel: 4, pos: 90}],
          'G713104':     [{nivel: 4, pos: 91}],
          'VT052':       [{nivel: 1, pos: 92}],
          'G799101':     [{nivel: 2, pos: 93}],
          'VT039':       [{nivel: 1, pos: 94}],
        }
        if(objeto) return idsEst;
        return idsEst[id] ?? undefined;
    }
  }
  static idsCuentasP12(id: string, tipo:string, objeto?: boolean){
    switch(tipo){
      case 'bal': 
        const idsBal = {
          'VT05':       [{nivel: 1, pos: 1}],
          'A101':       [{nivel: 2, pos: 2}],
          'A102':       [{nivel: 2, pos: 3}],
          'VT01':       [{nivel: 2, pos: 4}],
          'VT22':       [{nivel: 3, pos: 5}], 
          'A10301':     [{nivel: 4, pos: 6}],
          'A10302':     [{nivel: 4, pos: 7}],
          'A10303':     [{nivel: 4, pos: 8}],
          'A10304':     [{nivel: 4, pos: 9}],
          'A1200102':   [{nivel: 3, pos: 10}],
          'A104':       [{nivel: 2, pos: 11}],
          'A110':       [{nivel: 2, pos: 12}],
          'A106':       [{nivel: 2, pos: 13}],
          'VT02':       [{nivel: 2, pos: 14}],
          'A108':       [{nivel: 3, pos: 15}],
          'A12002':     [{nivel: 3, pos: 16}],
          'VT03':       [{nivel: 2, pos: 17}],
          'A105':       [{nivel: 3, pos: 18}],
          'A109':       [{nivel: 3, pos: 19}],
          'VT10':       [{nivel: 1, pos: 20}],
          'VT06':       [{nivel: 2, pos: 21}],
          'P30101':     [{nivel: 3, pos: 22}],
          'P30103':     [{nivel: 3, pos: 23}],
          'P305':       [{nivel: 2, pos: 24}],
          'P30501':     [{nivel: 3, pos: 25}],
          'P30502':     [{nivel: 3, pos: 26}],
          'VT09':       [{nivel: 2, pos: 27}],
          'VT07':       [{nivel: 3, pos: 28}],
          'P302':       [{nivel: 3, pos: 29}],
          'P303':       [{nivel: 3, pos: 30}],
          'VT23':       [{nivel: 3, pos: 31}],
          'VT11':       [{nivel: 1, pos: 32}],
          'P501':       [{nivel: 2, pos: 33}],
          'P502':       [{nivel: 2, pos: 34}],
          'P503':       [{nivel: 2, pos: 35}],
          'P504':       [{nivel: 2, pos: 36}],
        }
        if(objeto) return idsBal;
        return idsBal[id] ?? undefined;
      case 'est': 
        const idsEst = {
          'VT12':       [{nivel: 2, pos:1}],
          'I6010103':   [{nivel: 3, pos:2}],
          'I60102':     [{nivel: 3, pos:3}],
          'I602':       [{nivel: 3, pos:4}],
          'I6010102':   [{nivel: 2, pos:5}],
          'G701':       [{nivel: 2, pos:6}],
          'VT13':       [{nivel: 1, pos:7}],
          'G703':       [{nivel: 2, pos:8}],
          'VT14':       [{nivel: 1, pos:9}],
          'G704':       [{nivel: 2, pos:10}],
          'G70401':     [{nivel: 3, pos:11}],
          'G70402':     [{nivel: 3, pos:12}],
          'G70403':     [{nivel: 3, pos:13}],
          'G70404':     [{nivel: 3, pos:14}],
          'G70405':     [{nivel: 3, pos:15}],
          'G70406':     [{nivel: 3, pos:16}],
          'G70407':     [{nivel: 3, pos:17}],
          'G70408':     [{nivel: 3, pos:18}],
          'G70409':     [{nivel: 3, pos:19}],
          'G70410':     [{nivel: 3, pos:20}],
          'G70411':     [{nivel: 3, pos:21}],
          'VT15':       [{nivel: 1, pos:22}],
          'VT16':       [{nivel: 2, pos:23}],
          'I6010101':   [{nivel: 3, pos:24}],
          'I60103':     [{nivel: 3, pos:25}],
          'I603':       [{nivel: 3, pos:26}],
          'I604':       [{nivel: 3, pos:27}],
          'I605':       [{nivel: 3, pos:28}],
          'I606':       [{nivel: 3, pos:29}],
          'I607':       [{nivel: 3, pos:30}],
          'VT17':       [{nivel: 2, pos:31}],
          'G702':       [{nivel: 3, pos:32}],
          'G705':       [{nivel: 3, pos:33}],
          'G706':       [{nivel: 3, pos:34}],
          'G707':       [{nivel: 3, pos:35}],
          'G708':       [{nivel: 3, pos:36}],
          'VT18':       [{nivel: 1, pos:37}],
          'G709':       [{nivel: 2, pos:38}],
          'VT19':       [{nivel: 1, pos:39}],
        }
        if(objeto) return idsEst;
        return idsEst[id] ?? undefined;
    }
  }
  static idsCuentasP13(id:string, tipo:string, objeto?: boolean){
    switch(tipo){
      case 'bal': 
        const idsBal = {
          'A101': [{nivel: 1, pos:1}],
          'VT20': [{nivel: 2, pos:2}],
          'VT21': [{nivel: 2, pos:3}],
          'VT22': [{nivel: 2, pos:4}],

          'VT23': [{nivel: 1, pos:5}],
          'A102': [{nivel: 2, pos:6}],
          'VT24': [{nivel: 3, pos:7}],
          'VT25': [{nivel: 3, pos:8}],
          'VT26': [{nivel: 3, pos:9}],
          'P207103': [{nivel: 2, pos:10}],
          'VT27': [{nivel: 2, pos:11}],

          'VT28': [{nivel: 1, pos:12}],
          'VT29': [{nivel: 2, pos:13}],
          'VT30': [{nivel: 2, pos:14}],
          'VT31': [{nivel: 2, pos:15}],
          'VT32': [{nivel: 2, pos:16}],
          'A103': [{nivel: 2, pos:17}],
          'P207101': [{nivel: 2, pos:18}],

          'VT33': [{nivel: 1, pos:19}],
          'VT34': [{nivel: 2, pos:20}],
          'P207112': [{nivel: 2, pos:21}],
          'VT35': [{nivel: 2, pos:22}],
          'VT36': [{nivel: 2, pos:23}],
          'VT37': [{nivel: 2, pos:24}],
          'P207102': [{nivel: 2, pos:25}],
          'A104107': [{nivel: 2, pos:26}],

          'A105': [{nivel: 1, pos:27}],
          'VT38': [{nivel: 2, pos:28}],
          'VT39': [{nivel: 2, pos:29}],

          'VT04': [{nivel: 1, pos:30}],
          'A106101': [{nivel: 2, pos:31}],
          'A106102': [{nivel: 2, pos:32}],
          'A106': [{nivel: 2, pos:33}],
          'P207107': [{nivel: 2, pos:34}],

          'VT06': [{nivel: 1, pos:35}],
          'A10710101': [{nivel: 2, pos:36}],
          'A10710102': [{nivel: 2, pos:37}],
          'A10710103': [{nivel: 2, pos:38}],
          'A107102': [{nivel: 2, pos:39}],
          'A107103': [{nivel: 2, pos:40}],
          'A107104': [{nivel: 2, pos:41}],
          'A107105': [{nivel: 2, pos:42}],
          'A107': [{nivel: 2, pos:43}],
          'P207104': [{nivel: 3, pos:44}],
          'P20710501': [{nivel: 3, pos:45}],
          'P207106': [{nivel: 3, pos:46}],
          'P207108': [{nivel: 3, pos:47}],//no se si aqui es 3 o 2
          'P207109': [{nivel: 3, pos:48}],
          'P20710502': [{nivel: 3, pos:49}],
          'VT05': [{nivel: 2, pos:50}],

          'A108': [{nivel: 1, pos:51}],
          'VT40': [{nivel: 2, pos:52}],
          'VT41': [{nivel: 2, pos:53}],
          'A108103': [{nivel: 2, pos:54}],
          'A108104': [{nivel: 2, pos:55}],
          'VT42': [{nivel: 2, pos:56}],

          'VT07': [{nivel: 1, pos:57}],
          'A109101': [{nivel: 2, pos:58}],
          'P207110': [{nivel: 2, pos:59}],

          'VT43': [{nivel: 1, pos:60}],
          'VT44': [{nivel: 2, pos:61}],
          'VT45': [{nivel: 2, pos:62}],
          'A110': [{nivel: 2, pos:63}],
          'P207111': [{nivel: 2, pos:64}],

          'VT46': [{nivel: 1, pos:65}],

          'P201': [{nivel: 1, pos:66}],
          'VT47': [{nivel: 2, pos:67}],
          'VT48': [{nivel: 2, pos:68}],
          'VT49': [{nivel: 2, pos:69}],
          'P201110': [{nivel: 2, pos:70}],
          'VT50': [{nivel: 2, pos:71}],
          'VT51': [{nivel: 2, pos:72}],
          'VT52': [{nivel: 2, pos:73}],
          'VT53': [{nivel: 2, pos:74}],

          'P202': [{nivel: 1, pos:75}],
          'VT54': [{nivel: 2, pos:76}],
          'VT55': [{nivel: 2, pos:77}],

          'P203': [{nivel: 1, pos:78}],
          'VT56': [{nivel: 2, pos:79}],

          'P204': [{nivel: 1, pos:80}],
          'VT57': [{nivel: 2, pos:81}],
          'VT58': [{nivel: 2, pos:82}],

          'P205': [{nivel: 1, pos:83}],
          'VT59': [{nivel: 2, pos:84}],
          'VT60': [{nivel: 2, pos:85}],

          'P206': [{nivel: 1, pos:86}],
          'VT61': [{nivel: 2, pos:87}],
          'VT62': [{nivel: 2, pos:88}],
          'VT63': [{nivel: 2, pos:89}],
          'VT64': [{nivel: 2, pos:90}],

          'P208': [{nivel: 1, pos:91}],
          'P208102': [{nivel: 2, pos:92}],
          'P208103': [{nivel: 2, pos:93}],

          'VT65': [{nivel: 1, pos:94}],

          'P301': [{nivel: 1, pos:95}],
          'P301101': [{nivel: 2, pos:96}],
          'P301103': [{nivel: 2, pos:97}],

          'P302': [{nivel: 1, pos:98}],
          'P302101': [{nivel: 2, pos:99}],
          'P302102': [{nivel: 2, pos:100}],
          'P302105': [{nivel: 2, pos:101}],
          'P302107': [{nivel: 2, pos:102}],
          'P302108': [{nivel: 2, pos:103}],
          'P302109': [{nivel: 2, pos:104}],

          'P3': [{nivel: 1, pos:105}],

          'VT66': [{nivel: 1, pos:106}]
        }
        if(objeto) return idsBal;
        return idsBal[id] ?? undefined;
      case 'ER':
        const idsER = {
          'I5': [{nivel: 1, pos: 1}], // INGRESOS
          'I501': [{nivel: 2, pos: 2}], // PRODUCTOS FINANCIEROS
          'I5011': [{nivel: 3, pos: 3}], // MONEDA NACIONAL
          'I501101': [{nivel: 4, pos: 4}], // INTERESES
          'I50110101': [{nivel: 5, pos: 5}], // Sobre Disponibilidades
          'I5011010101': [{nivel: 6, pos: 6}], // Sobre Depósitos a la Vista
          'I5011010102': [{nivel: 6, pos: 7}], // Sobre Depósitos de Ahorros
          'I50110102': [{nivel: 5, pos: 8}], // Sobre Inversiones
          'I5011010201': [{nivel: 6, pos: 9}], // Valores Oficiales
          'I501101020101': [{nivel: 7, pos: 10}], // Bonos
          'I501101020102': [{nivel: 7, pos: 11}], // Letras
          'I5011010202': [{nivel: 6, pos: 12}], // Acciones y Participaciones
          'I5011010203': [{nivel: 6, pos: 13}], // Valores Diversos
          'I501101020301': [{nivel: 7, pos: 14}], // Bursátiles
          'I501101020302': [{nivel: 7, pos: 15}], // Depósitos a Plazo
          'I501101020399': [{nivel: 7, pos: 16}], // Inversiones en Otras Instituciones
          'I50110103': [{nivel: 5, pos: 17}], // Sobre Cartera de Préstamos
          'I5011010305': [{nivel: 6, pos: 18}], // Préstamos Fiduciarios
          'I501101030501': [{nivel: 7, pos: 19}], // Agropecuarios
          'I501101030502': [{nivel: 7, pos: 20}], // Microcrédito
          'I501101030503': [{nivel: 7, pos: 21}], // Comerciales
          'I501101030504': [{nivel: 7, pos: 22}], // Consumo
          'I501101030505': [{nivel: 7, pos: 23}], // Créditos con Destino de Vivienda
          'I5011010306': [{nivel: 6, pos: 24}], // Préstamos Automáticos
          'I501101030601': [{nivel: 7, pos: 25}], // Agropecuarios
          'I501101030602': [{nivel: 7, pos: 26}], // Microcrédito
          'I501101030603': [{nivel: 7, pos: 27}], // Comerciales
          'I501101030604': [{nivel: 7, pos: 28}], // Consumo
          'I501101030605': [{nivel: 7, pos: 29}], // Créditos con Destino de Vivienda
          'I5011010307': [{nivel: 6, pos: 30}], // Préstamos Prendarios
          'I501101030701': [{nivel: 7, pos: 31}], // Agropecuarios
          'I501101030702': [{nivel: 7, pos: 32}], // Microcrédito
          'I501101030703': [{nivel: 7, pos: 33}], // Comerciales
          'I501101030704': [{nivel: 7, pos: 34}], // Consumo
          'I501101030705': [{nivel: 7, pos: 35}], // Créditos con Destino de Vivienda
          'I5011010310': [{nivel: 6, pos: 36}], // Préstamos Hipotecarios
          'I501101031001': [{nivel: 7, pos: 37}], // Agropecuarios
          'I501101031002': [{nivel: 7, pos: 38}], // Microcrédito
          'I501101031003': [{nivel: 7, pos: 39}], // Comerciales
          'I501101031004': [{nivel: 7, pos: 40}], // Consumo
          'I501101031005': [{nivel: 7, pos: 41}], // Créditos para Vivienda
          'I5011010311': [{nivel: 6, pos: 42}], // Préstamos Con Garantía Mixta
          'I501101031101': [{nivel: 7, pos: 43}], // Agropecuarios
          'I501101031102': [{nivel: 7, pos: 44}], // Microcrédito
          'I501101031103': [{nivel: 7, pos: 45}], // Comerciales
          'I501101031104': [{nivel: 7, pos: 46}], // Consumo
          'I501101031105': [{nivel: 7, pos: 47}], // Créditos con Destino de Vivienda
          'I5011010312': [{nivel: 6, pos: 48}], // Préstamos Refinanciados
          'I501101031201': [{nivel: 7, pos: 49}], // Agropecuarios
          'I501101031202': [{nivel: 7, pos: 50}], // Microcrédito
          'I501101031203': [{nivel: 7, pos: 51}], // Comerciales
          'I501101031204': [{nivel: 7, pos: 52}], // Consumo
          'I501101031205': [{nivel: 7, pos: 53}], // Créditos con Destino de Vivienda
          'I5011010313': [{nivel: 6, pos: 54}], // Préstamos Readecuados
          'I501101031301': [{nivel: 7, pos: 55}], // Agropecuarios
          'I501101031302': [{nivel: 7, pos: 56}], // Microcrédito
          'I501101031303': [{nivel: 7, pos: 57}], // Comerciales
          'I501101031304': [{nivel: 7, pos: 58}], // Consumo
          'I501101031305': [{nivel: 7, pos: 59}], // Créditos con Destino de Vivienda
          'I5011010314': [{nivel: 6, pos: 60}], // Préstamos con Garantía Recíproca Emitida por la SA-FGR
          'I5011010315': [{nivel: 6, pos: 61}], // Intereses Moratorios
          'I5011010317': [{nivel: 6, pos: 62}], // Préstamos a Otras Instituciones
          'I501101031701': [{nivel: 7, pos: 63}], // Cooperativas de Ahorro y Crédito
          'I501101031799': [{nivel: 7, pos: 64}], // Otras
          'I5011010318': [{nivel: 6, pos: 65}], // Préstamos con Fondos Propios Redescontados
          'I501101031801': [{nivel: 7, pos: 66}], // BANHPROVI
          'I501101031802': [{nivel: 7, pos: 67}], // RAP
          'I501101031803': [{nivel: 7, pos: 68}], // BCIE
          'I501101031804': [{nivel: 7, pos: 69}], // BID
          'I501101031899': [{nivel: 7, pos: 70}], // Otros
          'I5011010325': [{nivel: 6, pos: 71}], // Préstamos Refinanciados por Emergencia Sanitaria COVID-19
          'I501101032501': [{nivel: 7, pos: 72}], // Agropecuarios
          'I501101032502': [{nivel: 7, pos: 73}], // Microcrédito
          'I501101032503': [{nivel: 7, pos: 74}], // Comerciales
          'I501101032504': [{nivel: 7, pos: 75}], // Consumo
          'I501101032505': [{nivel: 7, pos: 76}], // Créditos con Destino de Vivienda
          'I5011010326': [{nivel: 6, pos: 77}], // Préstamos Readecuados por Emergencia Sanitaria COVID-19
          'I501101032601': [{nivel: 7, pos: 78}], // Agropecuarios
          'I501101032602': [{nivel: 7, pos: 79}], // Microcrédito
          'I501101032603': [{nivel: 7, pos: 80}], // Comerciales
          'I501101032604': [{nivel: 7, pos: 81}], // Consumo
          'I501101032605': [{nivel: 7, pos: 82}], // Créditos con Destino de Vivienda
          'I501103': [{nivel: 4, pos: 83}], // COMISIONES
          'I50110301': [{nivel: 5, pos: 84}], // Sobre Cartera Crediticia
          'I5011030101': [{nivel: 6, pos: 85}], // Comisiones Devengadas
          'I50110399': [{nivel: 5, pos: 86}], // Comisiones Varias
          'I501105': [{nivel: 4, pos: 87}], // OTROS PRODUCTOS
          'I50110501': [{nivel: 5, pos: 88}], // Fluctuaciones de Tipo de Cambio
          'I5011050101': [{nivel: 6, pos: 89}], // Activos
          'I5011050102': [{nivel: 6, pos: 90}], // Pasivos
          'I501199': [{nivel: 4, pos: 91}], // Otros Ingresos Financieros
          'I50119999': [{nivel: 5, pos: 92}], // Otros Ingresos
          'I5012': [{nivel: 3, pos: 93}], // MONEDA EXTRANJERA
          'I501201': [{nivel: 4, pos: 94}], // INTERESES
          'I50120101': [{nivel: 5, pos: 95}], // Sobre Disponibilidades
          'I5012010101': [{nivel: 6, pos: 96}], // Sobre Depósitos a la Vista
          'I5012010102': [{nivel: 6, pos: 97}], // Sobre Depósitos de Ahorros
          'I50120102': [{nivel: 5, pos: 98}], // Sobre Inversiones
          'I5012010201': [{nivel: 6, pos: 99}], // Valores Oficiales
          'I501201020101': [{nivel: 7, pos: 100}], // Bonos
          'I501201020102': [{nivel: 7, pos: 101}], // Letras
          'I5012010202': [{nivel: 6, pos: 102}], // Acciones y Participaciones
          'I5012010203': [{nivel: 6, pos: 103}], // Valores Diversos
          'I501201020301': [{nivel: 7, pos: 104}], // Bursátiles
          'I501201020302': [{nivel: 7, pos: 105}], // Depósitos a Plazo
          'I501201020399': [{nivel: 7, pos: 106}], // Inversiones en Otras Instituciones
          'I50120103': [{nivel: 5, pos: 107}], // Sobre Cartera de Préstamos
          'I5012010305': [{nivel: 6, pos: 108}], // Préstamos Fiduciarios
          'I501201030501': [{nivel: 7, pos: 109}], // Agropecuarios
          'I501201030502': [{nivel: 7, pos: 110}], // Microcrédito
          'I501201030503': [{nivel: 7, pos: 111}], // Comerciales
          'I501201030504': [{nivel: 7, pos: 112}], // Consumo
          'I501201030505': [{nivel: 7, pos: 113}], // Créditos con Destino de Vivienda
          'I5012010306': [{nivel: 6, pos: 114}], // Préstamos Automáticos
          'I501201030601': [{nivel: 7, pos: 115}], // Agropecuarios
          'I501201030602': [{nivel: 7, pos: 116}], // Microcrédito
          'I501201030603': [{nivel: 7, pos: 117}], // Comerciales
          'I501201030604': [{nivel: 7, pos: 118}], // Consumo
          'I501201030605': [{nivel: 7, pos: 119}], // Créditos con Destino de Vivienda
          'I5012010307': [{nivel: 6, pos: 120}], // Préstamos Prendarios
          'I501201030701': [{nivel: 7, pos: 121}], // Agropecuarios
          'I501201030702': [{nivel: 7, pos: 122}], // Microcrédito
          'I501201030703': [{nivel: 7, pos: 123}], // Comerciales
          'I501201030704': [{nivel: 7, pos: 124}], // Consumo
          'I501201030705': [{nivel: 7, pos: 125}], // Créditos con Destino de Vivienda
          'I5012010310': [{nivel: 6, pos: 126}], // Préstamos Hipotecarios
          'I501201031001': [{nivel: 7, pos: 127}], // Agropecuarios
          'I501201031002': [{nivel: 7, pos: 128}], // Microcrédito
          'I501201031003': [{nivel: 7, pos: 129}], // Comerciales
          'I501201031004': [{nivel: 7, pos: 130}], // Consumo
          'I501201031005': [{nivel: 7, pos: 131}], // Créditos para Vivienda
          'I5012010311': [{nivel: 6, pos: 132}], // Préstamos Con Garantía Mixta
          'I501201031101': [{nivel: 7, pos: 133}], // Agropecuarios
          'I501201031102': [{nivel: 7, pos: 134}], // Microcrédito
          'I501201031103': [{nivel: 7, pos: 135}], // Comerciales
          'I501201031104': [{nivel: 7, pos: 136}], // Consumo
          'I501201031105': [{nivel: 7, pos: 137}], // Créditos con Destino de Vivienda
          'I5012010312': [{nivel: 6, pos: 138}], // Préstamos Refinanciados
          'I501201031201': [{nivel: 7, pos: 139}], // Agropecuarios
          'I501201031202': [{nivel: 7, pos: 140}], // Microcrédito
          'I501201031203': [{nivel: 7, pos: 141}], // Comerciales
          'I501201031204': [{nivel: 7, pos: 142}], // Consumo
          'I501201031205': [{nivel: 7, pos: 143}], // Créditos con Destino de Vivienda
          'I5012010313': [{nivel: 6, pos: 144}], // Préstamos Readecuados
          'I501201031301': [{nivel: 7, pos: 145}], // Agropecuarios
          'I501201031302': [{nivel: 7, pos: 146}], // Microcrédito
          'I501201031303': [{nivel: 7, pos: 147}], // Comerciales
          'I501201031304': [{nivel: 7, pos: 148}], // Consumo
          'I501201031305': [{nivel: 7, pos: 149}], // Créditos con Destino de Vivienda
          'I5012010314': [{nivel: 6, pos: 150}], // Préstamos con Garantía Recíproca Emitida por la SA-FGR
          'I5012010317': [{nivel: 6, pos: 151}], // Préstamos a Otras Instituciones
          'I501201031701': [{nivel: 7, pos: 152}], // Cooperativas de Ahorro y Crédito
          'I501201031799': [{nivel: 7, pos: 153}], // Otras
          'I5012010318': [{nivel: 6, pos: 154}], // Préstamos con Fondos Redescontados
          'I501201031801': [{nivel: 7, pos: 155}], // BANHPROVI
          'I501201031802': [{nivel: 7, pos: 156}], // RAP
          'I501201031803': [{nivel: 7, pos: 157}], // BCIE
          'I501201031804': [{nivel: 7, pos: 158}], // BID
          'I501201031899': [{nivel: 7, pos: 159}], // Otros
          'I5012010325': [{nivel: 6, pos: 160}], // Préstamos Refinanciados por Emergencia Sanitaria COVID-19
          'I501201032501': [{nivel: 7, pos: 161}], // Agropecuarios
          'I501201032502': [{nivel: 7, pos: 162}], // Microcrédito
          'I501201032503': [{nivel: 7, pos: 163}], // Comerciales
          'I501201032504': [{nivel: 7, pos: 164}], // Consumo
          'I501201032505': [{nivel: 7, pos: 165}], // Créditos con Destino de Vivienda
          'I5012010326': [{nivel: 6, pos: 166}], // Préstamos Readecuados por Emergencia Sanitaria COVID-19
          'I501201032601': [{nivel: 7, pos: 167}], // Agropecuarios
          'I501201032602': [{nivel: 7, pos: 168}], // Microcrédito
          'I501201032603': [{nivel: 7, pos: 169}], // Comerciales
          'I501201032604': [{nivel: 7, pos: 170}], // Consumo
          'I501201032605': [{nivel: 7, pos: 171}], // Créditos con Destino de Vivienda
          'I501203': [{nivel: 4, pos: 172}], // COMISIONES
          'I50120301': [{nivel: 5, pos: 173}], // Sobre Cartera Crediticia
          'I5012030101': [{nivel: 6, pos: 174}], // Comisiones Devengadas
          'I50120399': [{nivel: 5, pos: 175}], // Comisiones Varias
          'I501299': [{nivel: 4, pos: 176}], // Otros Ingresos Financieros
          'I50129999': [{nivel: 5, pos: 177}], // Otros Ingresos
          'I502': [{nivel: 2, pos: 178}], // PRODUCTOS POR SERVICIOS
          'I5021': [{nivel: 3, pos: 179}], // MONEDA NACIONAL
          'I502101': [{nivel: 4, pos: 180}], // COMISIONES
          'I50210101': [{nivel: 5, pos: 181}], // Remesas
          'I50210102': [{nivel: 5, pos: 182}], // Cobranzas por Cuenta Ajena
          'I50210199': [{nivel: 5, pos: 183}], // Otras Comisiones
          'I502102': [{nivel: 4, pos: 184}], // ARRENDAMIENTOS
          'I50210201': [{nivel: 5, pos: 185}], // Alquiler de Activos Fijos
          'I502103': [{nivel: 4, pos: 186}], // OTROS INGRESOS POR SERVICIOS
          'I50210301': [{nivel: 5, pos: 187}], // Cuota de Ingreso de Afiliados
          'I50210399': [{nivel: 5, pos: 188}], // OTROS INGRESOS POR SERVICIOS
          'I5022': [{nivel: 3, pos: 189}], // MONEDA EXTRANJERA
          'I502201': [{nivel: 4, pos: 190}], // COMISIONES
          'I50220101': [{nivel: 5, pos: 191}], // Remesas
          'I50220102': [{nivel: 5, pos: 192}], // Cobranzas por Cuenta Ajena
          'I50220199': [{nivel: 5, pos: 193}], // Otras Comisiones
          'I503': [{nivel: 2, pos: 194}], // OTROS PRODUCTOS
          'I5031': [{nivel: 3, pos: 195}], // MONEDA NACIONAL
          'I503101': [{nivel: 4, pos: 196}], // Venta de Activos Eventuales
          'I503102': [{nivel: 4, pos: 197}], // Ventas de Bienes Muebles e Inmuebles
          'I503103': [{nivel: 4, pos: 198}], // Donaciones Recibidas
          'I503104': [{nivel: 4, pos: 199}], // Intereses Cobrados sobre Operaciones Readecuadas
          'I503198': [{nivel: 4, pos: 200}], // Donaciones Recibidas
          'I503199': [{nivel: 4, pos: 201}], // OTROS PRODUCTOS
          'I50319999': [{nivel: 5, pos: 202}], // Otros
          'I599': [{nivel: 2, pos: 203}], // INGRESOS DE EJERCICIOS ANTERIORES
          'I5991': [{nivel: 3, pos: 204}], // MONEDA NACIONAL
          'I599102': [{nivel: 4, pos: 205}], // Recuperaciones
          'I599199': [{nivel: 4, pos: 206}], // Otros Ingresos de Ejercicios Anteriores
          'I59919999': [{nivel: 5, pos: 207}], // Otros
          'G6': [{nivel: 1, pos: 208}], // GASTOS
          'G601': [{nivel: 2, pos: 209}], // GASTOS FINANCIEROS
          'G6011': [{nivel: 3, pos: 210}], // MONEDA NACIONAL
          'G601101': [{nivel: 4, pos: 211}], // INTERESES
          'G60110102': [{nivel: 5, pos: 212}], // DEPÓSITOS DE AHORRO
          'G60110103': [{nivel: 5, pos: 213}], // Depósitos a Plazo
          'G60110108': [{nivel: 5, pos: 214}], // Préstamos de Instituciones Financieras Nacionales
          'G60110113': [{nivel: 5, pos: 215}], // Préstamos Redescontados
          'G60110114': [{nivel: 5, pos: 216}], // Préstamos de Instituciones Internacionales
          'G60110115': [{nivel: 5, pos: 217}], // APORTACIONES
          'G60110199': [{nivel: 5, pos: 218}], // Otras Obligaciones
          'G601102': [{nivel: 4, pos: 219}], // COMISIONES
          'G60110202': [{nivel: 5, pos: 220}], // Préstamos de Instituciones Financieras Nacionales
          'G60110296': [{nivel: 5, pos: 221}], // Préstamos de Instituciones Internacionales
          'G60110299': [{nivel: 5, pos: 222}], // Otras Comisiones
          'G601105': [{nivel: 4, pos: 223}], // OTROS GASTOS
          'G60110501': [{nivel: 5, pos: 224}], // Fluctuaciones de Tipo de Cambio
          'G6011050101': [{nivel: 6, pos: 225}], // Activos
          'G6011050102': [{nivel: 6, pos: 226}], // Pasivos
          'G601199': [{nivel: 4, pos: 227}], // OTROS GASTOS FINANCIEROS
          'G60119999': [{nivel: 5, pos: 228}], // OTROS GASTOS
          'G6012': [{nivel: 3, pos: 229}], // MONEDA EXTRANJERA
          'G601201': [{nivel: 4, pos: 230}], // INTERESES
          'G60120102': [{nivel: 5, pos: 231}], // DEPÓSITOS DE AHORRO
          'G60120103': [{nivel: 5, pos: 232}], // Depósitos a Plazo
          'G60120108': [{nivel: 5, pos: 233}], // Préstamos de Instituciones Financieras Nacionales
          'G60120113': [{nivel: 5, pos: 234}], // Préstamos Redescontados
          'G60120114': [{nivel: 5, pos: 235}], // Préstamos de Instituciones Internacionales
          'G60120115': [{nivel: 5, pos: 236}], // APORTACIONES
          'G60120199': [{nivel: 5, pos: 237}], // Otras Obligaciones
          'G601202': [{nivel: 4, pos: 238}], // COMISIONES
          'G60120202': [{nivel: 5, pos: 239}], // Préstamos de Instituciones Financieras Nacionales
          'G60120296': [{nivel: 5, pos: 240}], // Préstamos de Instituciones Internacionales
          'G60120299': [{nivel: 5, pos: 241}], // Otras Comisiones
          'G602': [{nivel: 2, pos: 242}], // GASTOS DE ADMINISTRACION
          'G6021': [{nivel: 3, pos: 243}], // MONEDA NACIONAL
          'G602101': [{nivel: 4, pos: 244}], // DIRECTIVOS
          'G60210101': [{nivel: 5, pos: 245}], // Asamblea General
          'G6021010101': [{nivel: 6, pos: 246}], // Convocatorias
          'G6021010102': [{nivel: 6, pos: 247}], // Memorias e Informes
          'G6021010103': [{nivel: 6, pos: 248}], // Alimentación
          'G6021010104': [{nivel: 6, pos: 249}], // Premios y Obsequios
          'G6021010105': [{nivel: 6, pos: 250}], // Alquileres y Arreglo de local
          'G6021010106': [{nivel: 6, pos: 251}], // Transporte
          'G6021010199': [{nivel: 6, pos: 252}], // Otros
          'G60210102': [{nivel: 5, pos: 253}], // Junta Directiva
          'G6021010201': [{nivel: 6, pos: 254}], // Dietas
          'G6021010202': [{nivel: 6, pos: 255}], // Gastos de Representación
          'G6021010203': [{nivel: 6, pos: 256}], // Transporte
          'G6021010204': [{nivel: 6, pos: 257}], // Viáticos
          'G6021010299': [{nivel: 6, pos: 258}], // Otros
          'G60210103': [{nivel: 5, pos: 259}], // Junta de Vigilancia
          'G6021010301': [{nivel: 6, pos: 260}], // Dietas
          'G6021010302': [{nivel: 6, pos: 261}], // Gastos de Representación
          'G6021010303': [{nivel: 6, pos: 262}], // Transporte
          'G6021010304': [{nivel: 6, pos: 263}], // Viáticos
          'G6021010399': [{nivel: 6, pos: 264}], // Otros
          'G60210104': [{nivel: 5, pos: 265}], // Comités
          'G602102': [{nivel: 4, pos: 266}], // Funcionarios y Empleados
          'G60210201': [{nivel: 5, pos: 267}], // Sueldos Ordinarios
          'G60210202': [{nivel: 5, pos: 268}], // Sueldos Extraordinarios
          'G60210203': [{nivel: 5, pos: 269}], // Compensaciones Sociales
          'G6021020301': [{nivel: 6, pos: 270}], // Aguinaldos
          'G6021020302': [{nivel: 6, pos: 271}], // Décimo Cuarto Mes
          'G6021020303': [{nivel: 6, pos: 272}], // Vacaciones
          'G6021020304': [{nivel: 6, pos: 273}], // Incentivos del Personal
          'G60210205': [{nivel: 5, pos: 274}], // Bonificaciones
          'G60210206': [{nivel: 5, pos: 275}], // Gastos de Representación
          'G60210207': [{nivel: 5, pos: 276}], // Capacitación y Entrenamiento
          'G60210208': [{nivel: 5, pos: 277}], // Gastos de Viaje
          'G6021020801': [{nivel: 6, pos: 278}], // Transporte
          'G6021020802': [{nivel: 6, pos: 279}], // Viáticos
          'G6021020803': [{nivel: 6, pos: 280}], // Otros Gastos de Viaje
          'G60210209': [{nivel: 5, pos: 281}], // Aportes Patronales
          'G6021020901': [{nivel: 6, pos: 282}], // Seguro Social
          'G6021020902': [{nivel: 6, pos: 283}], // INFOP
          'G6021020903': [{nivel: 6, pos: 284}], // RAP
          'G60210210': [{nivel: 5, pos: 285}], // Prestaciones Sociales
          'G60210211': [{nivel: 5, pos: 286}], // Seguro de Vida de Ejecutivos y Empleados
          'G60210212': [{nivel: 5, pos: 287}], // Seguro Médico de Ejecutivos y Empleados
          'G60210213': [{nivel: 5, pos: 288}], // Seguro de Plan de Retiro
          'G60210299': [{nivel: 5, pos: 289}], // Otros
          'G602103': [{nivel: 4, pos: 290}], // IMPUESTOS Y CONTRIBUCIONES
          'G60210301': [{nivel: 5, pos: 291}], // Impuestos y Contribuciones Municipales
          'G60210302': [{nivel: 5, pos: 292}], // Impuestos y Contribuciones Estatales
          'G60210303': [{nivel: 5, pos: 293}], // Contribución Especial de Seguridad Poblacional
          'G602104': [{nivel: 4, pos: 294}], // HONORARIOS PROFESIONALES
          'G60210401': [{nivel: 5, pos: 295}], // Auditoría Externa
          'G60210402': [{nivel: 5, pos: 296}], // Asesoría Jurídica
          'G60210403': [{nivel: 5, pos: 297}], // Asesoría Técnica
          'G602105': [{nivel: 4, pos: 298}], // ARRENDAMIENTOS
          'G60210501': [{nivel: 5, pos: 299}], // INMUEBLES
          'G60210502': [{nivel: 5, pos: 300}], // MOBILIARIO Y EQUIPO DE OFICINA
          'G60210503': [{nivel: 5, pos: 301}], // Sistema de Informática
          'G60210505': [{nivel: 5, pos: 302}], // Vehículos
          'G60210599': [{nivel: 5, pos: 303}], // Otros
          'G602106': [{nivel: 4, pos: 304}], // REPARACIÓN, USO Y MANTENIMIENTO
          'G60210601': [{nivel: 5, pos: 305}], // INMUEBLES
          'G60210602': [{nivel: 5, pos: 306}], // MOBILIARIO Y EQUIPO DE OFICINA
          'G60210603': [{nivel: 5, pos: 307}], // Sistema de Informática
          'G60210605': [{nivel: 5, pos: 308}], // Vehículos
          'G60210606': [{nivel: 5, pos: 309}], // Edificios Arrendados
          'G60210699': [{nivel: 5, pos: 310}], // Otros
          'G602107': [{nivel: 4, pos: 311}], // SEGURIDAD Y VIGILANCIA
          'G60210701': [{nivel: 5, pos: 312}], // SEGURIDAD Y VIGILANCIA
          'G602108': [{nivel: 4, pos: 313}], // MERCADEO
          'G60210801': [{nivel: 5, pos: 314}], // Estudios de Mercado
          'G60210802': [{nivel: 5, pos: 315}], // Promoción y Publicidad
          'G60210899': [{nivel: 5, pos: 316}], // Otros
          'G602109': [{nivel: 4, pos: 317}], // AMORTIZACION DE PRIMAS DE SEGURO
          'G60210901': [{nivel: 5, pos: 318}], // Seguro de Vehículos
          'G60210902': [{nivel: 5, pos: 319}], // Seguro de Mobiliario, Equipo y Edificio
          'G60210903': [{nivel: 5, pos: 320}], // Seguro de Valores
          'G60210904': [{nivel: 5, pos: 321}], // Seguros y Fianzas de Fidelidad
          'G60210905': [{nivel: 5, pos: 322}], // Seguro de Cartera de Préstamos
          'G60210906': [{nivel: 5, pos: 323}], // Seguro de Vida Ahorro
          'G60210999': [{nivel: 5, pos: 324}], // Otros
          'G602110': [{nivel: 4, pos: 325}], // DEPRECIACIONES Y AMORTIZACIONES
          'G60211001': [{nivel: 5, pos: 326}], // Depreciaciones
          'G6021100101': [{nivel: 6, pos: 327}], // Edificio
          'G6021100102': [{nivel: 6, pos: 328}], // Mobiliario y Equipo
          'G6021100103': [{nivel: 6, pos: 329}], // Equipo de Informática
          'G6021100104': [{nivel: 6, pos: 330}], // Vehículos
          'G6021100105': [{nivel: 6, pos: 331}], // INSTALACIONES
          'G60211002': [{nivel: 5, pos: 332}], // Provisiones y Amortizaciones
          'G6021100201': [{nivel: 6, pos: 333}], // PROVISIÓN PARA CRÉDITOS DUDOSOS
          'G602110020101': [{nivel: 7, pos: 334}], // Agropecuarios
          'G602110020102': [{nivel: 7, pos: 335}], // Microcréditos
          'G602110020103': [{nivel: 7, pos: 336}], // Comerciales
          'G602110020104': [{nivel: 7, pos: 337}], // Consumo
          'G602110020105': [{nivel: 7, pos: 338}], // Créditos con Destino de Vivienda
          'G602110020106': [{nivel: 7, pos: 339}], // Créditos para Vivienda
          'G6021100202': [{nivel: 6, pos: 340}], // PROVISIÓN PARA INTERESES DUDOSOS
          'G602110020201': [{nivel: 7, pos: 341}], // Agropecuarios
          'G602110020202': [{nivel: 7, pos: 342}], // Microcréditos
          'G602110020203': [{nivel: 7, pos: 343}], // Comerciales
          'G602110020204': [{nivel: 7, pos: 344}], // Consumo
          'G602110020205': [{nivel: 7, pos: 345}], // Créditos con Destino de Vivienda
          'G602110020206': [{nivel: 7, pos: 346}], // Créditos para Vivienda
          'G6021100203': [{nivel: 6, pos: 347}], // Amortización sobre Inversiones
          'G6021100204': [{nivel: 6, pos: 348}], // Amortización sobre Activos Eventuales
          'G6021100205': [{nivel: 6, pos: 349}], // Amortización sobre Gastos de Organización e Instalación
          'G6021100206': [{nivel: 6, pos: 350}], // Amortización sobre Activos de Inversión
          'G6021100207': [{nivel: 6, pos: 351}], // Amortización sobre Activos Intangibles
          'G6021100208': [{nivel: 6, pos: 352}], // Provisión sobre Cuentas y Documentos por Cobrar
          'G602112': [{nivel: 4, pos: 353}], // PAPELERÍA, ÚTILES Y SUMINISTROS
          'G60211201': [{nivel: 5, pos: 354}], // Papelería y Útiles
          'G60211202': [{nivel: 5, pos: 355}], // Suministros
          'G602199': [{nivel: 4, pos: 356}], // GASTOS DIVERSOS
          'G60219901': [{nivel: 5, pos: 357}], // Servicios Públicos
          'G60219902': [{nivel: 5, pos: 358}], // Cuotas y Asociaciones Varias
          'G60219903': [{nivel: 5, pos: 359}], // Donaciones y Contribuciones Voluntarias
          'G60219904': [{nivel: 5, pos: 360}], // Comunicaciones e Informática
          'G60219905': [{nivel: 5, pos: 361}], // Aportaciones de Supervisión
          'G60219998': [{nivel: 5, pos: 362}], // Aportaciones al Fondo de Seguro de Depósitos
          'G60219999': [{nivel: 5, pos: 363}], // Otros
          'G697': [{nivel: 2, pos: 364}], // OTROS GASTOS
          'G6971': [{nivel: 3, pos: 365}], // MONEDA NACIONAL
          'G697101': [{nivel: 4, pos: 366}], // Venta de Activos Eventuales
          'G697102': [{nivel: 4, pos: 367}], // Ventas de Bienes Muebles e Inmuebles
          'G697103': [{nivel: 4, pos: 368}], // Sanciones, Multas e Indemnizaciones
          'G697199': [{nivel: 4, pos: 369}], // OTROS GASTOS
          'G69719999': [{nivel: 5, pos: 370}], // Otros
          'G699': [{nivel: 2, pos: 371}], // GASTOS DE EJERCICIOS ANTERIORES
          'G6991': [{nivel: 3, pos: 372}], // MONEDA NACIONAL
          'G699101': [{nivel: 4, pos: 373}], // GASTOS DE EJERCICIOS ANTERIORES
          'G69910199': [{nivel: 5, pos: 374}], // Otros
        }
        if(objeto) return idsER;
        return idsER[id] ?? undefined;
      case 'ER6MN':
        const idsER6MN = {
          'I5': [{nivel: 1, pos: 1}], // INGRESOS
          'I501': [{nivel: 1, pos: 2}], // PRODUCTOS FINANCIEROS
          'I501101': [{nivel: 1, pos: 3}], // INTERESES
          'I50110101': [{nivel: 2, pos: 4}], // Sobre Disponibilidades
          'I50110102': [{nivel: 2, pos: 5}], // Sobre Inversiones
          'I50110103': [{nivel: 2, pos: 6}], // Sobre Cartera de Préstamos
          'I501103': [{nivel: 1, pos: 7}], // COMISIONES
          'I50110301': [{nivel: 2, pos: 8}], // Sobre Cartera Crediticia
          'I50110399': [{nivel: 2, pos: 9}], // Comisiones Varias
          'I501105': [{nivel: 1, pos: 10}], // OTROS PRODUCTOS
          'I50110501': [{nivel: 2, pos: 11}], // Fluctuaciones de Tipo de Cambio
          'I501199': [{nivel: 1, pos: 12}], // Otros Ingresos Financieros
          'I50119999': [{nivel: 2, pos: 13}], // Otros Ingresos
          'G6011': [{nivel: 1, pos: 14}], // GASTOS FINANCIEROS
          'G601101': [{nivel: 1, pos: 15}], // INTERESES
          'G60110102': [{nivel: 2, pos: 16}], // Depósitos de Ahorro
          'G60110103': [{nivel: 2, pos: 17}], // Depósitos a Plazo
          'G60110108': [{nivel: 2, pos: 18}], // Préstamos de Instituciones Financieras Nacionales
          'G60110113': [{nivel: 2, pos: 19}], // Préstamos Redescontados
          'G60110114': [{nivel: 2, pos: 20}], // Préstamos de Instituciones Internacionales
          'G60110115': [{nivel: 2, pos: 21}], // Aportaciones
          'G60110199': [{nivel: 2, pos: 22}], // Otras Obligaciones
          'G601102': [{nivel: 1, pos: 23}], // COMISIONES
          'G60110202': [{nivel: 2, pos: 24}], // Préstamos de Instituciones Financieras Nacionales
          'G60110296': [{nivel: 2, pos: 25}], // Préstamos de Instituciones Internacionales
          'G60110299': [{nivel: 2, pos: 26}], // Otras Comisiones
          'G601105': [{nivel: 1, pos: 27}], // OTROS GASTOS
          'G60110501': [{nivel: 2, pos: 28}], // Fluctuaciones de Tipo de Cambio
          'G601199': [{nivel: 1, pos: 29}], // OTROS GASTOS FINANCIEROS
          'G60119999': [{nivel: 2, pos: 30}], // Otros Gastos
          'I502': [{nivel: 1, pos: 31}], // PRODUCTOS POR SERVICIOS
          'I502101': [{nivel: 1, pos: 32}], // COMISIONES
          'I50210101': [{nivel: 2, pos: 33}], // Remesas
          'I50210102': [{nivel: 2, pos: 34}], // Cobranzas por Cuenta Ajena
          'I50210199': [{nivel: 2, pos: 35}], // Otras Comisiones
          'I502102': [{nivel: 1, pos: 36}], // ARRENDAMIENTOS
          'I50210201': [{nivel: 2, pos: 37}], // Alquiler de Activos Fijos
          'I502103': [{nivel: 1, pos: 38}], // OTROS INGRESOS POR SERVICIOS
          'I50210301': [{nivel: 2, pos: 39}], // Cuota de Ingreso de Afiliados
          'I50210399': [{nivel: 2, pos: 40}], // Otros Ingresos por Servicios
          'G602': [{nivel: 1, pos: 41}], // GASTOS DE ADMINISTRACION
          'I503': [{nivel: 1, pos: 42}], // OTROS PRODUCTOS
          'I503101': [{nivel: 2, pos: 43}], // Venta de Activos Eventuales
          'I503102': [{nivel: 2, pos: 44}], // Ventas de Bienes Muebles e Inmuebles
          'I503103': [{nivel: 2, pos: 45}], // Donaciones Recibidas
          'I503104': [{nivel: 2, pos: 46}], // Intereses Cobrados sobre Operaciones Readecuadas
          'I503198': [{nivel: 2, pos: 47}], // Donaciones Recibidas
          'I503199': [{nivel: 2, pos: 48}], // Otros Productos
          'G697': [{nivel: 1, pos: 49}], // OTROS GASTOS
          'G697101': [{nivel: 2, pos: 50}], // Venta de Activos Eventuales
          'G697102': [{nivel: 2, pos: 51}], // Ventas de Bienes Muebles e Inmuebles
          'G697103': [{nivel: 2, pos: 52}], // Sanciones, Multas e Indemnizaciones
          'G697199': [{nivel: 2, pos: 53}], // Otros Gastos
          'I599': [{nivel: 1, pos: 54}], // INGRESOS DE EJERCICIOS ANTERIORES
          'I599102': [{nivel: 2, pos: 55}], // Recuperaciones
          'I599199': [{nivel: 2, pos: 56}], // Otros Ingresos de Ejercicios Anteriores
          'G699': [{nivel: 1, pos: 57}], // GASTOS DE EJERCICIOS ANTERIORES
          'G699101': [{nivel: 1, pos: 58}], // Gastos de Ejercicios Anteriores
        }
        if(objeto) return idsER6MN;
        return idsER6MN[id] ?? undefined;
      case 'ER6ME':
        const idsER6ME = {
          'I501201': [{nivel: 1, pos: 1}], // INTERESES
          'I50120101': [{nivel: 2, pos: 2}], // Sobre Disponibilidades
          'I50120102': [{nivel: 2, pos: 3}], // Sobre Inversiones
          'I50120103': [{nivel: 2, pos: 4}], // Sobre Cartera de Préstamos
          'I501203': [{nivel: 1, pos: 5}], // COMISIONES
          'I50120301': [{nivel: 2, pos: 6}], // Sobre Cartera Crediticia
          'I50120399': [{nivel: 2, pos: 7}], // Comisiones Varias
          'I501299': [{nivel: 1, pos: 8}], // Otros Ingresos Financieros
          'I50129999': [{nivel: 2, pos: 9}], // Otros Ingresos
          'G6012': [{nivel: 1, pos: 10}], // GASTOS FINANCIEROS
          'G601201': [{nivel: 1, pos: 11}], // INTERESES
          'G60120102': [{nivel: 2, pos: 12}], // Depósitos de Ahorro
          'G60120103': [{nivel: 2, pos: 13}], // Depósitos a Plazo
          'G60120108': [{nivel: 2, pos: 14}], // Préstamos de Instituciones Financieras Nacionales
          'G60120113': [{nivel: 2, pos: 15}], // Préstamos Redescontados
          'G60120114': [{nivel: 2, pos: 16}], // Préstamos de Instituciones Internacionales
          'G60120115': [{nivel: 2, pos: 17}], // Aportaciones
          'G60120199': [{nivel: 2, pos: 18}], // Otras Obligaciones
          'G601202': [{nivel: 1, pos: 19}], // COMISIONES
          'G60120202': [{nivel: 2, pos: 20}], // Préstamos de Instituciones Financieras Nacionales
          'G60120296': [{nivel: 2, pos: 21}], // Préstamos de Instituciones Internacionales
          'G60120299': [{nivel: 2, pos: 22}], // Otras Comisiones
          'I502201': [{nivel: 1, pos: 23}], // COMISIONES
          'I50220101': [{nivel: 2, pos: 24}], // Remesas
          'I50220102': [{nivel: 2, pos: 25}], // Cobranzas por Cuenta Ajena
          'I50220199': [{nivel: 2, pos: 26}], // Otras Comisiones
        }
        if(objeto) return idsER6ME;
        return idsER6ME[id] ?? undefined;
      case 'balME':
        const idsBalME = {
          'A1012': [{nivel: 1, pos: 1}],
          'A101201': [{nivel: 2, pos: 2}],
          'A101202': [{nivel: 2, pos: 3}],
          'A101203': [{nivel: 2, pos: 4}],

          'A1022': [{nivel: 1, pos: 5}],
          'A102201': [{nivel: 2, pos: 6}],
          'A10220102': [{nivel: 3, pos: 7}],
          'A10220104': [{nivel: 3, pos: 8}],
          'A10220105': [{nivel: 3, pos: 9}],
          'SC01': [{nivel: 2, pos: 10, nombre: 'Reserva Para Amortización De Inversiones'}],
          'A102202': [{nivel: 2, pos: 11}],

          'A1032': [{nivel: 1, pos: 12}],
          'A103201': [{nivel: 2, pos: 13}],
          'A103202': [{nivel: 2, pos: 14}],
          'A103203': [{nivel: 2, pos: 15}],
          'A103204': [{nivel: 2, pos: 16}],
          'VT83': [{nivel: 2, pos: 17}],
          'SC02': [{nivel: 2, pos: 17, nombre: 'Provisión Para Créditos Dudosos'}],

          'A1042': [{nivel: 1, pos: 18}],
          'A104201': [{nivel: 2, pos: 19}],
          'SC03': [{nivel: 2, pos: 20, nombre: 'Provisión para Cuentas y Documentos por Cobrar'}],
          'A104203': [{nivel: 2, pos: 21}],
          'A104204': [{nivel: 2, pos: 22}],
          'A104205': [{nivel: 2, pos: 23}],
          'SC04': [{nivel: 2, pos: 24, nombre: 'Provisión Para Intereses Dudosos'}],
          'SC05': [{nivel: 2, pos: 25, nombre: 'Depósitos En Garantía'}],

          'A1052': [{nivel: 1, pos: 26}],
          'A105201': [{nivel: 2, pos: 27}],
          'A105202': [{nivel: 2, pos: 28}],

          'SC06': [{nivel: 1, pos: 29, nombre: 'Activos Eventuales'}],
          'SC07': [{nivel: 2, pos: 30, nombre: 'Inmuebles'}],
          'SC08': [{nivel: 2, pos: 31, nombre: 'Muebles'}],
          'SC09': [{nivel: 2, pos: 32, nombre: 'Subtotal Activos Eventuales'}],
          'SC10': [{nivel: 2, pos: 33, nombre: 'Depreciación Acumulada De Activos Eventuales'}],

          'SC11': [{nivel: 1, pos: 34, nombre: 'Activos Fijos'}],
          'SC12': [{nivel: 2, pos: 35, nombre: 'Terrenos'}],
          'SC13': [{nivel: 2, pos: 36, nombre: 'Edificio'}],
          'SC14': [{nivel: 2, pos: 37, nombre: 'Obras en Construccion'}],
          'SC15': [{nivel: 2, pos: 38, nombre: 'Mobiliario y Equipo de Oficina'}],
          'SC16': [{nivel: 2, pos: 39, nombre: 'Instalaciones'}],
          'SC17': [{nivel: 2, pos: 40, nombre: 'Bienes Arrendados'}],
          'SC18': [{nivel: 2, pos: 41, nombre: 'Vehiculo'}],
          'SC19': [{nivel: 2, pos: 42, nombre: 'Subtotal Activos Fijos'}],
          'SC20': [{nivel: 3, pos: 43, nombre: 'Depreciación Acumulada de Edificios'}],
          'SC21': [{nivel: 3, pos: 44, nombre: 'Depreciación Acumulada de Mobiliario Y Equipo'}],
          'SC22': [{nivel: 3, pos: 45, nombre: 'Depreciación Acumulada de Instalaciones'}],
          'SC23': [{nivel: 3, pos: 46, nombre: 'Depreciación Acumulada de activos arrendados'}],
          'SC24': [{nivel: 3, pos: 47, nombre: 'Depreciación Acumulada de Vehiculo'}],
          'SC25': [{nivel: 3, pos: 48, nombre: 'Depreciación Acumulada de Equipo De Computo'}],
          'SC26': [{nivel: 2, pos: 49, nombre: 'Subtotal Depreciaciones'}],

          'A1082': [{nivel: 1, pos: 50}],
          'A108201': [{nivel: 2, pos: 51}],
          'A108202': [{nivel: 2, pos: 52}],
          'SC27': [{nivel: 2, pos: 53, nombre: 'Cuentas Por Amortizar'}],
          'SC28': [{nivel: 2, pos: 54, nombre: 'Papelería Y Útiles De Oficina'}],
          'A108219': [{nivel: 2, pos: 55}],

          'SC29': [{nivel: 1, pos: 56, nombre: 'Activos De Inversión'}],
          'SC30': [{nivel: 2, pos: 57, nombre: 'Bienes Y Raíces'}],
          'SC31': [{nivel: 2, pos: 58, nombre: 'Depreciación Acumulada de Activos de Inversión'}],

          'A1102': [{nivel: 1, pos: 59}],
          'A110201': [{nivel: 2, pos: 60}],
          'A110202': [{nivel: 2, pos: 61}],
          'VT84': [{nivel: 2, pos: 62}],
          'SC32': [{nivel: 2, pos: 63, nombre: 'Amortización Acumulada De Activos Intangibles'}],

          'VT16': [{nivel: 1, pos: 64}],

          'P2012': [{nivel: 1, pos: 65}],
          'P201207': [{nivel: 2, pos: 66}],
          'P201208': [{nivel: 2, pos: 67}],
          'P201209': [{nivel: 2, pos: 68}],
          'SC33': [{nivel: 2, pos: 69, nombre: 'Excedentes por Distribuir'}],
          'P201212': [{nivel: 2, pos: 70}],
          'P201213': [{nivel: 2, pos: 71}],
          'P201220': [{nivel: 2, pos: 72}],
          'P201221': [{nivel: 2, pos: 73}],

          'P2022': [{nivel: 1, pos: 74}],
          'P202201': [{nivel: 2, pos: 75}],
          'P202203': [{nivel: 2, pos: 76}],

          'P2032': [{nivel: 1, pos: 77}],
          'P203203': [{nivel: 2, pos: 78}],

          'P2042': [{nivel: 1, pos: 79}],
          'P204201': [{nivel: 2, pos: 80}],
          'P204202': [{nivel: 2, pos: 81}],

          'P2052': [{nivel: 1, pos: 82}],
          'P205201': [{nivel: 2, pos: 83}],
          'P205202': [{nivel: 2, pos: 84}],

          'P2062': [{nivel: 1, pos: 85}],
          'P206201': [{nivel: 2, pos: 86}],
          'P206202': [{nivel: 2, pos: 87}],
          'P206204': [{nivel: 2, pos: 88}],
          'P206207': [{nivel: 2, pos: 89}],

          'SC34': [{nivel: 1, pos: 90, nombre: 'Provisiones Eventuales'}],
          'SC35': [{nivel: 2, pos: 91, nombre: 'Provisiones para Prestaciones Sociales'}],
          'SC36': [{nivel: 2, pos: 92, nombre: 'Provisiones Especiales'}],

          'VT17': [{nivel: 1, pos: 93}],

          
          'SC37': [{nivel: 1, pos: 94, nombre: 'Patrimonio Primario'}],
          'SC38': [{nivel: 2, pos: 95, nombre: 'Aportaciones'}],
          'SC39': [{nivel: 2, pos: 96, nombre: 'Reserva Legal'}],

          'SC40': [{nivel: 1, pos: 97, nombre: 'Patrimonio Complementario'}],
          'SC41': [{nivel: 2, pos: 98, nombre: 'Reserva Por Revaluaciones'}],
          'SC42': [{nivel: 2, pos: 99, nombre: 'Reservas para contingencias'}],
          'SC43': [{nivel: 2, pos: 100, nombre: 'Donaciones'}],
          'SC44': [{nivel: 2, pos: 101, nombre: 'Otras reservas de capital'}],
          'SC45': [{nivel: 2, pos: 102, nombre: 'Resultados Acumulados'}],
          'SC46': [{nivel: 2, pos: 103, nombre: 'Excedentes o Pérdidas del Periodo'}],

          'SC47': [{nivel: 1, pos: 104, nombre: 'Suma de Patrimonio'}],

          'VT86': [{nivel: 1, pos: 105}], // Suma Pasivo mas Patrimonio
        }
        if(objeto) return idsBalME;
        return idsBalME[id] ?? undefined;
      case 'balMN':
        const idsBalMN = {
          'A1011': [{nivel: 1, pos:1}],
          'A101101': [{nivel: 2, pos:2}],
          'A101102': [{nivel: 2, pos:3}],
          'A101103': [{nivel: 2, pos:4}],

          'VT01': [{nivel: 1, pos:5}],
          'A102101': [{nivel: 2, pos:6}],
          'A10210102': [{nivel: 3, pos:7}],
          'A10210104': [{nivel: 3, pos:8}],
          'A10210105': [{nivel: 3, pos:9}],
          'P207103': [{nivel: 2, pos:10}],
          'A102102': [{nivel: 2, pos:11}],

          'VT02': [{nivel: 1, pos:12}],
          'A103101': [{nivel: 2, pos:13}],
          'A103102': [{nivel: 2, pos:14}],
          'A103103': [{nivel: 2, pos:15}],
          'A103104': [{nivel: 2, pos:16}],
          'A1031': [{nivel: 2, pos:17}],
          'P207101': [{nivel: 2, pos:18}],

          'VT03': [{nivel: 1, pos:19}],
          'A104101': [{nivel: 2, pos:20}],
          'P207112': [{nivel: 2, pos:21}],
          'A104103': [{nivel: 2, pos:22}],
          'A104104': [{nivel: 2, pos:23}],
          'A104105': [{nivel: 2, pos:24}],
          'P207102': [{nivel: 2, pos:25}],
          'A104107': [{nivel: 2, pos:26}],

          'A1051': [{nivel: 1, pos:27}],
          'A105101': [{nivel: 2, pos:28}],
          'A105102': [{nivel: 2, pos:29}],

          'VT04': [{nivel: 1, pos:30}],
          'A106101': [{nivel: 3, pos:31}],
          'A106102': [{nivel: 3, pos:32}],
          'A1061': [{nivel: 2, pos:33}],
          'P207107': [{nivel: 2, pos:34}],

          'VT06': [{nivel: 1, pos:35}],
          'A10710101': [{nivel: 3, pos:36}],
          'A10710102': [{nivel: 3, pos:37}],
          'A10710103': [{nivel: 3, pos:38}],
          'A107102': [{nivel: 3, pos:39}],
          'A107103': [{nivel: 3, pos:40}],
          'A107104': [{nivel: 3, pos:41}],
          'A107105': [{nivel: 3, pos:42}],
          'A1071': [{nivel: 2, pos:43}],
          'P207104': [{nivel: 3, pos:44}],
          'P20710501': [{nivel: 3, pos:45}],
          'P207106': [{nivel: 3, pos:46}],
          'P207108': [{nivel: 3, pos:47}],//no se si aqui es 3 
          'P207109': [{nivel: 3, pos:48}],
          'P20710502': [{nivel: 3, pos:49}],
          'VT05': [{nivel: 2, pos:50}],

          'A1081': [{nivel: 1, pos:51}],
          'A108101': [{nivel: 2, pos:52}],
          'A108102': [{nivel: 2, pos:53}],
          'A108103': [{nivel: 2, pos:54}],
          'A108104': [{nivel: 2, pos:55}],
          'A108119': [{nivel: 2, pos:56}],

          'VT07': [{nivel: 1, pos:57}],
          'A109101': [{nivel: 2, pos:58}],
          'P207110': [{nivel: 2, pos:59}],

          'VT08': [{nivel: 1, pos:60}],
          'A110101': [{nivel: 3, pos:61}],
          'A110102': [{nivel: 3, pos:62}],
          'A1101': [{nivel: 2, pos:63}],
          'P207111': [{nivel: 2, pos:64}],

          'VT09': [{nivel: 1, pos:65}],

          'P2011': [{nivel: 1, pos:66}],
          'P201107': [{nivel: 2, pos:67}],
          'P201108': [{nivel: 2, pos:68}],
          'P201109': [{nivel: 2, pos:69}],
          'P201110': [{nivel: 2, pos:70}],
          'P201112': [{nivel: 2, pos:71}],
          'P201113': [{nivel: 2, pos:72}],
          'P201120': [{nivel: 2, pos:73}],
          'P201121': [{nivel: 2, pos:74}],

          'P2021': [{nivel: 1, pos:75}],
          'P202101': [{nivel: 2, pos:76}],
          'P202103': [{nivel: 2, pos:77}],

          'P2031': [{nivel: 1, pos:78}],
          'P203103': [{nivel: 2, pos:79}],

          'P2041': [{nivel: 1, pos:80}],
          'P204101': [{nivel: 2, pos:81}],
          'P204102': [{nivel: 2, pos:82}],

          'P2051': [{nivel: 1, pos:83}],
          'P205101': [{nivel: 2, pos:84}],
          'P205102': [{nivel: 2, pos:85}],

          'P2061': [{nivel: 1, pos:86}],
          'P206101': [{nivel: 2, pos:87}],
          'P206102': [{nivel: 2, pos:88}],
          'P206104': [{nivel: 2, pos:89}],
          'P206107': [{nivel: 2, pos:90}],

          'P2081': [{nivel: 1, pos:91}],
          'P208102': [{nivel: 2, pos:92}],
          'P208103': [{nivel: 2, pos:93}],

          'VT10': [{nivel: 1, pos:94}],

          'P3011': [{nivel: 1, pos:95}],
          'P301101': [{nivel: 2, pos:96}],
          'P301103': [{nivel: 2, pos:97}],

          'P3021': [{nivel: 1, pos:98}],
          'P302101': [{nivel: 2, pos:99}],
          'P302102': [{nivel: 2, pos:100}],
          'P302105': [{nivel: 2, pos:101}],
          'P302107': [{nivel: 2, pos:102}],
          'P302108': [{nivel: 2, pos:103}],
          'P302109': [{nivel: 2, pos:104}],

          'P3': [{nivel: 1, pos:105}],
          
          'VT11': [{nivel: 1, pos:106}],
        }
        if(objeto) return idsBalMN;
        return idsBalMN[id] ?? undefined;
      case 'est': 
        const idsEst = {
            'I501': [{nivel: 1, pos: 1}],

            'VT67': [{nivel: 1, pos: 2}],
            'VT68': [{nivel: 2, pos: 3}],
            'VT69': [{nivel: 2, pos: 4}],
            'VT70': [{nivel: 2, pos: 5}],

            'VT71': [{nivel: 1, pos: 6}],
            'VT72': [{nivel: 2, pos: 7}],
            'VT73': [{nivel: 2, pos: 8}],

            'VT74': [{nivel: 1, pos: 9}],
            'I50110501': [{nivel: 2, pos: 10}],
            'VT75': [{nivel: 2, pos: 11}],

            'G601': [{nivel: 1, pos: 12}],
            'VT76': [{nivel: 2, pos: 13}],
            'VT77': [{nivel: 2, pos: 14}],
            'G601105': [{nivel: 2, pos: 15}],
            'G601199': [{nivel: 2, pos: 16}],

            'VT78': [{nivel: 1, pos: 17}],

            'I502': [{nivel: 1, pos: 18}],
            'VT79': [{nivel: 2, pos: 19}],
            'I502102': [{nivel: 2, pos: 20}],
            'I502103': [{nivel: 2, pos: 21}],

            'G602': [{nivel: 1, pos: 22}],
            'G602101': [{nivel: 2, pos: 23}],
            'G602102': [{nivel: 2, pos: 24}],
            'G602103': [{nivel: 2, pos: 25}],
            'G602104': [{nivel: 2, pos: 26}],
            'G602105': [{nivel: 2, pos: 27}],
            'G602106': [{nivel: 2, pos: 28}],
            'G602107': [{nivel: 2, pos: 29}],
            'G602108': [{nivel: 2, pos: 30}],
            'G602109': [{nivel: 2, pos: 31}],
            'G602110': [{nivel: 2, pos: 32}],
            'G602112': [{nivel: 2, pos: 33}],
            'G602199': [{nivel: 2, pos: 34}],

            'VT80': [{nivel: 1, pos: 35}],

            'I503': [{nivel: 1, pos: 36}],
            'I503101': [{nivel: 2, pos: 37}],
            'I503102': [{nivel: 2, pos: 38}],
            'I503103': [{nivel: 2, pos: 39}],
            'I503104': [{nivel: 2, pos: 40}],
            'I503198': [{nivel: 2, pos: 41}],
            'I503199': [{nivel: 2, pos: 42}],

            'G697': [{nivel: 1, pos: 43}],
            'G697101': [{nivel: 2, pos: 44}],
            'G697102': [{nivel: 2, pos: 45}],
            'G697103': [{nivel: 2, pos: 46}],
            'G697199': [{nivel: 2, pos: 47}],

            'I599': [{nivel: 1, pos: 48}],
            'G699': [{nivel: 2, pos: 49}],

            'VT81': [{nivel: 1, pos: 50}]

        }
        if(objeto) return idsEst;
        return idsEst[id] ?? undefined;
      case 'estME':
        const idsEstME = {
          'I5012': [{nivel: 1, pos: 1}],

          'I501201': [{nivel: 1, pos: 2}],
          'I50120101': [{nivel: 2, pos: 3}],
          'I50120102': [{nivel: 2, pos: 4}],
          'I50120103': [{nivel: 2, pos: 5}],

          'I501203': [{nivel: 1, pos: 6}],
          'I50120301': [{nivel: 2, pos: 7}],
          'I50120399': [{nivel: 2, pos: 8}],

          'I501299': [{nivel: 1, pos: 9}],
          'SC49': [{nivel: 2, pos: 10, nombre: 'Fluctuaciones de Tipo de Cambio'}],
          'VT85': [{nivel: 2, pos: 11}], // Otros Ingresos Financieros

          'G6012': [{nivel: 1, pos: 11}],
          'G601201': [{nivel: 2, pos: 12}],
          'G601202': [{nivel: 2, pos: 13}],
          'SC50': [{nivel: 2, pos: 14, nombre: 'Otros Gastos'}],
          'SC51': [{nivel: 2, pos: 15, nombre: 'Otros Gastos Financieros'}],

          'VT18': [{nivel: 1, pos: 16}],

          'I5022': [{nivel: 1, pos: 17}],
          'I502201': [{nivel: 2, pos: 18}],
          'SC52': [{nivel: 2, pos: 19, nombre: 'Arrendamientos'}],
          'SC53': [{nivel: 2, pos: 20, nombre: 'Otros ingresos por Servicios'}],

          'SC54': [{nivel: 1, pos: 21, nombre: 'Gastos de Administracion'}],
          'SC55': [{nivel: 2, pos: 22, nombre: 'Directivos'}],
          'SC56': [{nivel: 2, pos: 23, nombre: 'Funcionarios y Empleados'}],
          'SC57': [{nivel: 2, pos: 24, nombre: 'Impuestos y Contribuciones'}],
          'SC58': [{nivel: 2, pos: 25, nombre: 'Honorarios Profesionales'}],
          'SC59': [{nivel: 2, pos: 26, nombre: 'Arrendamiento'}],
          'SC60': [{nivel: 2, pos: 27, nombre: 'Reparaciones, Uso y Mantenimiento'}],
          'SC61': [{nivel: 2, pos: 28, nombre: 'Seguridad y Vigilancia'}],
          'SC62': [{nivel: 2, pos: 29, nombre: 'Mercadeo'}],
          'SC63': [{nivel: 2, pos: 30, nombre: 'Amortización de primas de seguro'}],
          'SC64': [{nivel: 2, pos: 31, nombre: 'Depreciaciones y Amortizaciones'}],
          'SC65': [{nivel: 2, pos: 32, nombre: 'Papelería , Útiles y Suministros'}],
          'SC66': [{nivel: 2, pos: 33, nombre: 'Gastos Diversos'}],

          'VT19': [{nivel: 1, pos: 34}],

          'SC67': [{nivel: 1, pos: 35, nombre: 'Otros Productos'}],
          'SC68': [{nivel: 2, pos: 36, nombre: 'Venta de Activos Eventuales'}],
          'SC69': [{nivel: 2, pos: 37, nombre: 'Venta de Bienes Muebles e Inmuebles'}],
          'SC70': [{nivel: 2, pos: 38, nombre: 'Donaciones Recibidas'}],
          'SC71': [{nivel: 2, pos: 39, nombre: 'Intereses Cobrados sobre Operaciones Readecuadas'}],
          'SC72': [{nivel: 2, pos: 40, nombre: 'Donaciones Recibidas'}],
          'SC73': [{nivel: 2, pos: 41, nombre: 'Otros Productos'}],

          'SC74': [{nivel: 1, pos: 42, nombre: 'Otros Gastos'}],
          'SC75': [{nivel: 2, pos: 43, nombre: 'Venta de Activos Eventuales'}],
          'SC76': [{nivel: 2, pos: 44, nombre: 'Venta de Bienes Muebles e Inmuebles'}],
          'SC77': [{nivel: 2, pos: 45, nombre: 'Multas e Indemnizaciones'}],
          'SC78': [{nivel: 2, pos: 46, nombre: 'Otros Gastos'}],

          'SC79': [{nivel: 1, pos: 47, nombre: 'Ingresos de Ejercicios Anteriores'}],
          'SC80': [{nivel: 2, pos: 48, nombre: 'Gastos de Ejercicios Anteriores'}],

          'VT82': [{nivel: 1, pos: 49}], // Excedente o Perdida del Ejercicio
        }
        if(objeto) return idsEstME;
        return idsEstME[id] ?? undefined;
      case 'estMN':
        const idsEstMN = {
          'I5011': [{nivel: 1, pos: 1}],

          'I501101': [{nivel: 1, pos: 2}],
          'I50110101': [{nivel: 2, pos: 3}],
          'I50110102': [{nivel: 2, pos: 4}],
          'I50110103': [{nivel: 2, pos: 5}],

          'I501103': [{nivel: 1, pos: 6}],
          'I50110301': [{nivel: 2, pos: 7}],
          'I50110399': [{nivel: 2, pos: 8}],

          'VT12': [{nivel: 1, pos: 9}],
          'I50110501': [{nivel: 2, pos: 10}],
          'I501199': [{nivel: 2, pos: 11}],

          'G6011': [{nivel: 1, pos: 12}],
          'G601101': [{nivel: 2, pos: 13}],
          'G601102': [{nivel: 2, pos: 14}],
          'G601105': [{nivel: 2, pos: 15}],
          'G601199': [{nivel: 2, pos: 16}],

          'VT13': [{nivel: 1, pos: 17}],

          'I5021': [{nivel: 1, pos: 18}],
          'I502101': [{nivel: 2, pos: 19}],
          'I502102': [{nivel: 2, pos: 20}],
          'I502103': [{nivel: 2, pos: 21}],

          'G6021': [{nivel: 1, pos: 22}],
          'G602101': [{nivel: 2, pos: 23}],
          'G602102': [{nivel: 2, pos: 24}],
          'G602103': [{nivel: 2, pos: 25}],
          'G602104': [{nivel: 2, pos: 26}],
          'G602105': [{nivel: 2, pos: 27}],
          'G602106': [{nivel: 2, pos: 28}],
          'G602107': [{nivel: 2, pos: 29}],
          'G602108': [{nivel: 2, pos: 30}],
          'G602109': [{nivel: 2, pos: 31}],
          'G602110': [{nivel: 2, pos: 32}],
          'G602112': [{nivel: 2, pos: 33}],
          'G602199': [{nivel: 2, pos: 34}],

          'VT14': [{nivel: 1, pos: 35}],

          'I5031': [{nivel: 1, pos: 36}],
          'I503101': [{nivel: 2, pos: 37}],
          'I503102': [{nivel: 2, pos: 38}],
          'I503103': [{nivel: 2, pos: 39}],
          'I503104': [{nivel: 2, pos: 40}],
          'I503198': [{nivel: 2, pos: 41}],
          'I503199': [{nivel: 2, pos: 42}],

          'G6971': [{nivel: 1, pos: 43}],
          'G697101': [{nivel: 2, pos: 44}],
          'G697102': [{nivel: 2, pos: 45}],
          'G697103': [{nivel: 2, pos: 46}],
          'G697199': [{nivel: 2, pos: 47}],

          'I599': [{nivel: 1, pos: 48}],
          'G699': [{nivel: 2, pos: 49}],

          'VT15': [{nivel: 1, pos: 50}]
        };
        if(objeto) return idsEstMN;
        return idsEstMN[id] ?? undefined;
    }
  }
  static idsVarTemp(id: number){
    const consultas ={
      0: 'VT011',
      1: 'VT040',
      2: 'VT004',
    }
    return consultas[id] ?? undefined;
  }
  static porcentajes(id: number){
    const consultas ={
      0: '',
      1: 8,
      2: 2.4,
      3: 15,
    }
    return consultas[id] ?? undefined;
  }
  static montosAn(id: number){
    const consultas ={
      2022: 78141246276,
      2021: 72749437836,
      2020: 69148037743,
    }
    return consultas[id] ?? undefined;
  }
}

export class indicadores{
  static indiFinancieros =  [
    {name: 'CB', pos: 1},
    {name: 'CA', pos: 2},
    {name: 'RT', pos: 3},
    {name: 'EF', pos: 4},
    {name: 'AC', pos: 5},
  ];
  static indiFinancierosA = [
    {name: 'EC', pos: 1},
    {name: 'RC', pos: 2},
    {name: 'L', pos: 3},
  ];
  static indiFinancieros13 = [
    {name: 'LR', pos: 1},
    {name: 'CA', pos: 2},
    {name: 'SO', pos: 3},
    {name: 'LI', pos: 4},
    {name: 'GA', pos: 5},
    {name: 'RC', pos: 6},
  ];
  static indiFinancieros5 = [
    {name: 'CF', pos: 1},
    {name: 'CA', pos: 2},
    {name: 'EF', pos: 3},
    {name: 'R', pos: 4},
  ];
  static indiPerlas =  [
    {name: 'PR', pos: 1},
    {name: 'EE', pos: 2},
    {name: 'CP', pos: 3},
    {name: 'TR', pos: 4},
    {name: 'LQ', pos: 5},
    {name: 'SC', pos: 6},
  ];
  static indiPerlas5 =  [
    {name: 'TC', pos: 1},
    {name: 'LI', pos: 2},
    {name: 'SC', pos: 3},
  ];
  static indiPerlas8 =  [
    {name: 'PR', pos: 1},
    {name: 'EE', pos: 2},
    {name: 'CP', pos: 3},
    {name: 'TR', pos: 4},
    {name: 'LQ', pos: 5},
    {name: 'SC', pos: 6},
  ];
}
export class indCoberturas{
  static mostrarInd(plantilla){
    switch(plantilla){
      case 7: 
        const c = ['C1', 'CB1', 'CB2', 'CB3', 'CB4', 'CB5', 'CB6', 'CB7', 'CB8']
       return c;
      case 12: 
        return ['CB', 'CB1', 'CB2', 'CB3', 'CB4', 'CB5', 'CB6'];
      default:
        return [];
    }
  }
  static cuentasIndCobertura(plantilla: number){
    var cuentas = {};
    switch(plantilla){
      case 12: 
        cuentas = {
          cuentas: ['A1200102', 'I6010102', 'G701', 'G703', 'G704', 'A101', 'A102', 'A106', 'P305'],
          varTemp: ['VT12', 'VT02', 'VT08', 'VT11', 'VT09', 'VT04', 'VT23'],
          var: ['V01', 'V03', 'V04'],
        }
        return cuentas;
      case 7: 
        cuentas = {
          cuentas: ['A11101','A11102','P21201','P21202','P21204','P22201','P22203'],
          varTemp: ['VT017','VT053'],
          var: ['V007','V008','V009'],
          cuentasp:['G5110104'],
          variablesp:['V050',],
          varTempp: ['VT037',],
        }
        return cuentas;
      default:
        return '';
          
    }
  }
  static obtenerPeso(plantilla, id){
    switch(plantilla){
      case 7:
        switch(id){
          case 'CB1':
            return 10;
          case 'CB2':
            return 20;
          case 'CB3':
            return 10;
          case 'CB4':
            return 10;
          case 'CB5':
            return 10;
          case 'CB6':
            return 10;
          case 'CB7':
            return 10;
          case 'CB8':
            return 20;
          default: return -1;
        }
      case 12:
        switch(id){
          case 'CB1':
            return 20;
          case 'CB2':
            return 20;
          case 'CB3':
            return 20;
          case 'CB4':
            return 10;
          case 'CB5':
            return 10;
          case 'CB6': //RCL
            return 20;
          default: return -1;
        }
    }    
    return 0;
  }
  static obtenerPuntos(plantilla, id, val){
    switch(plantilla){
      case 7: 
        switch(id){
          case 'CB1':
            if(val>=0 && val<=70)
              return 0;
            if(val>70 && val<=80)
              return 50;
            if(val>80 && val<=90)
              return 75;
            if(val>90)
              return 100;
          return -1;
          case 'CB2':
            if(val>=0 && val<=95)
              return 0;
            if(val>95 && val<=100)
              return 70;
            if(val>100 && val<=110)
              return 80;
            if(val>110 && val<=120)
              return 90;
            if(val>120)
              return 100;
          return -1;
          case 'CB3':
            if(val>=0 && val<=95)
              return 0;
            if(val>95 && val<=100)
              return 70;
            if(val>100 && val<=110)
              return 80;
            if(val>110 && val<=120)
              return 90;
            if(val>120)
              return 100;
          return -1;
          case 'CB4':
            if(val>=0 && val<=80)
              return 0;
            if(val>80 && val<=90)
              return 70;
            if(val>90 && val<=100)
              return 80;
            if(val>100 && val<=110)
              return 90;
            if(val>110)
              return 100;
          return -1;
          case 'CB5':
            if(val>=0 && val<=70)
              return 0;
            if(val>70 && val<=80)
              return 70;
            if(val>80 && val<=90)
              return 80;
            if(val>90 && val<=100)
              return 90;
            if(val>100)
              return 100;
          return -1;
          case 'CB6':
            if(val>=0 && val<=30)
              return 0;
            if(val>30 && val<=40)
              return 70;
            if(val>40 && val<=50)
              return 80;
            if(val>50 && val<=70)
              return 90;
            if(val>70)
              return 100;
          return -1;
          case 'CB7':
            if(val>=0 && val<=20)
              return 100;
            if(val>20 && val<=30)
              return 70;
            if(val>30 && val<=40)
              return 40;
            if(val>40 && val<=50)
              return 20;
          return -1;
          case 'CB8':
            if(val>=0 && val<=70)
              return 0;
            if(val>70 && val<=80)
              return 70;
            if(val>80 && val<=90)
              return 80;
            if(val>90 && val<=100)
              return 90;
            if(val>=100)
              return 100;
          return -1;
          default: 
          return -1;
        }
      case 12: 
        switch(id){
          case 'CB1':
            if(val >= 100)
              return 100;
            if(val < 100 && val >= 90)
              return 80;
            if(val < 90 && val >= 80)
              return 60;
            if(val < 80)
              return 0
            return -1;
          case 'CB2':
            if(val >= 110)
              return 100;
            if(val < 110 && val >= 100)
              return 80;
            if(val < 100 && val >= 90)
              return 60;
            if(val < 90)
              return 0
            return -1;
          case 'CB3':
            if(val >= 100)
              return 100;
            if(val < 100 && val >= 90)
              return 80;
            if(val < 90 && val >= 80)
              return 60;
            if(val < 80)
              return 0
            return -1;
          case 'CB4':
            if(val >= 100)
              return 100;
            if(val < 100 && val >= 90)
              return 80;
            if(val < 90 && val >= 80)
              return 60;
            if(val < 80)
              return 0
            return -1;
          case 'CB5':
            if(val >= 70)
              return 100;
            if(val < 70 && val >= 60)
              return 80;
            if(val < 60 && val >= 50)
              return 60;
            if(val < 50)
              return 0
            return -1;
          case 'CB6':
            if(val >= 90)
              return 100;
            if(val < 90 && val >= 80)
              return 80;
            if(val < 80 && val >= 70)
              return 60;
            if(val < 70)
              return 0
            return -1;
          default:
            return -1;
        }
      default:
        return -1;
    }
  }
}

export class indProductividad{
  static indicadores(idInst){
    switch(idInst){
      case 7: 
        const idsBal7 = [
          {
            nombre: 'Tamaño promedio de crédito vigente regular.',
            calculo: 'Cartera bruta sin tarjetas de crédito / Número de créditos vigentes sin tarjetas de crédito.',
            formula: 'CRE_01 / CRE_02',
            nivel: 1
          },
          {
            nombre: 'Cartera bruta sin tarjetas de crédito.',
            calculo: 'Cartera bruta sin tarjetas de crédito.',
            formula: 'CRE_01',
            nivel: 2
          },
          {
            nombre: 'Número de créditos vigentes sin tarjetas de crédito.',
            calculo: 'Número de créditos vigentes sin tarjetas de crédito.',
            formula: 'CRE_02',
            nivel: 2
          },

          {
            nombre: 'Tamaño promedio de crédito desembolsado regular.',
            calculo: 'Monto de créditos desembolsados acumulados en el año sin TdC / Número de créditos desembolsados acumulados en el año sin TdC.',
            formula: 'CRE_03 / CRE_04',
            nivel: 1
          },
          {
            nombre: 'Monto de créditos desembolsados acumulados en el año sin TdC.',
            calculo: 'Monto de créditos desembolsados acumulados en el año sin TdC.',
            formula: 'CRE_03',
            nivel: 2
          },
          {
            nombre: 'Número de créditos desembolsados acumulados en el año sin TdC.',
            calculo: 'Número de créditos desembolsados acumulados en el año sin TdC.',
            formula: 'CRE_04',
            nivel: 2
          },

          {
            nombre: 'Número promedio mensual de créditos regulares desembolsados.',
            calculo: 'Número de créditos desembolsados desde el 1 de enero al cierre del mes sin TdC / Meses transcurridos del año.',
            formula: 'CRE_04 / varTemp',
            nivel: 1
          },
          {
            nombre: 'Número de créditos desembolsados desde el 1 de enero al cierre del mes sin TdC.',
            calculo: 'Número de créditos desembolsados desde el 1 de enero al cierre del mes sin TdC.',
            formula: 'CRE_04',
            nivel: 2
          },
          {
            nombre: 'Meses transcurridos del año.',
            calculo: 'Meses transcurridos del año.',
            formula: 'varTemp',
            nivel: 2
          },

          {
            nombre: 'Número promedio diario de créditos regulares desembolsados.',
            calculo: 'Número promedio mensual de créditos regulares desembolsados / Número de días laborables.',
            formula: 'CRE_04 / varTemp / FOR_03',
            nivel: 1
          },
          {
            nombre: 'Número promedio mensual de créditos regulares desembolsados.',
            calculo: 'Número promedio mensual de créditos regulares desembolsados.',
            formula: 'CRE_04 / varTemp ',
            nivel: 2
          },
          {
            nombre: 'Número de días laborables.',
            calculo: 'Número de días laborables.',
            formula: 'FOR_03',
            nivel: 2
          },

          {
            nombre: 'Número promedio diario de créditos regulares desembolsados por agencia.',
            calculo: 'Número promedio diario de créditos regulares desembolsados / Número de agencias.',
            formula: 'CRE_04 / varTemp / FOR_03 / FOR_02',
            nivel: 1
          },
          {
            nombre: 'Número promedio diario de créditos regulares desembolsados.',
            calculo: 'Número promedio diario de créditos regulares desembolsados.',
            formula: 'CRE_04 / varTemp / FOR_03',
            nivel: 2
          },
          {
            nombre: 'Número de agencias.',
            calculo: 'Número de agencias.',
            formula: 'FOR_02',
            nivel: 2
          },

          {
            nombre: 'Cartera bruta regular promedio por empleado.',
            calculo: 'Cartera bruta sin tarjetas de crédito / Número de empleados.',
            formula: 'CRE_01 / FOR_01',
            nivel: 1
          },
          {
            nombre: 'Cartera bruta sin tarjetas de crédito.',
            calculo: 'Cartera bruta sin tarjetas de crédito.',
            formula: 'CRE_01',
            nivel: 2
          },
          {
            nombre: 'Número de empleados.',
            calculo: 'Número de empleados.',
            formula: 'FOR_01',
            nivel: 2
          },

          {
            nombre: 'Número de créditos vigentes regulares promedio por empleado.',
            calculo: 'Número de créditos vigentes sin TdC / Número de empleados.',
            formula: 'CRE_02 / FOR_01',
            nivel: 1
          },
          {
            nombre: 'Número de créditos vigentes sin TdC.',
            calculo: 'Número de créditos vigentes sin TdC.',
            formula: 'CRE_02',
            nivel: 2
          },
          {
            nombre: 'Número de empleados.',
            calculo: 'Número de empleados.',
            formula: 'FOR_01',
            nivel: 2
          },

          {
            nombre: 'Costo operativo por crédito regular desembolsado.',
            calculo: 'Gastos administrativos y operativos / Número de créditos desembolsados acumulados en el año sin TdC.',
            formula: 'valCuenta / CRE_04',
            nivel: 1
          },
          {
            nombre: 'Gastos administrativos y operativos.',
            calculo: 'Gastos administrativos y operativos.',
            formula: 'valCuenta',
            nivel: 2
          },
          {
            nombre: 'Número de créditos desembolsados acumulados en el año sin TdC.',
            calculo: 'Número de créditos desembolsados acumulados en el año sin TdC.',
            formula: 'CRE_04',
            nivel: 2
          },

          {
            nombre: 'Tamaño promedio de crédito desembolsado/salario mínimo vigente.',
            calculo: 'Tamaño promedio de crédito desembolsado regular /Salario mínimo.',
            formula: 'CRE_03 / CRE_04 / FOR_05',
            nivel: 1
          },
          {
            nombre: 'Tamaño promedio de crédito desembolsado regular.',
            calculo: 'Tamaño promedio de crédito desembolsado regular.',
            formula: 'CRE_03 / CRE_04',
            nivel: 2
          },
          {
            nombre: 'Salario mínimo.',
            calculo: 'Salario mínimo.',
            formula: 'FOR_05',
            nivel: 2
          },

          {
            nombre: 'Tamaño promedio de saldo de tarjetas de crédito.',
            calculo: 'Saldo de cartera de tarjetas de crédito / Número de tarjetas de crédito vigentes.',
            formula: 'CRE_05 / CRE_06',
            nivel: 1
          },
          {
            nombre: 'Saldo de cartera de tarjetas de crédito.',
            calculo: 'Saldo de cartera de tarjetas de crédito.',
            formula: 'CRE_05',
            nivel: 2
          },
          {
            nombre: 'Número de tarjetas de crédito vigentes.',
            calculo: 'Número de tarjetas de crédito vigentes.',
            formula: 'CRE_06',
            nivel: 2
          },

          {
            nombre: 'Índice de uso de línea de tarjetas de crédito.',
            calculo: 'Saldo de cartera de tarjetas de crédito / Monto habilitado de tarjetas de crédito.',
            formula: 'CRE_05 / CRE_07 * porcen',
            nivel: 1
          },
          {
            nombre: 'Saldo de cartera de tarjetas de crédito.',
            calculo: 'Saldo de cartera de tarjetas de crédito.',
            formula: 'CRE_05',
            nivel: 2
          },
          {
            nombre: 'Monto habilitado de tarjetas de crédito.',
            calculo: 'Monto habilitado de tarjetas de crédito.',
            formula: 'CRE_07 * porcen',
            nivel: 2
          },

          {
            nombre: 'Monto promedio mensual de desembolso de tarjetas de crédito.',
            calculo: 'Monto de desembolso de tarjetas de crédito desde el 1 de enero al cierre del mes / Número de mes.',
            formula: 'CRE_08 / varTemp',
            nivel: 1
          },
          {
            nombre: 'Monto de desembolso de tarjetas de crédito desde el 1 de enero al cierre del mes.',
            calculo: 'Monto de desembolso de tarjetas de crédito desde el 1 de enero al cierre del mes.',
            formula: 'CRE_08',
            nivel: 2
          },
          {
            nombre: 'Número de mes.',
            calculo: 'Número de mes.',
            formula: 'varTemp',
            nivel: 2
          },
        ]
        return idsBal7 ?? undefined;
      case 12:
        const idsBal12 = [
          {
            nombre: 'Créditos vigentes por empleado',
            calculo: 'Número de créditos vigentes / Número total de empleados',
            formula: 'numeroCreditosVigentes / V06',
            nivel: 1
          },
          {
            nombre: 'Número de créditos vigentes',
            calculo: 'Número de créditos vigentes',
            formula: 'numeroCreditosVigentes',
            nivel: 2
          },
          {
            nombre: 'Número total de empleados',
            calculo: 'Número total de empleados',
            formula: 'V06',
            nivel: 2
          },
          
          {
            nombre: 'Número promedio mensual de créditos desembolsados',
            calculo: 'Número de créditos desembolsados en el año / Mes del año',
            formula: 'numeroCreditosDesembolsadosEnAnio / mes',
            nivel: 1
          },
          {
            nombre: 'Número de créditos desembolsados en el año',
            calculo: 'Número de créditos desembolsados en el año',
            formula: 'numeroCreditosDesembolsadosEnAnio',
            nivel: 2
          },
          {
            nombre: 'Mes del año',
            calculo: 'Mes del año',
            formula: 'mes',
            nivel: 2
          },
          
          {
            nombre: 'Número promedio diario de créditos desembolsados.',
            calculo: 'Número promedio mensual de créditos desembolsados / N° de días promedio de trabajo por mes',
            formula: 'numeroCreditosDesembolsadosEnAnio / mes / V07',
            nivel: 1
          },
          {
            nombre: 'Número promedio mensual de créditos desembolsados',
            calculo: 'Número promedio mensual de créditos desembolsados',
            formula: 'numeroCreditosDesembolsadosEnAnio',
            nivel: 2
          },
          {
            nombre: 'N° de días promedio de trabajo por mes',
            calculo: 'N° de días promedio de trabajo por mes',
            formula: 'mes /V07',
            nivel: 2
          },
          
          {
            nombre: 'Monto promedio mensual de crédito desembolsado',
            calculo: 'Monto créditos desembolsado en el año / Mes del año',
            formula: 'montoCreditosDesembolsadoEnAnio / mes',
            nivel: 1
          },
          {
            nombre: 'Monto créditos desembolsado en el año',
            calculo: 'Monto créditos desembolsado en el año',
            formula: 'montoCreditosDesembolsadoEnAnio',
            nivel: 2
          },
          {
            nombre: 'Mes del año',
            calculo: 'Mes del año',
            formula: 'mes',
            nivel: 2
          },

          {
            nombre: 'Costo operativo por crédito vigente',
            calculo: 'Cartera bruta sin tarjetas de crédito / Número de empleados.',
            formula: 'V06',
            nivel: 1
          },
          {
            nombre: 'Cartera bruta sin tarjetas de crédito',
            calculo: 'Cartera bruta sin tarjetas de crédito',
            formula: 'V06',
            nivel: 2
          },
          {
            nombre: 'Número de empleados',
            calculo: 'Número de empleados.',
            formula: 'V06',
            nivel: 2
          },

          {
            nombre: 'Número de socios-clientes nuevos por día',
            calculo: 'Número de socios-clientes nuevos en el año / Mes del año / N° de días promedio de trabajo por mes',
            formula: 'numeroSociosClientesNuevosEnAnio / mes / V07',
            nivel: 1
          },
          {
            nombre: 'Número de socios-clientes nuevos en el año',
            calculo: 'Número de socios-clientes nuevos en el año',
            formula: 'numeroSociosClientesNuevosEnAnio',
            nivel: 2
          },
          {
            nombre: 'Mes del año',
            calculo: 'Mes del año',
            formula: 'mes',
            nivel: 2
          },
          {
            nombre: 'N° de días promedio de trabajo por mes',
            calculo: 'N° de días promedio de trabajo por mes',
            formula: 'V07',
            nivel: 2
          },
        ]
        return idsBal12 ?? undefined;
    }
    return undefined;
  }
  static variablesAT(idInst){
    switch(idInst){
      case 12: 
        return ['V06', 'V07']
      default: 
       return null;
    }
      

  }
}

export class coberturaFinanciero{
  static cuentasCobertura(plantilla){
    switch(plantilla){
      case 7: 
        const consultas = {
          cuentas: [],
          varTemp: ['VT011', 'VT040', 'VT004', 'VT049', 'VT038'],
          var: [],
        }
        return consultas;
      case 12: 
        const consultas2 = {
          cuentas: ['A1200102', 'A109', 'I6010102'],
          varTemp: ['VT11', 'VT21', 'VT12'],
          var: ['V01'],
        }
        return consultas2;
    }
    return undefined;
  }
  static encabezados(plantilla){
    var enc = [];
    switch(plantilla){
      case 7: 
        enc = [
          {nombre: "Patrimonio computable",nivel: 1,monto: undefined,porcentaje: undefined, total: 'VT011 - VT040'},
          {nombre: "Patrimonio efectivo",nivel: 2,monto: 'VT011',porcentaje: undefined, total: undefined},
          {nombre: "(-) Activos diferidos e intangibles",nivel: 2,monto: 'VT040',porcentaje: undefined, total: undefined},
          {nombre: "÷ Requerimiento de capital total",nivel: 1,monto: undefined,porcentaje: undefined, total: '-'},
          {nombre: "Requerimiento de capital por riesgo de crédito",nivel: 1,monto: undefined,porcentaje: undefined, total: undefined},
          {nombre: "Activos ponderados por riesgo",nivel: 2,monto: 'VT004',porcentaje: 8, total: 'VT004 * porcentaje'}, // nombre vt21
          {nombre: "Requerimiento de capital por riesgo de mercado",nivel: 1,porcentaje: undefined},
          {nombre: "Activos ponderados por riesgo",nivel: 2,monto: 'VT004',porcentaje: 2.4, total: 'VT004 * porcentaje'}, // nombre vt21
          {nombre: "Requerimiento de capital por riesgo operativo",nivel: 1,porcentaje: undefined},
          {nombre: "Ingreso financiero",nivel: 2,monto: 'VT049 - VT038',porcentaje: undefined}, 
          {nombre: "Promedio de ingresos",nivel: 3,monto: 'promedio',porcentaje: 15, total: 'monto * porcentaje'},     
        ]
        return enc;
      case 12: 
        enc = [
          {nombre: "Patrimonio computable",nivel: 1,monto: undefined,porcentaje: undefined, total: 'VT11 - A109 - A1200102 - V01'},
          {nombre: "Patrimonio",nivel: 2,monto: 'VT11',porcentaje: undefined, total: undefined},
          {nombre: "(+ -) Déficit o superávit de estimaciones",nivel: 2,monto: '-A1200102 - V01',porcentaje: undefined, total: undefined},
          {nombre: "(-) Cargos diferidos",nivel: 2,monto: 'A109',porcentaje: undefined, total: undefined},
          {nombre: "÷ Requerimiento de capital total",nivel: 1,monto: undefined,porcentaje: undefined, total: '-'},
          {nombre: "Requerimiento de capital por riesgo de crédito",nivel: 1,monto: undefined,porcentaje: undefined, total: undefined},
          {nombre: "Activos ponderados por riesgo",nivel: 2,monto: 'VT21',porcentaje: 10, total: 'VT21 * porcentaje'}, // nombre vt21
          {nombre: "Requerimiento de capital por riesgo de mercado",nivel: 1,porcentaje: undefined},
          {nombre: "Activos ponderados por riesgo",nivel: 2,monto: 'VT21',porcentaje: 3, total: 'VT21 * porcentaje'}, // nombre vt21
          {nombre: "Requerimiento de capital por riesgo operativo",nivel: 1,porcentaje: undefined},
          {nombre: "Ingreso financiero",nivel: 2,monto: 'VT12 + I6010102',porcentaje: undefined}, 
          {nombre: "Promedio de ingresos",nivel: 3,monto: 'promedio',porcentaje: 15, total: 'monto * porcentaje'},          
        ]
        return enc;
    }
    return undefined;
  }
  static capitalizacionRiesgosPorcentaje(plantilla){
    var p =  [
      
    ]
  }
}

export class obtenerCodigoPropio{
  static idsCodigoPropio(idPlantilla: number, id:string){
    switch(idPlantilla){
      case 13:
        const ids = {
          'A1':               {codigo: '1', moneda: ''},
          'A101':             {codigo: '101', moneda: ''},
          'A1011':            {codigo: '1011', moneda: 'MN'},
          'A101101':          {codigo: '101101', moneda: 'MN'},
          'A10110101':        {codigo: '101101.01', moneda: 'MN'},
          'A10110102':        {codigo: '101101.02', moneda: 'MN'},
          'A10110103':        {codigo: '101101.03', moneda: 'MN'},
          'A10110104':        {codigo: '101101.04', moneda: 'MN'},
          'A101102':          {codigo: '101102', moneda: 'MN'},
          'A101103':          {codigo: '101103', moneda: 'MN'},
          'A10110301':        {codigo: '101103.01', moneda: 'MN'},
          'A10110302':        {codigo: '101103.02', moneda: 'MN'},
          'A1011030298':      {codigo: '101103.0298', moneda: 'MN'},
          'A1011030299':      {codigo: '101103.0299', moneda: 'MN'},
          'A1012':            {codigo: '1012', moneda: 'ME'},
          'A101201':          {codigo: '101201', moneda: 'ME'},
          'A10120101':        {codigo: '101201.01', moneda: 'ME'},
          'A10120102':        {codigo: '101201.02', moneda: 'ME'},
          'A10120104':        {codigo: '101201.04', moneda: 'ME'},
          'A101202':          {codigo: '101202', moneda: 'ME'},
          'A101203':          {codigo: '101203', moneda: 'ME'},
          'A10120301':        {codigo: '101203.01', moneda: 'ME'},
          'A10120302':        {codigo: '101203.02', moneda: 'ME'},
          'A1012030298':      {codigo: '101203.0298', moneda: 'ME'},
          'A1012030299':      {codigo: '101203.0299', moneda: 'ME'},
          'A102':             {codigo: '102', moneda: ''},
          'A1021':            {codigo: '1021', moneda: 'MN'},
          'A102101':          {codigo: '102101', moneda: 'MN'},
          'A10210102':        {codigo: '102101.02', moneda: 'MN'},
          'A1021010201':      {codigo: '102101.0201', moneda: 'MN'},
          'A1021010202':      {codigo: '102101.0202', moneda: 'MN'},
          'A10210104':        {codigo: '102101.04', moneda: 'MN'},
          'A1021010401':      {codigo: '102101.0401', moneda: 'MN'},
          'A1021010402':      {codigo: '102101.0402', moneda: 'MN'},
          'A1021010499':      {codigo: '102101.0499', moneda: 'MN'},
          'A10210105':        {codigo: '102101.05', moneda: 'MN'},
          'A1021010501':      {codigo: '102101.0501', moneda: 'MN'},
          'A1021010502':      {codigo: '102101.0502', moneda: 'MN'},
          'A1021010599':      {codigo: '102101.0599', moneda: 'MN'},
          'A102102':          {codigo: '102102', moneda: 'MN'},
          'A10210201':        {codigo: '102102.01', moneda: 'MN'},
          'A1021020101':      {codigo: '102102.0101', moneda: 'MN'},
          'A102102010101':    {codigo: '102102.010101', moneda: 'MN'},
          'A10210201010101':  {codigo: '102102.01010101', moneda: 'MN'},
          'A10210201010102':  {codigo: '102102.01010102', moneda: 'MN'},
          'A10210201010103':  {codigo: '102102.01010103', moneda: 'MN'},
          'A10210201010104':  {codigo: '102102.01010104', moneda: 'MN'},
          'A102102010102':    {codigo: '102102.010102', moneda: 'MN'},
          'A10210201010201':  {codigo: '102102.01010201', moneda: 'MN'},
          'A10210201010202':  {codigo: '102102.01010202', moneda: 'MN'},
          'A10210201010203':  {codigo: '102102.01010203', moneda: 'MN'},
          'A10210201010204':  {codigo: '102102.01010204', moneda: 'MN'},
          'A1021020102':      {codigo: '102102.0102', moneda: 'MN'},
          'A102102010201':    {codigo: '102102.010201', moneda: 'MN'},
          'A10210201020101':  {codigo: '102102.01020101', moneda: 'MN'},
          'A10210201020102':  {codigo: '102102.01020102', moneda: 'MN'},
          'A10210201020103':  {codigo: '102102.01020103', moneda: 'MN'},
          'A10210201020104':  {codigo: '102102.01020304', moneda: 'MN'},
          'A1022':            {codigo: '1022', moneda: 'ME'},
          'A102201':          {codigo: '102201', moneda: 'ME'},
          'A10220102':        {codigo: '102201.02', moneda: 'ME'},
          'A1022010201':      {codigo: '102201.0201', moneda: 'ME'},
          'A1022010202':      {codigo: '102201.0202', moneda: 'ME'},
          'A10220104':        {codigo: '102201.04', moneda: 'ME'},
          'A1022010401':      {codigo: '102201.0401', moneda: 'ME'},
          'A1022010402':      {codigo: '102201.0402', moneda: 'ME'},
          'A1022010499':      {codigo: '102201.0499', moneda: 'ME'},
          'A10220105':        {codigo: '102201.05', moneda: 'ME'},
          'A1022010501':      {codigo: '102201.0501', moneda: 'ME'},
          'A1022010502':      {codigo: '102201.0502', moneda: 'ME'},
          'A1022010599':      {codigo: '102201.0599', moneda: 'ME'},
          'A102202':          {codigo: '102202', moneda: 'ME'},
          'A10220201':        {codigo: '102202.01', moneda: 'ME'},
          'A1022020101':      {codigo: '102202.0101', moneda: 'ME'},
          'A102202010101':    {codigo: '102202.010101', moneda: 'ME'},
          'A10220201010101':  {codigo: '102202.01010101', moneda: 'ME'},
          'A10220201010102':  {codigo: '102202.01010102', moneda: 'ME'},
          'A10220201010103':  {codigo: '102202.01010103', moneda: 'ME'},
          'A10220201010104':  {codigo: '102202.01010104', moneda: 'ME'},
          'A102202010102':    {codigo: '102202.010102', moneda: 'ME'},
          'A10220201010201':  {codigo: '102202.01010201', moneda: 'ME'},
          'A10220201010202':  {codigo: '102202.01010202', moneda: 'ME'},
          'A10220201010203':  {codigo: '102202.01010203', moneda: 'ME'},
          'A10220201010204':  {codigo: '102202.01010204', moneda: 'ME'},
          'A1022020102':      {codigo: '102202.0102', moneda: 'ME'},
          'A102202010201':    {codigo: '102202.010201', moneda: 'ME'},
          'A10220201020101':  {codigo: '102202.01020101', moneda: 'ME'},
          'A10220201020102':  {codigo: '102202.01020102', moneda: 'ME'},
          'A10220201020103':  {codigo: '102202.01020103', moneda: 'ME'},
          'A10220201020104':  {codigo: '102202.01020104', moneda: 'ME'},
          'A103':             {codigo: '103', moneda: ''},
          'A1031':            {codigo: '1031', moneda: 'MN'},
          'A103101':          {codigo: '103101', moneda: 'MN'},
          'A10310105':        {codigo: '103101.05', moneda: 'MN'},
          'A1031010501':      {codigo: '103101.0501', moneda: 'MN'},
          'A1031010502':      {codigo: '103101.0502', moneda: 'MN'},
          'A1031010503':      {codigo: '103101.0503', moneda: 'MN'},
          'A1031010504':      {codigo: '103101.0504', moneda: 'MN'},
          'A1031010505':      {codigo: '103101.0505', moneda: 'MN'},
          'A10310106':        {codigo: '103101.06', moneda: 'MN'},
          'A1031010601':      {codigo: '103101.0601', moneda: 'MN'},
          'A1031010602':      {codigo: '103101.0602', moneda: 'MN'},
          'A1031010603':      {codigo: '103101.0603', moneda: 'MN'},
          'A1031010604':      {codigo: '103101.0604', moneda: 'MN'},
          'A1031010605':      {codigo: '103101.0605', moneda: 'MN'},
          'A10310107':        {codigo: '103101.07', moneda: 'MN'},
          'A1031010701':      {codigo: '103101.0701', moneda: 'MN'},
          'A1031010702':      {codigo: '103101.0702', moneda: 'MN'},
          'A1031010703':      {codigo: '103101.0703', moneda: 'MN'},
          'A1031010704':      {codigo: '103101.0704', moneda: 'MN'},
          'A1031010705':      {codigo: '103101.0705', moneda: 'MN'},
          'A10310110':        {codigo: '103101.1', moneda: 'MN'},
          'A1031011001':      {codigo: '103101.1001', moneda: 'MN'},
          'A1031011002':      {codigo: '103101.1002', moneda: 'MN'},
          'A1031011003':      {codigo: '103101.1003', moneda: 'MN'},
          'A1031011004':      {codigo: '103101.1004', moneda: 'MN'},
          'A1031011005':      {codigo: '103101.1005', moneda: 'MN'},
          'A10310111':        {codigo: '103101.11', moneda: 'MN'},
          'A1031011101':      {codigo: '103101.1101', moneda: 'MN'},
          'A1031011102':      {codigo: '103101.1102', moneda: 'MN'},
          'A1031011103':      {codigo: '103101.1103', moneda: 'MN'},
          'A1031011104':      {codigo: '103101.1104', moneda: 'MN'},
          'A1031011105':      {codigo: '103101.1105', moneda: 'MN'},
          'A10310112':        {codigo: '103101.12', moneda: 'MN'},
          'A1031011201':      {codigo: '103101.1201', moneda: 'MN'},
          'A1031011202':      {codigo: '103101.1202', moneda: 'MN'},
          'A1031011203':      {codigo: '103101.1203', moneda: 'MN'},
          'A1031011204':      {codigo: '103101.1204', moneda: 'MN'},
          'A1031011205':      {codigo: '103101.1205', moneda: 'MN'},
          'A10310113':        {codigo: '103101.13', moneda: 'MN'},
          'A1031011301':      {codigo: '103101.1301', moneda: 'MN'},
          'A1031011302':      {codigo: '103101.1302', moneda: 'MN'},
          'A1031011303':      {codigo: '103101.1303', moneda: 'MN'},
          'A1031011304':      {codigo: '103101.1304', moneda: 'MN'},
          'A1031011305':      {codigo: '103101.1305', moneda: 'MN'},
          'A10310114':        {codigo: '103101.14', moneda: 'MN'},
          'A10310117':        {codigo: '103101.17', moneda: 'MN'},
          'A1031011701':      {codigo: '103101.1701', moneda: 'MN'},
          'A1031011799':      {codigo: '103101.1799', moneda: 'MN'},
          'A10310118':        {codigo: '103101.18', moneda: 'MN'},
          'A1031011801':      {codigo: '103101.1801', moneda: 'MN'},
          'A1031011802':      {codigo: '103101.1802', moneda: 'MN'},
          'A1031011803':      {codigo: '103101.1803', moneda: 'MN'},
          'A1031011804':      {codigo: '103101.1804', moneda: 'MN'},
          'A1031011899':      {codigo: '103101.1899', moneda: 'MN'},
          'A10310125':        {codigo: '103101.25', moneda: 'MN'},
          'A1031012501':      {codigo: '103101.2501', moneda: 'MN'},
          'A1031012502':      {codigo: '103101.2502', moneda: 'MN'},
          'A1031012503':      {codigo: '103101.2503', moneda: 'MN'},
          'A1031012504':      {codigo: '103101.2504', moneda: 'MN'},
          'A1031012505':      {codigo: '103101.2505', moneda: 'MN'},
          'A10310126':        {codigo: '103101.26', moneda: 'MN'},
          'A1031012601':      {codigo: '103101.2601', moneda: 'MN'},
          'A1031012602':      {codigo: '103101.2602', moneda: 'MN'},
          'A1031012603':      {codigo: '103101.2603', moneda: 'MN'},
          'A1031012604':      {codigo: '103101.2604', moneda: 'MN'},
          'A1031012605':      {codigo: '103101.2605', moneda: 'MN'},
          'A103102':          {codigo: '103102', moneda: 'MN'},
          'A10310205':        {codigo: '103102.05', moneda: 'MN'},
          'A1031020501':      {codigo: '103102.0501', moneda: 'MN'},
          'A1031020502':      {codigo: '103102.0502', moneda: 'MN'},
          'A1031020503':      {codigo: '103102.0503', moneda: 'MN'},
          'A1031020504':      {codigo: '103102.0504', moneda: 'MN'},
          'A1031020505':      {codigo: '103102.0505', moneda: 'MN'},
          'A10310206':        {codigo: '103102.06', moneda: 'MN'},
          'A1031020601':      {codigo: '103102.0601', moneda: 'MN'},
          'A1031020602':      {codigo: '103102.0602', moneda: 'MN'},
          'A1031020603':      {codigo: '103102.0603', moneda: 'MN'},
          'A1031020604':      {codigo: '103102.0604', moneda: 'MN'},
          'A1031020605':      {codigo: '103102.0605', moneda: 'MN'},
          'A10310207':        {codigo: '103102.07', moneda: 'MN'},
          'A1031020701':      {codigo: '103102.0701', moneda: 'MN'},
          'A1031020702':      {codigo: '103102.0702', moneda: 'MN'},
          'A1031020703':      {codigo: '103102.0703', moneda: 'MN'},
          'A1031020704':      {codigo: '103102.0704', moneda: 'MN'},
          'A1031020705':      {codigo: '103102.0705', moneda: 'MN'},
          'A10310210':        {codigo: '103102.1', moneda: 'MN'},
          'A1031021001':      {codigo: '103102.1001', moneda: 'MN'},
          'A1031021002':      {codigo: '103102.1002', moneda: 'MN'},
          'A1031021003':      {codigo: '103102.1003', moneda: 'MN'},
          'A1031021004':      {codigo: '103102.1004', moneda: 'MN'},
          'A1031021005':      {codigo: '103102.1005', moneda: 'MN'},
          'A10310211':        {codigo: '103102.11', moneda: 'MN'},
          'A1031021101':      {codigo: '103102.1101', moneda: 'MN'},
          'A1031021102':      {codigo: '103102.1102', moneda: 'MN'},
          'A1031021103':      {codigo: '103102.1103', moneda: 'MN'},
          'A1031021104':      {codigo: '103102.1104', moneda: 'MN'},
          'A1031021105':      {codigo: '103102.1105', moneda: 'MN'},
          'A10310212':        {codigo: '103102.12', moneda: 'MN'},
          'A1031021201':      {codigo: '103102.1201', moneda: 'MN'},
          'A1031021202':      {codigo: '103102.1202', moneda: 'MN'},
          'A1031021203':      {codigo: '103102.1203', moneda: 'MN'},
          'A1031021204':      {codigo: '103102.1204', moneda: 'MN'},
          'A1031021205':      {codigo: '103102.1205', moneda: 'MN'},
          'A10310213':        {codigo: '103102.13', moneda: 'MN'},
          'A1031021301':      {codigo: '103102.1301', moneda: 'MN'},
          'A1031021302':      {codigo: '103102.1302', moneda: 'MN'},
          'A1031021303':      {codigo: '103102.1303', moneda: 'MN'},
          'A1031021304':      {codigo: '103102.1304', moneda: 'MN'},
          'A1031021305':      {codigo: '103102.1305', moneda: 'MN'},
          'A10310214':        {codigo: '103102.14', moneda: 'MN'},
          'A10310217':        {codigo: '103102.17', moneda: 'MN'},
          'A1031021701':      {codigo: '103102.1701', moneda: 'MN'},
          'A1031021799':      {codigo: '103102.1799', moneda: 'MN'},
          'A10310218':        {codigo: '103102.18', moneda: 'MN'},
          'A1031021801':      {codigo: '103102.1801', moneda: 'MN'},
          'A1031021802':      {codigo: '103102.1802', moneda: 'MN'},
          'A1031021803':      {codigo: '103102.1803', moneda: 'MN'},
          'A1031021804':      {codigo: '103102.1804', moneda: 'MN'},
          'A1031021899':      {codigo: '103102.1899', moneda: 'MN'},
          'A10310225':        {codigo: '103102.25', moneda: 'MN'},
          'A1031022501':      {codigo: '103102.2501', moneda: 'MN'},
          'A1031022502':      {codigo: '103102.2502', moneda: 'MN'},
          'A1031022503':      {codigo: '103102.2503', moneda: 'MN'},
          'A1031022504':      {codigo: '103102.2504', moneda: 'MN'},
          'A1031022505':      {codigo: '103102.2505', moneda: 'MN'},
          'A10310226':        {codigo: '103102.26', moneda: 'MN'},
          'A1031022601':      {codigo: '103102.2601', moneda: 'MN'},
          'A1031022602':      {codigo: '103102.2602', moneda: 'MN'},
          'A1031022603':      {codigo: '103102.2603', moneda: 'MN'},
          'A1031022604':      {codigo: '103102.2604', moneda: 'MN'},
          'A1031022605':      {codigo: '103102.2605', moneda: 'MN'},
          'A103103':          {codigo: '103103', moneda: 'MN'},
          'A10310305':        {codigo: '103103.05', moneda: 'MN'},
          'A1031030501':      {codigo: '103103.0501', moneda: 'MN'},
          'A1031030502':      {codigo: '103103.0502', moneda: 'MN'},
          'A1031030503':      {codigo: '103103.0503', moneda: 'MN'},
          'A1031030504':      {codigo: '103103.0504', moneda: 'MN'},
          'A1031030505':      {codigo: '103103.0505', moneda: 'MN'},
          'A10310306':        {codigo: '103103.06', moneda: 'MN'},
          'A1031030601':      {codigo: '103103.0601', moneda: 'MN'},
          'A1031030602':      {codigo: '103103.0602', moneda: 'MN'},
          'A1031030603':      {codigo: '103103.0603', moneda: 'MN'},
          'A1031030604':      {codigo: '103103.0604', moneda: 'MN'},
          'A1031030605':      {codigo: '103103.0605', moneda: 'MN'},
          'A10310307':        {codigo: '103103.07', moneda: 'MN'},
          'A1031030701':      {codigo: '103103.0701', moneda: 'MN'},
          'A1031030702':      {codigo: '103103.0702', moneda: 'MN'},
          'A1031030703':      {codigo: '103103.0703', moneda: 'MN'},
          'A1031030704':      {codigo: '103103.0704', moneda: 'MN'},
          'A1031030705':      {codigo: '103103.0705', moneda: 'MN'},
          'A10310310':        {codigo: '103103.1', moneda: 'MN'},
          'A1031031001':      {codigo: '103103.1001', moneda: 'MN'},
          'A1031031002':      {codigo: '103103.1002', moneda: 'MN'},
          'A1031031003':      {codigo: '103103.1003', moneda: 'MN'},
          'A1031031004':      {codigo: '103103.1004', moneda: 'MN'},
          'A1031031005':      {codigo: '103103.1005', moneda: 'MN'},
          'A10310311':        {codigo: '103103.11', moneda: 'MN'},
          'A1031031101':      {codigo: '103103.1101', moneda: 'MN'},
          'A1031031102':      {codigo: '103103.1102', moneda: 'MN'},
          'A1031031103':      {codigo: '103103.1103', moneda: 'MN'},
          'A1031031104':      {codigo: '103103.1104', moneda: 'MN'},
          'A1031031105':      {codigo: '103103.1105', moneda: 'MN'},
          'A10310312':        {codigo: '103103.12', moneda: 'MN'},
          'A1031031201':      {codigo: '103103.1201', moneda: 'MN'},
          'A1031031202':      {codigo: '103103.1202', moneda: 'MN'},
          'A1031031203':      {codigo: '103103.1203', moneda: 'MN'},
          'A1031031204':      {codigo: '103103.1204', moneda: 'MN'},
          'A1031031205':      {codigo: '103103.1205', moneda: 'MN'},
          'A10310313':        {codigo: '103103.13', moneda: 'MN'},
          'A1031031301':      {codigo: '103103.1301', moneda: 'MN'},
          'A1031031302':      {codigo: '103103.1302', moneda: 'MN'},
          'A1031031303':      {codigo: '103103.1303', moneda: 'MN'},
          'A1031031304':      {codigo: '103103.1304', moneda: 'MN'},
          'A1031031305':      {codigo: '103103.1305', moneda: 'MN'},
          'A10310314':        {codigo: '103103.14', moneda: 'MN'},
          'A10310317':        {codigo: '103103.17', moneda: 'MN'},
          'A1031031701':      {codigo: '103103.1701', moneda: 'MN'},
          'A1031031799':      {codigo: '103103.1799', moneda: 'MN'},
          'A10310318':        {codigo: '103103.18', moneda: 'MN'},
          'A1031031801':      {codigo: '103103.1801', moneda: 'MN'},
          'A1031031802':      {codigo: '103103.1802', moneda: 'MN'},
          'A1031031803':      {codigo: '103103.1803', moneda: 'MN'},
          'A1031031804':      {codigo: '103103.1804', moneda: 'MN'},
          'A1031031899':      {codigo: '103103.1899', moneda: 'MN'},
          'A10310325':        {codigo: '103103.25', moneda: 'MN'},
          'A1031032501':      {codigo: '103103.2501', moneda: 'MN'},
          'A1031032502':      {codigo: '103103.2502', moneda: 'MN'},
          'A1031032503':      {codigo: '103103.2503', moneda: 'MN'},
          'A1031032504':      {codigo: '103103.2504', moneda: 'MN'},
          'A1031032505':      {codigo: '103103.2505', moneda: 'MN'},
          'A10310326':        {codigo: '103103.26', moneda: 'MN'},
          'A1031032601':      {codigo: '103103.2601', moneda: 'MN'},
          'A1031032602':      {codigo: '103103.2602', moneda: 'MN'},
          'A1031032603':      {codigo: '103103.2603', moneda: 'MN'},
          'A1031032604':      {codigo: '103103.2604', moneda: 'MN'},
          'A1031032605':      {codigo: '103103.2605', moneda: 'MN'},
          'A103104':          {codigo: '103104', moneda: 'MN'},
          'A10310405':        {codigo: '103104.05', moneda: 'MN'},
          'A1031040501':      {codigo: '103104.0501', moneda: 'MN'},
          'A1031040502':      {codigo: '103104.0502', moneda: 'MN'},
          'A1031040503':      {codigo: '103104.0503', moneda: 'MN'},
          'A1031040504':      {codigo: '103104.0504', moneda: 'MN'},
          'A1031040505':      {codigo: '103104.0505', moneda: 'MN'},
          'A10310406':        {codigo: '103104.06', moneda: 'MN'},
          'A1031040601':      {codigo: '103104.0601', moneda: 'MN'},
          'A1031040602':      {codigo: '103104.0602', moneda: 'MN'},
          'A1031040603':      {codigo: '103104.0603', moneda: 'MN'},
          'A1031040604':      {codigo: '103104.0604', moneda: 'MN'},
          'A1031040605':      {codigo: '103104.0605', moneda: 'MN'},
          'A10310407':        {codigo: '103104.07', moneda: 'MN'},
          'A1031040701':      {codigo: '103104.0701', moneda: 'MN'},
          'A1031040702':      {codigo: '103104.0702', moneda: 'MN'},
          'A1031040703':      {codigo: '103104.0703', moneda: 'MN'},
          'A1031040704':      {codigo: '103104.0704', moneda: 'MN'},
          'A1031040705':      {codigo: '103104.0705', moneda: 'MN'},
          'A10310410':        {codigo: '103104.1', moneda: 'MN'},
          'A1031041001':      {codigo: '103104.1001', moneda: 'MN'},
          'A1031041002':      {codigo: '103104.1002', moneda: 'MN'},
          'A1031041003':      {codigo: '103104.1003', moneda: 'MN'},
          'A1031041004':      {codigo: '103104.1004', moneda: 'MN'},
          'A1031041005':      {codigo: '103104.1005', moneda: 'MN'},
          'A10310411':        {codigo: '103104.11', moneda: 'MN'},
          'A1031041101':      {codigo: '103104.1101', moneda: 'MN'},
          'A1031041102':      {codigo: '103104.1102', moneda: 'MN'},
          'A1031041103':      {codigo: '103104.1103', moneda: 'MN'},
          'A1031041104':      {codigo: '103104.1104', moneda: 'MN'},
          'A1031041105':      {codigo: '103104.1105', moneda: 'MN'},
          'A10310412':        {codigo: '103104.12', moneda: 'MN'},
          'A1031041201':      {codigo: '103104.1201', moneda: 'MN'},
          'A1031041202':      {codigo: '103104.1202', moneda: 'MN'},
          'A1031041203':      {codigo: '103104.1203', moneda: 'MN'},
          'A1031041204':      {codigo: '103104.1204', moneda: 'MN'},
          'A1031041205':      {codigo: '103104.1205', moneda: 'MN'},
          'A10310413':        {codigo: '103104.13', moneda: 'MN'},
          'A1031041301':      {codigo: '103104.1301', moneda: 'MN'},
          'A1031041302':      {codigo: '103104.1302', moneda: 'MN'},
          'A1031041303':      {codigo: '103104.1303', moneda: 'MN'},
          'A1031041304':      {codigo: '103104.1304', moneda: 'MN'},
          'A1031041305':      {codigo: '103104.1305', moneda: 'MN'},
          'A10310414':        {codigo: '103104.14', moneda: 'MN'},
          'A10310417':        {codigo: '103104.17', moneda: 'MN'},
          'A1031041701':      {codigo: '103104.1701', moneda: 'MN'},
          'A1031041799':      {codigo: '103104.1799', moneda: 'MN'},
          'A10310418':        {codigo: '103104.18', moneda: 'MN'},
          'A1031041801':      {codigo: '103104.1801', moneda: 'MN'},
          'A1031041802':      {codigo: '103104.1802', moneda: 'MN'},
          'A1031041803':      {codigo: '103104.1803', moneda: 'MN'},
          'A1031041804':      {codigo: '103104.1804', moneda: 'MN'},
          'A1031041899':      {codigo: '103104.1899', moneda: 'MN'},
          'A10310425':        {codigo: '103104.25', moneda: 'MN'},
          'A1031042501':      {codigo: '103104.2501', moneda: 'MN'},
          'A1031042502':      {codigo: '103104.2502', moneda: 'MN'},
          'A1031042503':      {codigo: '103104.2503', moneda: 'MN'},
          'A1031042504':      {codigo: '103104.2504', moneda: 'MN'},
          'A1031042505':      {codigo: '103104.2505', moneda: 'MN'},
          'A10310426':        {codigo: '103104.26', moneda: 'MN'},
          'A1031042601':      {codigo: '103104.2601', moneda: 'MN'},
          'A1031042602':      {codigo: '103104.2602', moneda: 'MN'},
          'A1031042603':      {codigo: '103104.2603', moneda: 'MN'},
          'A1031042604':      {codigo: '103104.2604', moneda: 'MN'},
          'A1031042605':      {codigo: '103104.2605', moneda: 'MN'},
          'A1032':            {codigo: '1032', moneda: 'ME'},
          'A103201':          {codigo: '103201', moneda: 'ME'},
          'A10320105':        {codigo: '103201.05', moneda: 'ME'},
          'A1032010501':      {codigo: '103201.0501', moneda: 'ME'},
          'A1032010502':      {codigo: '103201.0502', moneda: 'ME'},
          'A1032010503':      {codigo: '103201.0503', moneda: 'ME'},
          'A1032010504':      {codigo: '103201.0504', moneda: 'ME'},
          'A1032010505':      {codigo: '103201.0505', moneda: 'ME'},
          'A10320106':        {codigo: '103201.06', moneda: 'ME'},
          'A1032010601':      {codigo: '103201.0601', moneda: 'ME'},
          'A1032010602':      {codigo: '103201.0602', moneda: 'ME'},
          'A1032010603':      {codigo: '103201.0603', moneda: 'ME'},
          'A1032010604':      {codigo: '103201.0604', moneda: 'ME'},
          'A1032010605':      {codigo: '103201.0605', moneda: 'ME'},
          'A10320107':        {codigo: '103201.07', moneda: 'ME'},
          'A1032010701':      {codigo: '103201.0701', moneda: 'ME'},
          'A1032010702':      {codigo: '103201.0702', moneda: 'ME'},
          'A1032010703':      {codigo: '103201.0703', moneda: 'ME'},
          'A1032010704':      {codigo: '103201.0704', moneda: 'ME'},
          'A1032010705':      {codigo: '103201.0705', moneda: 'ME'},
          'A10320110':        {codigo: '103201.1', moneda: 'ME'},
          'A1032011001':      {codigo: '103201.1001', moneda: 'ME'},
          'A1032011002':      {codigo: '103201.1002', moneda: 'ME'},
          'A1032011003':      {codigo: '103201.1003', moneda: 'ME'},
          'A1032011004':      {codigo: '103201.1004', moneda: 'ME'},
          'A1032011005':      {codigo: '103201.1005', moneda: 'ME'},
          'A10320111':        {codigo: '103201.11', moneda: 'ME'},
          'A1032011101':      {codigo: '103201.1101', moneda: 'ME'},
          'A1032011102':      {codigo: '103201.1102', moneda: 'ME'},
          'A1032011103':      {codigo: '103201.1103', moneda: 'ME'},
          'A1032011104':      {codigo: '103201.1104', moneda: 'ME'},
          'A1032011105':      {codigo: '103201.1105', moneda: 'ME'},
          'A10320112':        {codigo: '103201.12', moneda: 'ME'},
          'A1032011201':      {codigo: '103201.1201', moneda: 'ME'},
          'A1032011202':      {codigo: '103201.1202', moneda: 'ME'},
          'A1032011203':      {codigo: '103201.1203', moneda: 'ME'},
          'A1032011204':      {codigo: '103201.1204', moneda: 'ME'},
          'A1032011205':      {codigo: '103201.1205', moneda: 'ME'},
          'A10320113':        {codigo: '103201.13', moneda: 'ME'},
          'A1032011301':      {codigo: '103201.1301', moneda: 'ME'},
          'A1032011302':      {codigo: '103201.1302', moneda: 'ME'},
          'A1032011303':      {codigo: '103201.1303', moneda: 'ME'},
          'A1032011304':      {codigo: '103201.1304', moneda: 'ME'},
          'A1032011305':      {codigo: '103201.1305', moneda: 'ME'},
          'A10320114':        {codigo: '103201.14', moneda: 'ME'},
          'A10320117':        {codigo: '103201.17', moneda: 'ME'},
          'A1032011701':      {codigo: '103201.1701', moneda: 'ME'},
          'A1032011799':      {codigo: '103201.1799', moneda: 'ME'},
          'A10320118':        {codigo: '103201.18', moneda: 'ME'},
          'A1032011801':      {codigo: '103201.1801', moneda: 'ME'},
          'A1032011802':      {codigo: '103201.1802', moneda: 'ME'},
          'A1032011803':      {codigo: '103201.1803', moneda: 'ME'},
          'A1032011804':      {codigo: '103201.1804', moneda: 'ME'},
          'A1032011899':      {codigo: '103201.1899', moneda: 'ME'},
          'A10320125':        {codigo: '103201.25', moneda: 'ME'},
          'A1032012501':      {codigo: '103201.2501', moneda: 'ME'},
          'A1032012502':      {codigo: '103201.2502', moneda: 'ME'},
          'A1032012503':      {codigo: '103201.2503', moneda: 'ME'},
          'A1032012504':      {codigo: '103201.2504', moneda: 'ME'},
          'A1032012505':      {codigo: '103201.2505', moneda: 'ME'},
          'A10320126':        {codigo: '103201.26', moneda: 'ME'},
          'A1032012601':      {codigo: '103201.2601', moneda: 'ME'},
          'A1032012602':      {codigo: '103201.2602', moneda: 'ME'},
          'A1032012603':      {codigo: '103201.2603', moneda: 'ME'},
          'A1032012604':      {codigo: '103201.2604', moneda: 'ME'},
          'A1032012605':      {codigo: '103201.2605', moneda: 'ME'},
          'A103202':          {codigo: '103202', moneda: 'ME'},
          'A10320205':        {codigo: '103202.05', moneda: 'ME'},
          'A1032020501':      {codigo: '103202.0501', moneda: 'ME'},
          'A1032020502':      {codigo: '103202.0502', moneda: 'ME'},
          'A1032020503':      {codigo: '103202.0503', moneda: 'ME'},
          'A1032020504':      {codigo: '103202.0504', moneda: 'ME'},
          'A1032020505':      {codigo: '103202.0505', moneda: 'ME'},
          'A10320206':        {codigo: '103202.06', moneda: 'ME'},
          'A1032020601':      {codigo: '103202.0601', moneda: 'ME'},
          'A1032020602':      {codigo: '103202.0602', moneda: 'ME'},
          'A1032020603':      {codigo: '103202.0603', moneda: 'ME'},
          'A1032020604':      {codigo: '103202.0604', moneda: 'ME'},
          'A1032020605':      {codigo: '103202.0605', moneda: 'ME'},
          'A10320207':        {codigo: '103202.07', moneda: 'ME'},
          'A1032020701':      {codigo: '103202.0701', moneda: 'ME'},
          'A1032020702':      {codigo: '103202.0702', moneda: 'ME'},
          'A1032020703':      {codigo: '103202.0703', moneda: 'ME'},
          'A1032020704':      {codigo: '103202.0704', moneda: 'ME'},
          'A1032020705':      {codigo: '103202.0705', moneda: 'ME'},
          'A10320210':        {codigo: '103202.1', moneda: 'ME'},
          'A1032021001':      {codigo: '103202.1001', moneda: 'ME'},
          'A1032021002':      {codigo: '103202.1002', moneda: 'ME'},
          'A1032021003':      {codigo: '103202.1003', moneda: 'ME'},
          'A1032021004':      {codigo: '103202.1004', moneda: 'ME'},
          'A1032021005':      {codigo: '103202.1005', moneda: 'ME'},
          'A10320211':        {codigo: '103202.11', moneda: 'ME'},
          'A1032021101':      {codigo: '103202.1101', moneda: 'ME'},
          'A1032021102':      {codigo: '103202.1102', moneda: 'ME'},
          'A1032021103':      {codigo: '103202.1103', moneda: 'ME'},
          'A1032021104':      {codigo: '103202.1104', moneda: 'ME'},
          'A1032021105':      {codigo: '103202.1105', moneda: 'ME'},
          'A10320212':        {codigo: '103202.12', moneda: 'ME'},
          'A1032021201':      {codigo: '103202.1201', moneda: 'ME'},
          'A1032021202':      {codigo: '103202.1202', moneda: 'ME'},
          'A1032021203':      {codigo: '103202.1203', moneda: 'ME'},
          'A1032021204':      {codigo: '103202.1204', moneda: 'ME'},
          'A1032021205':      {codigo: '103202.1205', moneda: 'ME'},
          'A10320213':        {codigo: '103202.13', moneda: 'ME'},
          'A1032021301':      {codigo: '103202.1301', moneda: 'ME'},
          'A1032021302':      {codigo: '103202.1302', moneda: 'ME'},
          'A1032021303':      {codigo: '103202.1303', moneda: 'ME'},
          'A1032021304':      {codigo: '103202.1304', moneda: 'ME'},
          'A1032021305':      {codigo: '103202.1305', moneda: 'ME'},
          'A10320214':        {codigo: '103202.14', moneda: 'ME'},
          'A10320217':        {codigo: '103202.17', moneda: 'ME'},
          'A1032021701':      {codigo: '103202.1701', moneda: 'ME'},
          'A1032021799':      {codigo: '103202.1799', moneda: 'ME'},
          'A10320218':        {codigo: '103202.18', moneda: 'ME'},
          'A1032021801':      {codigo: '103202.1801', moneda: 'ME'},
          'A1032021802':      {codigo: '103202.1802', moneda: 'ME'},
          'A1032021803':      {codigo: '103202.1803', moneda: 'ME'},
          'A1032021804':      {codigo: '103202.1804', moneda: 'ME'},
          'A1032021899':      {codigo: '103202.1899', moneda: 'ME'},
          'A10320225':        {codigo: '103202.25', moneda: 'ME'},
          'A1032022501':      {codigo: '103202.2501', moneda: 'ME'},
          'A1032022502':      {codigo: '103202.2502', moneda: 'ME'},
          'A1032022503':      {codigo: '103202.2503', moneda: 'ME'},
          'A1032022504':      {codigo: '103202.2504', moneda: 'ME'},
          'A1032022505':      {codigo: '103202.2505', moneda: 'ME'},
          'A10320226':        {codigo: '103202.26', moneda: 'ME'},
          'A1032022601':      {codigo: '103202.2601', moneda: 'ME'},
          'A1032022602':      {codigo: '103202.2602', moneda: 'ME'},
          'A1032022603':      {codigo: '103202.2603', moneda: 'ME'},
          'A1032022604':      {codigo: '103202.2604', moneda: 'ME'},
          'A1032022605':      {codigo: '103202.2605', moneda: 'ME'},
          'A103203':          {codigo: '103203', moneda: 'ME'},
          'A10320305':        {codigo: '103203.05', moneda: 'ME'},
          'A1032030501':      {codigo: '103203.0501', moneda: 'ME'},
          'A1032030502':      {codigo: '103203.0502', moneda: 'ME'},
          'A1032030503':      {codigo: '103203.0503', moneda: 'ME'},
          'A1032030504':      {codigo: '103203.0504', moneda: 'ME'},
          'A1032030505':      {codigo: '103203.0505', moneda: 'ME'},
          'A10320306':        {codigo: '103203.06', moneda: 'ME'},
          'A1032030601':      {codigo: '103203.0601', moneda: 'ME'},
          'A1032030602':      {codigo: '103203.0602', moneda: 'ME'},
          'A1032030603':      {codigo: '103203.0603', moneda: 'ME'},
          'A1032030604':      {codigo: '103203.0604', moneda: 'ME'},
          'A1032030605':      {codigo: '103203.0605', moneda: 'ME'},
          'A10320307':        {codigo: '103203.07', moneda: 'ME'},
          'A1032030701':      {codigo: '103203.0701', moneda: 'ME'},
          'A1032030702':      {codigo: '103203.0702', moneda: 'ME'},
          'A1032030703':      {codigo: '103203.0703', moneda: 'ME'},
          'A1032030704':      {codigo: '103203.0704', moneda: 'ME'},
          'A1032030705':      {codigo: '103203.0705', moneda: 'ME'},
          'A10320310':        {codigo: '103203.1', moneda: 'ME'},
          'A1032031001':      {codigo: '103203.1001', moneda: 'ME'},
          'A1032031002':      {codigo: '103203.1002', moneda: 'ME'},
          'A1032031003':      {codigo: '103203.1003', moneda: 'ME'},
          'A1032031004':      {codigo: '103203.1004', moneda: 'ME'},
          'A1032031005':      {codigo: '103203.1005', moneda: 'ME'},
          'A10320311':        {codigo: '103203.11', moneda: 'ME'},
          'A1032031101':      {codigo: '103203.1101', moneda: 'ME'},
          'A1032031102':      {codigo: '103203.1102', moneda: 'ME'},
          'A1032031103':      {codigo: '103203.1103', moneda: 'ME'},
          'A1032031104':      {codigo: '103203.1104', moneda: 'ME'},
          'A1032031105':      {codigo: '103203.1105', moneda: 'ME'},
          'A10320312':        {codigo: '103203.12', moneda: 'ME'},
          'A1032031201':      {codigo: '103203.1201', moneda: 'ME'},
          'A1032031202':      {codigo: '103203.1202', moneda: 'ME'},
          'A1032031203':      {codigo: '103203.1203', moneda: 'ME'},
          'A1032031204':      {codigo: '103203.1204', moneda: 'ME'},
          'A1032031205':      {codigo: '103203.1205', moneda: 'ME'},
          'A10320313':        {codigo: '103203.13', moneda: 'ME'},
          'A1032031301':      {codigo: '103203.1301', moneda: 'ME'},
          'A1032031302':      {codigo: '103203.1302', moneda: 'ME'},
          'A1032031303':      {codigo: '103203.1303', moneda: 'ME'},
          'A1032031304':      {codigo: '103203.1304', moneda: 'ME'},
          'A1032031305':      {codigo: '103203.1305', moneda: 'ME'},
          'A10320314':        {codigo: '103203.14', moneda: 'ME'},
          'A10320317':        {codigo: '103203.17', moneda: 'ME'},
          'A1032031701':      {codigo: '103203.1701', moneda: 'ME'},
          'A1032031799':      {codigo: '103203.1799', moneda: 'ME'},
          'A10320318':        {codigo: '103203.18', moneda: 'ME'},
          'A1032031801':      {codigo: '103203.1801', moneda: 'ME'},
          'A1032031802':      {codigo: '103203.1802', moneda: 'ME'},
          'A1032031803':      {codigo: '103203.1803', moneda: 'ME'},
          'A1032031804':      {codigo: '103203.1804', moneda: 'ME'},
          'A1032031899':      {codigo: '103203.1899', moneda: 'ME'},
          'A10320325':        {codigo: '103203.25', moneda: 'ME'},
          'A1032032501':      {codigo: '103203.2501', moneda: 'ME'},
          'A1032032502':      {codigo: '103203.2502', moneda: 'ME'},
          'A1032032503':      {codigo: '103203.2503', moneda: 'ME'},
          'A1032032504':      {codigo: '103203.2504', moneda: 'ME'},
          'A1032032505':      {codigo: '103203.2505', moneda: 'ME'},
          'A10320326':        {codigo: '103203.26', moneda: 'ME'},
          'A1032032601':      {codigo: '103203.2601', moneda: 'ME'},
          'A1032032602':      {codigo: '103203.2602', moneda: 'ME'},
          'A1032032603':      {codigo: '103203.2603', moneda: 'ME'},
          'A1032032604':      {codigo: '103203.2604', moneda: 'ME'},
          'A1032032605':      {codigo: '103203.2605', moneda: 'ME'},
          'A103204':          {codigo: '103204', moneda: 'ME'},
          'A10320405':        {codigo: '103204.05', moneda: 'ME'},
          'A1032040501':      {codigo: '103204.0501', moneda: 'ME'},
          'A1032040502':      {codigo: '103204.0502', moneda: 'ME'},
          'A1032040503':      {codigo: '103204.0503', moneda: 'ME'},
          'A1032040504':      {codigo: '103204.0504', moneda: 'ME'},
          'A1032040505':      {codigo: '103204.0505', moneda: 'ME'},
          'A10320406':        {codigo: '103204.06', moneda: 'ME'},
          'A1032040601':      {codigo: '103204.0601', moneda: 'ME'},
          'A1032040602':      {codigo: '103204.0602', moneda: 'ME'},
          'A1032040603':      {codigo: '103204.0603', moneda: 'ME'},
          'A1032040604':      {codigo: '103204.0604', moneda: 'ME'},
          'A1032040605':      {codigo: '103204.0605', moneda: 'ME'},
          'A10320407':        {codigo: '103204.07', moneda: 'ME'},
          'A1032040701':      {codigo: '103204.0701', moneda: 'ME'},
          'A1032040702':      {codigo: '103204.0702', moneda: 'ME'},
          'A1032040703':      {codigo: '103204.0703', moneda: 'ME'},
          'A1032040704':      {codigo: '103204.0704', moneda: 'ME'},
          'A1032040705':      {codigo: '103204.0705', moneda: 'ME'},
          'A10320410':        {codigo: '103204.1', moneda: 'ME'},
          'A1032041001':      {codigo: '103204.1001', moneda: 'ME'},
          'A1032041002':      {codigo: '103204.1002', moneda: 'ME'},
          'A1032041003':      {codigo: '103204.1003', moneda: 'ME'},
          'A1032041004':      {codigo: '103204.1004', moneda: 'ME'},
          'A1032041005':      {codigo: '103204.1005', moneda: 'ME'},
          'A10320411':        {codigo: '103204.11', moneda: 'ME'},
          'A1032041101':      {codigo: '103204.1101', moneda: 'ME'},
          'A1032041102':      {codigo: '103204.1102', moneda: 'ME'},
          'A1032041103':      {codigo: '103204.1103', moneda: 'ME'},
          'A1032041104':      {codigo: '103204.1104', moneda: 'ME'},
          'A1032041105':      {codigo: '103204.1105', moneda: 'ME'},
          'A10320412':        {codigo: '103204.12', moneda: 'ME'},
          'A1032041201':      {codigo: '103204.1201', moneda: 'ME'},
          'A1032041202':      {codigo: '103204.1202', moneda: 'ME'},
          'A1032041203':      {codigo: '103204.1203', moneda: 'ME'},
          'A1032041204':      {codigo: '103204.1204', moneda: 'ME'},
          'A1032041205':      {codigo: '103204.1205', moneda: 'ME'},
          'A10320413':        {codigo: '103204.13', moneda: 'ME'},
          'A1032041301':      {codigo: '103204.1301', moneda: 'ME'},
          'A1032041302':      {codigo: '103204.1302', moneda: 'ME'},
          'A1032041303':      {codigo: '103204.1303', moneda: 'ME'},
          'A1032041304':      {codigo: '103204.1304', moneda: 'ME'},
          'A1032041305':      {codigo: '103204.1305', moneda: 'ME'},
          'A10320414':        {codigo: '103204.14', moneda: 'ME'},
          'A10320417':        {codigo: '103204.17', moneda: 'ME'},
          'A1032041701':      {codigo: '103204.1701', moneda: 'ME'},
          'A1032041799':      {codigo: '103204.1799', moneda: 'ME'},
          'A10320418':        {codigo: '103204.18', moneda: 'ME'},
          'A1032041801':      {codigo: '103204.1801', moneda: 'ME'},
          'A1032041802':      {codigo: '103204.1802', moneda: 'ME'},
          'A1032041803':      {codigo: '103204.1803', moneda: 'ME'},
          'A1032041804':      {codigo: '103204.1804', moneda: 'ME'},
          'A1032041899':      {codigo: '103204.1899', moneda: 'ME'},
          'A10320425':        {codigo: '103204.25', moneda: 'ME'},
          'A1032042501':      {codigo: '103204.2501', moneda: 'ME'},
          'A1032042502':      {codigo: '103204.2502', moneda: 'ME'},
          'A1032042503':      {codigo: '103204.2503', moneda: 'ME'},
          'A1032042504':      {codigo: '103204.2504', moneda: 'ME'},
          'A1032042505':      {codigo: '103204.2505', moneda: 'ME'},
          'A10320426':        {codigo: '103204.26', moneda: 'ME'},
          'A1032042601':      {codigo: '103204.2601', moneda: 'ME'},
          'A1032042602':      {codigo: '103204.2602', moneda: 'ME'},
          'A1032042603':      {codigo: '103204.2603', moneda: 'ME'},
          'A1032042604':      {codigo: '103204.2604', moneda: 'ME'},
          'A1032042605':      {codigo: '103204.2605', moneda: 'ME'},
          'A104':             {codigo: '104', moneda: ''},
          'A1041':            {codigo: '1041', moneda: 'MN'},
          'A104101':          {codigo: '104101', moneda: 'MN'},
          'A10410102':        {codigo: '104101.02', moneda: 'MN'},
          'A10410103':        {codigo: '104101.03', moneda: 'MN'},
          'A10410105':        {codigo: '104101.05', moneda: 'MN'},
          'A10410107':        {codigo: '104101.07', moneda: 'MN'},
          'A10410108':        {codigo: '104101.08', moneda: 'MN'},
          'A10410199':        {codigo: '104101.99', moneda: 'MN'},
          'A104103':          {codigo: '104103', moneda: 'MN'},
          'A10410305':        {codigo: '104103.05', moneda: 'MN'},
          'A1041030501':      {codigo: '104103.0501', moneda: 'MN'},
          'A1041030502':      {codigo: '104103.0502', moneda: 'MN'},
          'A1041030503':      {codigo: '104103.0503', moneda: 'MN'},
          'A1041030504':      {codigo: '104103.0504', moneda: 'MN'},
          'A1041030505':      {codigo: '104103.0505', moneda: 'MN'},
          'A10410306':        {codigo: '104103.06', moneda: 'MN'},
          'A1041030601':      {codigo: '104103.0601', moneda: 'MN'},
          'A1041030602':      {codigo: '104103.0602', moneda: 'MN'},
          'A1041030603':      {codigo: '104103.0603', moneda: 'MN'},
          'A1041030604':      {codigo: '104103.0604', moneda: 'MN'},
          'A1041030605':      {codigo: '104103.0605', moneda: 'MN'},
          'A10410307':        {codigo: '104103.07', moneda: 'MN'},
          'A1041030701':      {codigo: '104103.0701', moneda: 'MN'},
          'A1041030702':      {codigo: '104103.0702', moneda: 'MN'},
          'A1041030703':      {codigo: '104103.0703', moneda: 'MN'},
          'A1041030704':      {codigo: '104103.0704', moneda: 'MN'},
          'A1041030705':      {codigo: '104103.0705', moneda: 'MN'},
          'A10410310':        {codigo: '104103.1', moneda: 'MN'},
          'A1041031001':      {codigo: '104103.1001', moneda: 'MN'},
          'A1041031002':      {codigo: '104103.1002', moneda: 'MN'},
          'A1041031003':      {codigo: '104103.1003', moneda: 'MN'},
          'A1041031004':      {codigo: '104103.1004', moneda: 'MN'},
          'A1041031005':      {codigo: '104103.1005', moneda: 'MN'},
          'A10410311':        {codigo: '104103.11', moneda: 'MN'},
          'A1041031101':      {codigo: '104103.1101', moneda: 'MN'},
          'A1041031102':      {codigo: '104103.1102', moneda: 'MN'},
          'A1041031103':      {codigo: '104103.1103', moneda: 'MN'},
          'A1041031104':      {codigo: '104103.1104', moneda: 'MN'},
          'A1041031105':      {codigo: '104103.1105', moneda: 'MN'},
          'A10410312':        {codigo: '104103.12', moneda: 'MN'},
          'A1041031201':      {codigo: '104103.1201', moneda: 'MN'},
          'A1041031202':      {codigo: '104103.1202', moneda: 'MN'},
          'A1041031203':      {codigo: '104103.1203', moneda: 'MN'},
          'A1041031204':      {codigo: '104103.1204', moneda: 'MN'},
          'A1041031205':      {codigo: '104103.1205', moneda: 'MN'},
          'A10410313':        {codigo: '104103.13', moneda: 'MN'},
          'A1041031301':      {codigo: '104103.1301', moneda: 'MN'},
          'A1041031302':      {codigo: '104103.1302', moneda: 'MN'},
          'A1041031303':      {codigo: '104103.1303', moneda: 'MN'},
          'A1041031304':      {codigo: '104103.1304', moneda: 'MN'},
          'A1041031305':      {codigo: '104103.1305', moneda: 'MN'},
          'A10410314':        {codigo: '104103.14', moneda: 'MN'},
          'A10410317':        {codigo: '104103.17', moneda: 'MN'},
          'A1041031701':      {codigo: '104103.1701', moneda: 'MN'},
          'A1041031799':      {codigo: '104103.1799', moneda: 'MN'},
          'A10410318':        {codigo: '104103.18', moneda: 'MN'},
          'A1041031801':      {codigo: '104103.1801', moneda: 'MN'},
          'A1041031802':      {codigo: '104103.1802', moneda: 'MN'},
          'A1041031803':      {codigo: '104103.1803', moneda: 'MN'},
          'A1041031804':      {codigo: '104103.1804', moneda: 'MN'},
          'A1041031899':      {codigo: '104103.1899', moneda: 'MN'},
          'A104104':          {codigo: '104104', moneda: 'MN'},
          'A10410405':        {codigo: '104104.05', moneda: 'MN'},
          'A1041040501':      {codigo: '104104.0501', moneda: 'MN'},
          'A1041040502':      {codigo: '104104.0502', moneda: 'MN'},
          'A1041040503':      {codigo: '104104.0503', moneda: 'MN'},
          'A1041040504':      {codigo: '104104.0504', moneda: 'MN'},
          'A1041040505':      {codigo: '104104.0505', moneda: 'MN'},
          'A10410406':        {codigo: '104104.06', moneda: 'MN'},
          'A1041040601':      {codigo: '104104.0601', moneda: 'MN'},
          'A1041040602':      {codigo: '104104.0602', moneda: 'MN'},
          'A1041040603':      {codigo: '104104.0603', moneda: 'MN'},
          'A1041040604':      {codigo: '104104.0604', moneda: 'MN'},
          'A1041040605':      {codigo: '104104.0605', moneda: 'MN'},
          'A10410407':        {codigo: '104104.07', moneda: 'MN'},
          'A1041040701':      {codigo: '104104.0701', moneda: 'MN'},
          'A1041040702':      {codigo: '104104.0702', moneda: 'MN'},
          'A1041040703':      {codigo: '104104.0703', moneda: 'MN'},
          'A1041040704':      {codigo: '104104.0704', moneda: 'MN'},
          'A1041040705':      {codigo: '104104.0705', moneda: 'MN'},
          'A10410410':        {codigo: '104104.1', moneda: 'MN'},
          'A1041041001':      {codigo: '104104.1001', moneda: 'MN'},
          'A1041041002':      {codigo: '104104.1002', moneda: 'MN'},
          'A1041041003':      {codigo: '104104.1003', moneda: 'MN'},
          'A1041041004':      {codigo: '104104.1004', moneda: 'MN'},
          'A1041041005':      {codigo: '104104.1005', moneda: 'MN'},
          'A10410411':        {codigo: '104104.11', moneda: 'MN'},
          'A1041041101':      {codigo: '104104.1101', moneda: 'MN'},
          'A1041041102':      {codigo: '104104.1102', moneda: 'MN'},
          'A1041041103':      {codigo: '104104.1103', moneda: 'MN'},
          'A1041041104':      {codigo: '104104.1104', moneda: 'MN'},
          'A1041041105':      {codigo: '104104.1105', moneda: 'MN'},
          'A10410412':        {codigo: '104104.12', moneda: 'MN'},
          'A1041041201':      {codigo: '104104.1201', moneda: 'MN'},
          'A1041041202':      {codigo: '104104.1202', moneda: 'MN'},
          'A1041041203':      {codigo: '104104.1203', moneda: 'MN'},
          'A1041041204':      {codigo: '104104.1204', moneda: 'MN'},
          'A1041041205':      {codigo: '104104.1205', moneda: 'MN'},
          'A10410413':        {codigo: '104104.13', moneda: 'MN'},
          'A1041041301':      {codigo: '104104.1301', moneda: 'MN'},
          'A1041041302':      {codigo: '104104.1302', moneda: 'MN'},
          'A1041041303':      {codigo: '104104.1303', moneda: 'MN'},
          'A1041041304':      {codigo: '104104.1304', moneda: 'MN'},
          'A1041041305':      {codigo: '104104.1305', moneda: 'MN'},
          'A10410414':        {codigo: '104104.14', moneda: 'MN'},
          'A10410417':        {codigo: '104104.17', moneda: 'MN'},
          'A1041041701':      {codigo: '104104.1701', moneda: 'MN'},
          'A1041041799':      {codigo: '104104.1799', moneda: 'MN'},
          'A10410418':        {codigo: '104104.18', moneda: 'MN'},
          'A1041041801':      {codigo: '104104.1801', moneda: 'MN'},
          'A1041041802':      {codigo: '104104.1802', moneda: 'MN'},
          'A1041041803':      {codigo: '104104.1803', moneda: 'MN'},
          'A1041041804':      {codigo: '104104.1804', moneda: 'MN'},
          'A1041041899':      {codigo: '104104.1899', moneda: 'MN'},
          'A10410425':        {codigo: '104104.25', moneda: 'MN'},
          'A1041042501':      {codigo: '104104.2501', moneda: 'MN'},
          'A1041042502':      {codigo: '104104.2502', moneda: 'MN'},
          'A1041042503':      {codigo: '104104.2503', moneda: 'MN'},
          'A1041042504':      {codigo: '104104.2504', moneda: 'MN'},
          'A1041042505':      {codigo: '104104.2505', moneda: 'MN'},
          'A10410426':        {codigo: '104104.26', moneda: 'MN'},
          'A1041042601':      {codigo: '104104.2601', moneda: 'MN'},
          'A1041042602':      {codigo: '104104.2602', moneda: 'MN'},
          'A1041042603':      {codigo: '104104.2603', moneda: 'MN'},
          'A1041042604':      {codigo: '104104.2604', moneda: 'MN'},
          'A1041042605':      {codigo: '104104.2605', moneda: 'MN'},
          'A104105':          {codigo: '104105', moneda: 'MN'},
          'A10410502':        {codigo: '104105.02', moneda: 'MN'},
          'A1041050201':      {codigo: '104105.0201', moneda: 'MN'},
          'A1041050202':      {codigo: '104105.0202', moneda: 'MN'},
          'A10410504':        {codigo: '104105.04', moneda: 'MN'},
          'A10410505':        {codigo: '104105.05', moneda: 'MN'},
          'A1041050501':      {codigo: '104105.0501', moneda: 'MN'},
          'A1041050502':      {codigo: '104105.0502', moneda: 'MN'},
          'A1041050599':      {codigo: '104105.0599', moneda: 'MN'},
          'A104107':          {codigo: '104107', moneda: 'MN'},
          'A10410701':        {codigo: '104107.01', moneda: 'MN'},
          'A1042':            {codigo: '1042', moneda: 'ME'},
          'A104201':          {codigo: '104201', moneda: 'ME'},
          'A10420102':        {codigo: '104201.02', moneda: 'ME'},
          'A10420103':        {codigo: '104201.03', moneda: 'ME'},
          'A10420105':        {codigo: '104201.05', moneda: 'ME'},
          'A10420107':        {codigo: '104201.07', moneda: 'ME'},
          'A10420108':        {codigo: '104201.08', moneda: 'ME'},
          'A10420199':        {codigo: '104201.99', moneda: 'ME'},
          'A104203':          {codigo: '104203', moneda: 'ME'},
          'A10420305':        {codigo: '104203.05', moneda: 'ME'},
          'A1042030501':      {codigo: '104203.0501', moneda: 'ME'},
          'A1042030502':      {codigo: '104203.0502', moneda: 'ME'},
          'A1042030503':      {codigo: '104203.0503', moneda: 'ME'},
          'A1042030504':      {codigo: '104203.0504', moneda: 'ME'},
          'A1042030505':      {codigo: '104203.0505', moneda: 'ME'},
          'A10420306':        {codigo: '104203.06', moneda: 'ME'},
          'A1042030601':      {codigo: '104203.0601', moneda: 'ME'},
          'A1042030602':      {codigo: '104203.0602', moneda: 'ME'},
          'A1042030603':      {codigo: '104203.0603', moneda: 'ME'},
          'A1042030604':      {codigo: '104203.0604', moneda: 'ME'},
          'A1042030605':      {codigo: '104203.0605', moneda: 'ME'},
          'A10420307':        {codigo: '104203.07', moneda: 'ME'},
          'A1042030701':      {codigo: '104203.0701', moneda: 'ME'},
          'A1042030702':      {codigo: '104203.0702', moneda: 'ME'},
          'A1042030703':      {codigo: '104203.0703', moneda: 'ME'},
          'A1042030704':      {codigo: '104203.0704', moneda: 'ME'},
          'A1042030705':      {codigo: '104203.0705', moneda: 'ME'},
          'A10420310':        {codigo: '104203.1', moneda: 'ME'},
          'A1042031001':      {codigo: '104203.1001', moneda: 'ME'},
          'A1042031002':      {codigo: '104203.1002', moneda: 'ME'},
          'A1042031003':      {codigo: '104203.1003', moneda: 'ME'},
          'A1042031004':      {codigo: '104203.1004', moneda: 'ME'},
          'A1042031005':      {codigo: '104203.1005', moneda: 'ME'},
          'A10420311':        {codigo: '104203.11', moneda: 'ME'},
          'A1042031101':      {codigo: '104203.1101', moneda: 'ME'},
          'A1042031102':      {codigo: '104203.1102', moneda: 'ME'},
          'A1042031103':      {codigo: '104203.1103', moneda: 'ME'},
          'A1042031104':      {codigo: '104203.1104', moneda: 'ME'},
          'A1042031105':      {codigo: '104203.1105', moneda: 'ME'},
          'A10420312':        {codigo: '104203.12', moneda: 'ME'},
          'A1042031201':      {codigo: '104203.1201', moneda: 'ME'},
          'A1042031202':      {codigo: '104203.1202', moneda: 'ME'},
          'A1042031203':      {codigo: '104203.1203', moneda: 'ME'},
          'A1042031204':      {codigo: '104203.1204', moneda: 'ME'},
          'A1042031205':      {codigo: '104203.1205', moneda: 'ME'},
          'A10420313':        {codigo: '104203.13', moneda: 'ME'},
          'A1042031301':      {codigo: '104203.1301', moneda: 'ME'},
          'A1042031302':      {codigo: '104203.1302', moneda: 'ME'},
          'A1042031303':      {codigo: '104203.1303', moneda: 'ME'},
          'A1042031304':      {codigo: '104203.1304', moneda: 'ME'},
          'A1042031305':      {codigo: '104203.1305', moneda: 'ME'},
          'A10420314':        {codigo: '104203.14', moneda: 'ME'},
          'A10420317':        {codigo: '104203.17', moneda: 'ME'},
          'A1042031701':      {codigo: '104203.1701', moneda: 'ME'},
          'A1042031799':      {codigo: '104203.1799', moneda: 'ME'},
          'A10420318':        {codigo: '104203.18', moneda: 'ME'},
          'A1042031801':      {codigo: '104203.1801', moneda: 'ME'},
          'A1042031802':      {codigo: '104203.1802', moneda: 'ME'},
          'A1042031803':      {codigo: '104203.1803', moneda: 'ME'},
          'A1042031804':      {codigo: '104203.1804', moneda: 'ME'},
          'A1042031899':      {codigo: '104203.1899', moneda: 'ME'},
          'A104204':          {codigo: '104204', moneda: 'ME'},
          'A10420405':        {codigo: '104204.05', moneda: 'ME'},
          'A1042040501':      {codigo: '104204.0501', moneda: 'ME'},
          'A1042040502':      {codigo: '104204.0502', moneda: 'ME'},
          'A1042040503':      {codigo: '104204.0503', moneda: 'ME'},
          'A1042040504':      {codigo: '104204.0504', moneda: 'ME'},
          'A1042040505':      {codigo: '104204.0505', moneda: 'ME'},
          'A10420406':        {codigo: '104204.06', moneda: 'ME'},
          'A1042040601':      {codigo: '104204.0601', moneda: 'ME'},
          'A1042040602':      {codigo: '104204.0602', moneda: 'ME'},
          'A1042040603':      {codigo: '104204.0603', moneda: 'ME'},
          'A1042040604':      {codigo: '104204.0604', moneda: 'ME'},
          'A1042040605':      {codigo: '104204.0605', moneda: 'ME'},
          'A10420407':        {codigo: '104204.07', moneda: 'ME'},
          'A1042040701':      {codigo: '104204.0701', moneda: 'ME'},
          'A1042040702':      {codigo: '104204.0702', moneda: 'ME'},
          'A1042040703':      {codigo: '104204.0703', moneda: 'ME'},
          'A1042040704':      {codigo: '104204.0704', moneda: 'ME'},
          'A1042040705':      {codigo: '104204.0705', moneda: 'ME'},
          'A10420410':        {codigo: '104204.1', moneda: 'ME'},
          'A1042041001':      {codigo: '104204.1001', moneda: 'ME'},
          'A1042041002':      {codigo: '104204.1002', moneda: 'ME'},
          'A1042041003':      {codigo: '104204.1003', moneda: 'ME'},
          'A1042041004':      {codigo: '104204.1004', moneda: 'ME'},
          'A1042041005':      {codigo: '104204.1005', moneda: 'ME'},
          'A10420411':        {codigo: '104204.11', moneda: 'ME'},
          'A1042041101':      {codigo: '104204.1101', moneda: 'ME'},
          'A1042041102':      {codigo: '104204.1102', moneda: 'ME'},
          'A1042041103':      {codigo: '104204.1103', moneda: 'ME'},
          'A1042041104':      {codigo: '104204.1104', moneda: 'ME'},
          'A1042041105':      {codigo: '104204.1105', moneda: 'ME'},
          'A10420412':        {codigo: '104204.12', moneda: 'ME'},
          'A1042041201':      {codigo: '104204.1201', moneda: 'ME'},
          'A1042041202':      {codigo: '104204.1202', moneda: 'ME'},
          'A1042041203':      {codigo: '104204.1203', moneda: 'ME'},
          'A1042041204':      {codigo: '104204.1204', moneda: 'ME'},
          'A1042041205':      {codigo: '104204.1205', moneda: 'ME'},
          'A10420413':        {codigo: '104204.13', moneda: 'ME'},
          'A1042041301':      {codigo: '104204.1301', moneda: 'ME'},
          'A1042041302':      {codigo: '104204.1302', moneda: 'ME'},
          'A1042041303':      {codigo: '104204.1303', moneda: 'ME'},
          'A1042041304':      {codigo: '104204.1304', moneda: 'ME'},
          'A1042041305':      {codigo: '104204.1305', moneda: 'ME'},
          'A10420414':        {codigo: '104204.14', moneda: 'ME'},
          'A10420417':        {codigo: '104204.17', moneda: 'ME'},
          'A1042041701':      {codigo: '104204.1701', moneda: 'ME'},
          'A1042041799':      {codigo: '104204.1799', moneda: 'ME'},
          'A10420418':        {codigo: '104204.18', moneda: 'ME'},
          'A1042041801':      {codigo: '104204.1801', moneda: 'ME'},
          'A1042041802':      {codigo: '104204.1802', moneda: 'ME'},
          'A1042041803':      {codigo: '104204.1803', moneda: 'ME'},
          'A1042041804':      {codigo: '104204.1804', moneda: 'ME'},
          'A1042041899':      {codigo: '104204.1899', moneda: 'ME'},
          'A10420425':        {codigo: '104204.25', moneda: 'ME'},
          'A1042042501':      {codigo: '104204.2501', moneda: 'ME'},
          'A1042042502':      {codigo: '104204.2502', moneda: 'ME'},
          'A1042042503':      {codigo: '104204.2503', moneda: 'ME'},
          'A1042042504':      {codigo: '104204.2504', moneda: 'ME'},
          'A1042042505':      {codigo: '104204.2505', moneda: 'ME'},
          'A10420426':        {codigo: '104204.26', moneda: 'ME'},
          'A1042042601':      {codigo: '104204.2601', moneda: 'ME'},
          'A1042042602':      {codigo: '104204.2602', moneda: 'ME'},
          'A1042042603':      {codigo: '104204.2603', moneda: 'ME'},
          'A1042042604':      {codigo: '104204.2604', moneda: 'ME'},
          'A1042042605':      {codigo: '104204.2605', moneda: 'ME'},
          'A104205':          {codigo: '104205', moneda: 'ME'},
          'A10420502':        {codigo: '104205.02', moneda: 'ME'},
          'A1042050201':      {codigo: '104205.0201', moneda: 'ME'},
          'A1042050202':      {codigo: '104205.0202', moneda: 'ME'},
          'A10420504':        {codigo: '104205.04', moneda: 'ME'},
          'A10420505':        {codigo: '104205.05', moneda: 'ME'},
          'A1042050501':      {codigo: '104205.0501', moneda: 'ME'},
          'A1042050502':      {codigo: '104205.0502', moneda: 'ME'},
          'A1042050599':      {codigo: '104205.0599', moneda: 'ME'},
          'A105':             {codigo: '105', moneda: ''},
          'A1051':            {codigo: '1051', moneda: 'MN'},
          'A105101':          {codigo: '105101', moneda: 'MN'},
          'A10510101':        {codigo: '105101.01', moneda: 'MN'},
          'A10510102':        {codigo: '105101.02', moneda: 'MN'},
          'A105102':          {codigo: '105102', moneda: 'MN'},
          'A10510201':        {codigo: '105102.01', moneda: 'MN'},
          'A10510202':        {codigo: '105102.02', moneda: 'MN'},
          'A1052':            {codigo: '1052', moneda: 'ME'},
          'A105201':          {codigo: '105201', moneda: 'ME'},
          'A10520101':        {codigo: '105201.01', moneda: 'ME'},
          'A10520102':        {codigo: '105201.02', moneda: 'ME'},
          'A105202':          {codigo: '105202', moneda: 'ME'},
          'A10520201':        {codigo: '105202.01', moneda: 'ME'},
          'A10520202':        {codigo: '105202.02', moneda: 'ME'},
          'A106':             {codigo: '106', moneda: ''},
          'A1061':            {codigo: '1061', moneda: 'MN'},
          'A106101':          {codigo: '106101', moneda: 'MN'},
          'A10610101':        {codigo: '106101.01', moneda: 'MN'},
          'A10610102':        {codigo: '106101.02', moneda: 'MN'},
          'A106102':          {codigo: '106102', moneda: 'MN'},
          'A10610201':        {codigo: '106102.01', moneda: 'MN'},
          'A10610299':        {codigo: '106102.99', moneda: 'MN'},
          'A107':             {codigo: '107', moneda: ''},
          'A1071':            {codigo: '1071', moneda: 'MN'},
          'A107101':          {codigo: '107101', moneda: 'MN'},
          'A10710101':        {codigo: '107101.01', moneda: 'MN'},
          'A10710102':        {codigo: '107101.02', moneda: 'MN'},
          'A10710103':        {codigo: '107101.03', moneda: 'MN'},
          'A107102':          {codigo: '107102', moneda: 'MN'},
          'A10710201':        {codigo: '107102.01', moneda: 'MN'},
          'A10710202':        {codigo: '107102.02', moneda: 'MN'},
          'A107103':          {codigo: '107103', moneda: 'MN'},
          'A10710301':        {codigo: '107103.01', moneda: 'MN'},
          'A10710302':        {codigo: '107103.02', moneda: 'MN'},
          'A107104':          {codigo: '107104', moneda: 'MN'},
          'A10710403':        {codigo: '107104.03', moneda: 'MN'},
          'A10710404':        {codigo: '107104.04', moneda: 'MN'},
          'A10710405':        {codigo: '107104.05', moneda: 'MN'},
          'A10710406':        {codigo: '107104.06', moneda: 'MN'},
          'A107105':          {codigo: '107105', moneda: 'MN'},
          'A10710501':        {codigo: '107105.01', moneda: 'MN'},
          'A108':             {codigo: '108', moneda: ''},
          'A1081':            {codigo: '1081', moneda: 'MN'},
          'A108101':          {codigo: '108101', moneda: 'MN'},
          'A10810101':        {codigo: '108101.01', moneda: 'MN'},
          'A10810102':        {codigo: '108101.02', moneda: 'MN'},
          'A10810103':        {codigo: '108101.03', moneda: 'MN'},
          'A10810104':        {codigo: '108101.04', moneda: 'MN'},
          'A10810105':        {codigo: '108101.05', moneda: 'MN'},
          'A10810199':        {codigo: '108101.99', moneda: 'MN'},
          'A108102':          {codigo: '108102', moneda: 'MN'},
          'A10810201':        {codigo: '108102.01', moneda: 'MN'},
          'A10810202':        {codigo: '108102.02', moneda: 'MN'},
          'A108103':          {codigo: '108103', moneda: 'MN'},
          'A10810301':        {codigo: '108103.01', moneda: 'MN'},
          'A10810399':        {codigo: '108103.99', moneda: 'MN'},
          'A108104':          {codigo: '108104', moneda: 'MN'},
          'A108119':          {codigo: '108119', moneda: 'MN'},
          'A10811999':        {codigo: '108119.99', moneda: 'MN'},
          'A1082':            {codigo: '1082', moneda: 'ME'},
          'A108201':          {codigo: '108201', moneda: 'ME'},
          'A10820101':        {codigo: '108201.01', moneda: 'ME'},
          'A10820102':        {codigo: '108201.02', moneda: 'ME'},
          'A10820103':        {codigo: '108201.03', moneda: 'ME'},
          'A10820104':        {codigo: '108201.04', moneda: 'ME'},
          'A10820199':        {codigo: '108201.99', moneda: 'ME'},
          'A108202':          {codigo: '108202', moneda: 'ME'},
          'A10820201':        {codigo: '108202.01', moneda: 'ME'},
          'A10820202':        {codigo: '108202.02', moneda: 'ME'},
          'A108219':          {codigo: '108219', moneda: 'ME'},
          'A10821999':        {codigo: '108219.99', moneda: 'ME'},
          'A109':             {codigo: '109', moneda: ''},
          'A1091':            {codigo: '1091', moneda: 'MN'},
          'A109101':          {codigo: '109101', moneda: 'MN'},
          'A10910101':        {codigo: '109101.01', moneda: 'MN'},
          'A10910102':        {codigo: '109101.02', moneda: 'MN'},
          'A110':             {codigo: '110', moneda: ''},
          'A1101':            {codigo: '1101', moneda: 'MN'},
          'A110101':          {codigo: '110101', moneda: 'MN'},
          'A11010101':        {codigo: '110101.01', moneda: 'MN'},
          'A11010102':        {codigo: '110101.02', moneda: 'MN'},
          'A110102':          {codigo: '110102', moneda: 'MN'},
          'A1102':            {codigo: '1102', moneda: 'ME'},
          'A110201':          {codigo: '110201', moneda: 'ME'},
          'A11020101':        {codigo: '110201.01', moneda: 'ME'},
          'A11020102':        {codigo: '110201.02', moneda: 'ME'},
          'A110202':          {codigo: '110202', moneda: 'ME'},
          'P2':               {codigo: '2', moneda: ''},
          'P201':             {codigo: '201', moneda: ''},
          'P2011':            {codigo: '2011', moneda: 'MN'},
          'P201107':          {codigo: '201107', moneda: 'MN'},
          'P20110702':        {codigo: '201107.02', moneda: 'MN'},
          'P201108':          {codigo: '201108', moneda: 'MN'},
          'P20110802':        {codigo: '201108.02', moneda: 'MN'},
          'P201109':          {codigo: '201109', moneda: 'MN'},
          'P20110901':        {codigo: '201109.01', moneda: 'MN'},
          'P20110904':        {codigo: '201109.04', moneda: 'MN'},
          'P20110905':        {codigo: '201109.05', moneda: 'MN'},
          'P2011090501':      {codigo: '201109.0501', moneda: 'MN'},
          'P2011090502':      {codigo: '201109.0502', moneda: 'MN'},
          'P2011090503':      {codigo: '201109.0503', moneda: 'MN'},
          'P2011090504':      {codigo: '201109.0504', moneda: 'MN'},
          'P2011090505':      {codigo: '201109.0505', moneda: 'MN'},
          'P20110906':        {codigo: '201109.06', moneda: 'MN'},
          'P20110907':        {codigo: '201109.07', moneda: 'MN'},
          'P20110996':        {codigo: '201109.96', moneda: 'MN'},
          'P20110997':        {codigo: '201109.97', moneda: 'MN'},
          'P20110998':        {codigo: '201109.98', moneda: 'MN'},
          'P20110999':        {codigo: '201109.99', moneda: 'MN'},
          'P201110':          {codigo: '201110', moneda: 'MN'},
          'P20111001':        {codigo: '201110.01', moneda: 'MN'},
          'P201112':          {codigo: '201112', moneda: 'MN'},
          'P20111202':        {codigo: '201112.02', moneda: 'MN'},
          'P20111203':        {codigo: '201112.03', moneda: 'MN'},
          'P20111208':        {codigo: '201112.08', moneda: 'MN'},
          'P2011120801':      {codigo: '201112.0801', moneda: 'MN'},
          'P2011120802':      {codigo: '201112.0802', moneda: 'MN'},
          'P2011120803':      {codigo: '201112.0803', moneda: 'MN'},
          'P2011120899':      {codigo: '201112.0899', moneda: 'MN'},
          'P20111209':        {codigo: '201112.09', moneda: 'MN'},
          'P2011120901':      {codigo: '201112.0901', moneda: 'MN'},
          'P2011120902':      {codigo: '201112.0902', moneda: 'MN'},
          'P2011120903':      {codigo: '201112.0903', moneda: 'MN'},
          'P2011120904':      {codigo: '201112.0904', moneda: 'MN'},
          'P2011120999':      {codigo: '201112.0999', moneda: 'MN'},
          'P20111213':        {codigo: '201112.13', moneda: 'MN'},
          'P20111216':        {codigo: '201112.16', moneda: 'MN'},
          'P20111299':        {codigo: '201112.99', moneda: 'MN'},
          'P201113':          {codigo: '201113', moneda: 'MN'},
          'P20111305':        {codigo: '201113.05', moneda: 'MN'},
          'P20111399':        {codigo: '201113.99', moneda: 'MN'},
          'P201120':          {codigo: '201120', moneda: 'MN'},
          'P20112001':        {codigo: '201120.01', moneda: 'MN'},
          'P20112002':        {codigo: '201120.02', moneda: 'MN'},
          'P201121':          {codigo: '201121', moneda: 'MN'},
          'P20112101':        {codigo: '201121.01', moneda: 'MN'},
          'P20112102':        {codigo: '201121.02', moneda: 'MN'},
          'P2012':            {codigo: '2012', moneda: 'ME'},
          'P201207':          {codigo: '201207', moneda: 'ME'},
          'P20120702':        {codigo: '201207.02', moneda: 'ME'},
          'P201208':          {codigo: '201208', moneda: 'ME'},
          'P20120802':        {codigo: '201208.02', moneda: 'ME'},
          'P201209':          {codigo: '201209', moneda: 'ME'},
          'P20120999':        {codigo: '201209.99', moneda: 'ME'},
          'P201212':          {codigo: '201212', moneda: 'ME'},
          'P20121202':        {codigo: '201212.02', moneda: 'ME'},
          'P20121203':        {codigo: '201212.03', moneda: 'ME'},
          'P20121208':        {codigo: '201212.08', moneda: 'ME'},
          'P2012120801':      {codigo: '201212.0801', moneda: 'ME'},
          'P2012120802':      {codigo: '201212.0802', moneda: 'ME'},
          'P2012120803':      {codigo: '201212.0803', moneda: 'ME'},
          'P2012120899':      {codigo: '201212.0899', moneda: 'ME'},
          'P20121209':        {codigo: '201212.09', moneda: 'ME'},
          'P2012120901':      {codigo: '201212.0901', moneda: 'ME'},
          'P2012120902':      {codigo: '201212.0902', moneda: 'ME'},
          'P2012120903':      {codigo: '201212.0903', moneda: 'ME'},
          'P2012120904':      {codigo: '201212.0904', moneda: 'ME'},
          'P2012120999':      {codigo: '201212.0999', moneda: 'ME'},
          'P20121213':        {codigo: '201212.13', moneda: 'ME'},
          'P20121216':        {codigo: '201212.16', moneda: 'ME'},
          'P20121299':        {codigo: '201212.99', moneda: 'ME'},
          'P201213':          {codigo: '201213', moneda: 'ME'},
          'P20121305':        {codigo: '201213.05', moneda: 'ME'},
          'P20121399':        {codigo: '201213.99', moneda: 'ME'},
          'P201220':          {codigo: '201220', moneda: 'ME'},
          'P20122001':        {codigo: '201220.01', moneda: 'ME'},
          'P20122002':        {codigo: '201220.02', moneda: 'ME'},
          'P201221':          {codigo: '201221', moneda: 'ME'},
          'P20122102':        {codigo: '201221.02', moneda: 'ME'},
          'P20122103':        {codigo: '201221.03', moneda: 'ME'},
          'P202':             {codigo: '202', moneda: ''},
          'P2021':            {codigo: '2021', moneda: 'MN'},
          'P202101':          {codigo: '202101', moneda: 'MN'},
          'P20210101':        {codigo: '202101.01', moneda: 'MN'},
          'P20210102':        {codigo: '202101.02', moneda: 'MN'},
          'P202103':          {codigo: '202103', moneda: 'MN'},
          'P20210301':        {codigo: '202103.01', moneda: 'MN'},
          'P20210302':        {codigo: '202103.02', moneda: 'MN'},
          'P20210303':        {codigo: '202103.03', moneda: 'MN'},
          'P2021030301':      {codigo: '202103.0301', moneda: 'MN'},
          'P2021030302':      {codigo: '202103.0302', moneda: 'MN'},
          'P2021030303':      {codigo: '202103.0303', moneda: 'MN'},
          'P2021030304':      {codigo: '202103.0304', moneda: 'MN'},
          'P2022':            {codigo: '2022', moneda: 'ME'},
          'P202201':          {codigo: '202201', moneda: 'ME'},
          'P20220101':        {codigo: '202201.01', moneda: 'ME'},
          'P20220102':        {codigo: '202201.02', moneda: 'ME'},
          'P202203':          {codigo: '202203', moneda: 'ME'},
          'P20220301':        {codigo: '202203.01', moneda: 'ME'},
          'P20220302':        {codigo: '202203.02', moneda: 'ME'},
          'P20220303':        {codigo: '202203.03', moneda: 'ME'},
          'P2022030301':      {codigo: '202203.0301', moneda: 'ME'},
          'P2022030302':      {codigo: '202203.0302', moneda: 'ME'},
          'P2022030303':      {codigo: '202203.0303', moneda: 'ME'},
          'P2022030304':      {codigo: '202203.0304', moneda: 'ME'},
          'P203':             {codigo: '203', moneda: ''},
          'P2031':            {codigo: '2031', moneda: 'MN'},
          'P203103':          {codigo: '203103', moneda: 'MN'},
          'P20310301':        {codigo: '203103.01', moneda: 'MN'},
          'P2032':            {codigo: '2032', moneda: 'ME'},
          'P203203':          {codigo: '203203', moneda: 'ME'},
          'P20320301':        {codigo: '203203.01', moneda: 'ME'},
          'P204':             {codigo: '204', moneda: ''},
          'P2041':            {codigo: '2041', moneda: 'MN'},
          'P204101':          {codigo: '204101', moneda: 'MN'},
          'P20410101':        {codigo: '204101.01', moneda: 'MN'},
          'P20410102':        {codigo: '204101.02', moneda: 'MN'},
          'P20410103':        {codigo: '204101.03', moneda: 'MN'},
          'P20410104':        {codigo: '204101.04', moneda: 'MN'},
          'P20410199':        {codigo: '204101.99', moneda: 'MN'},
          'P204102':          {codigo: '204102', moneda: 'MN'},
          'P20410202':        {codigo: '204102.02', moneda: 'MN'},
          'P20410203':        {codigo: '204102.03', moneda: 'MN'},
          'P2041020301':      {codigo: '204102.0301', moneda: 'MN'},
          'P2041020303':      {codigo: '204102.0303', moneda: 'MN'},
          'P2041020304':      {codigo: '204102.0304', moneda: 'MN'},
          'P2041020399':      {codigo: '204102.0399', moneda: 'MN'},
          'P2042':            {codigo: '2042', moneda: 'ME'},
          'P204201':          {codigo: '204201', moneda: 'ME'},
          'P20420103':        {codigo: '204201.03', moneda: 'ME'},
          'P20420104':        {codigo: '204201.04', moneda: 'ME'},
          'P20420199':        {codigo: '204201.99', moneda: 'ME'},
          'P204202':          {codigo: '204202', moneda: 'ME'},
          'P20420202':        {codigo: '204202.02', moneda: 'ME'},
          'P20420203':        {codigo: '204202.03', moneda: 'ME'},
          'P2042020301':      {codigo: '204202.0301', moneda: 'ME'},
          'P2042020303':      {codigo: '204202.0303', moneda: 'ME'},
          'P2042020304':      {codigo: '204202.0304', moneda: 'ME'},
          'P2042020399':      {codigo: '204202.0399', moneda: 'ME'},
          'P205':             {codigo: '205', moneda: ''},
          'P2051':            {codigo: '2051', moneda: 'MN'},
          'P205101':          {codigo: '205101', moneda: 'MN'},
          'P20510101':        {codigo: '205101.01', moneda: 'MN'},
          'P20510102':        {codigo: '205101.02', moneda: 'MN'},
          'P205102':          {codigo: '205102', moneda: 'MN'},
          'P20510201':        {codigo: '205102.01', moneda: 'MN'},
          'P20510202':        {codigo: '205102.02', moneda: 'MN'},
          'P2052':            {codigo: '2052', moneda: 'ME'},
          'P205201':          {codigo: '205201', moneda: 'ME'},
          'P20520101':        {codigo: '205201.01', moneda: 'ME'},
          'P20520102':        {codigo: '205201.02', moneda: 'ME'},
          'P205202':          {codigo: '205202', moneda: 'ME'},
          'P20520201':        {codigo: '205202.01', moneda: 'ME'},
          'P20520202':        {codigo: '205202.02', moneda: 'ME'},
          'P206':             {codigo: '206', moneda: ''},
          'P2061':            {codigo: '2061', moneda: 'MN'},
          'P206101':          {codigo: '206101', moneda: 'MN'},
          'P20610101':        {codigo: '206101.01', moneda: 'MN'},
          'P20610102':        {codigo: '206101.02', moneda: 'MN'},
          'P20610103':        {codigo: '206101.03', moneda: 'MN'},
          'P20610199':        {codigo: '206101.99', moneda: 'MN'},
          'P206102':          {codigo: '206102', moneda: 'MN'},
          'P20610201':        {codigo: '206102.01', moneda: 'MN'},
          'P206104':          {codigo: '206104', moneda: 'MN'},
          'P20610401':        {codigo: '206104.01', moneda: 'MN'},
          'P206107':          {codigo: '206107', moneda: 'MN'},
          'P20610701':        {codigo: '206107.01', moneda: 'MN'},
          'P2062':            {codigo: '2062', moneda: 'ME'},
          'P206201':          {codigo: '206201', moneda: 'ME'},
          'P20620101':        {codigo: '206201.01', moneda: 'ME'},
          'P20620102':        {codigo: '206201.02', moneda: 'ME'},
          'P20620103':        {codigo: '206201.03', moneda: 'ME'},
          'P20620199':        {codigo: '206201.99', moneda: 'ME'},
          'P206202':          {codigo: '206202', moneda: 'ME'},
          'P20620201':        {codigo: '206202.01', moneda: 'ME'},
          'P206204':          {codigo: '206204', moneda: 'ME'},
          'P20620401':        {codigo: '206204.01', moneda: 'ME'},
          'P206207':          {codigo: '206207', moneda: 'ME'},
          'P20620701':        {codigo: '206207.01', moneda: 'ME'},
          'P207':             {codigo: '207', moneda: ''},
          'P2071':            {codigo: '2071', moneda: 'MN'},
          'P207101':          {codigo: '207101', moneda: 'MN'},
          'P20710101':        {codigo: '207101.01', moneda: 'MN'},
          'P20710102':        {codigo: '207101.02', moneda: 'MN'},
          'P20710103':        {codigo: '207101.03', moneda: 'MN'},
          'P20710104':        {codigo: '207101.04', moneda: 'MN'},
          'P20710105':        {codigo: '207101.05', moneda: 'MN'},
          'P20710106':        {codigo: '207101.06', moneda: 'MN'},
          'P207102':          {codigo: '207102', moneda: 'MN'},
          'P20710201':        {codigo: '207102.01', moneda: 'MN'},
          'P20710202':        {codigo: '207102.02', moneda: 'MN'},
          'P20710203':        {codigo: '207102.03', moneda: 'MN'},
          'P20710204':        {codigo: '207102.04', moneda: 'MN'},
          'P20710205':        {codigo: '207102.05', moneda: 'MN'},
          'P20710206':        {codigo: '207102.06', moneda: 'MN'},
          'P207103':          {codigo: '207103', moneda: 'MN'},
          'P20710301':        {codigo: '207103.01', moneda: 'MN'},
          'P207104':          {codigo: '207104', moneda: 'MN'},
          'P20710401':        {codigo: '207104.01', moneda: 'MN'},
          'P207105':          {codigo: '207105', moneda: 'MN'},
          'P20710501':        {codigo: '207105.01', moneda: 'MN'},
          'P20710502':        {codigo: '207105.02', moneda: 'MN'},
          'P207106':          {codigo: '207106', moneda: 'MN'},
          'P20710601':        {codigo: '207106.01', moneda: 'MN'},
          'P20710602':        {codigo: '207106.02', moneda: 'MN'},
          'P207107':          {codigo: '207107', moneda: 'MN'},
          'P20710701':        {codigo: '207107.01', moneda: 'MN'},
          'P20710702':        {codigo: '207107.02', moneda: 'MN'},
          'P207108':          {codigo: '207108', moneda: 'MN'},
          'P20710801':        {codigo: '207108.01', moneda: 'MN'},
          'P207109':          {codigo: '207109', moneda: 'MN'},
          'P20710901':        {codigo: '207109.01', moneda: 'MN'},
          'P207110':          {codigo: '207110', moneda: 'MN'},
          'P20711001':        {codigo: '207110.01', moneda: 'MN'},
          'P207111':          {codigo: '207111', moneda: 'MN'},
          'P20711101':        {codigo: '207111.01', moneda: 'MN'},
          'P20711102':        {codigo: '207111.02', moneda: 'MN'},
          'P207112':          {codigo: '207112', moneda: 'MN'},
          'P20711201':        {codigo: '207112.01', moneda: 'MN'},
          'P20711202':        {codigo: '207112.02', moneda: 'MN'},
          'P208':             {codigo: '208', moneda: ''},
          'P2081':            {codigo: '2081', moneda: 'MN'},
          'P208102':          {codigo: '208102', moneda: 'MN'},
          'P20810201':        {codigo: '208102.01', moneda: 'MN'},
          'P20810202':        {codigo: '208102.02', moneda: 'MN'},
          'P20810203':        {codigo: '208102.03', moneda: 'MN'},
          'P20810204':        {codigo: '208102.04', moneda: 'MN'},
          'P20810299':        {codigo: '208102.99', moneda: 'MN'},
          'P208103':          {codigo: '208103', moneda: 'MN'},
          'P20810301':        {codigo: '208103.01', moneda: 'MN'},
          'P20810302':        {codigo: '208103.02', moneda: 'MN'},
          'P20810399':        {codigo: '208103.99', moneda: 'MN'},
          'P3':               {codigo: '3', moneda: ''},
          'P301':             {codigo: '301', moneda: ''},
          'P3011':            {codigo: '3011', moneda: 'MN'},
          'P301101':          {codigo: '301101', moneda: 'MN'},
          'P30110101':        {codigo: '301101.01', moneda: 'MN'},
          'P30110102':        {codigo: '301101.02', moneda: 'MN'},
          'P301103':          {codigo: '301103', moneda: 'MN'},
          'P302':             {codigo: '302', moneda: ''},
          'P3021':            {codigo: '3021', moneda: 'MN'},
          'P302101':          {codigo: '302101', moneda: 'MN'},
          'P30210101':        {codigo: '302101.01', moneda: 'MN'},
          'P302102':          {codigo: '302102', moneda: 'MN'},
          'P30210201':        {codigo: '302102.01', moneda: 'MN'},
          'P302105':          {codigo: '302105', moneda: 'MN'},
          'P30210501':        {codigo: '302105.01', moneda: 'MN'},
          'P30210502':        {codigo: '302105.02', moneda: 'MN'},
          'P302107':          {codigo: '302107', moneda: 'MN'},
          'P30210701':        {codigo: '302107.01', moneda: 'MN'},
          'P302108':          {codigo: '302108', moneda: 'MN'},
          'P30210801':        {codigo: '302108.01', moneda: 'MN'},
          'P30210802':        {codigo: '302108.02', moneda: 'MN'},
          'P302109':          {codigo: '302109', moneda: 'MN'},
          'C4':               {codigo: '4', moneda: ''},
          'C401':             {codigo: '401', moneda: ''},
          'C4011':            {codigo: '4011', moneda: 'MN'},
          'C401102':          {codigo: '401102', moneda: 'MN'},
          'C40110201':        {codigo: '401102.01', moneda: 'MN'},
          'C40110203':        {codigo: '401102.03', moneda: 'MN'},
          'C401103':          {codigo: '401103', moneda: 'MN'},
          'C40110301':        {codigo: '401103.01', moneda: 'MN'},
          'C40110399':        {codigo: '401103.99', moneda: 'MN'},
          'C4012':            {codigo: '4012', moneda: 'ME'},
          'C401202':          {codigo: '401202', moneda: 'ME'},
          'C40120201':        {codigo: '401202.01', moneda: 'ME'},
          'C40120203':        {codigo: '401202.03', moneda: 'ME'},
          'C401203':          {codigo: '401203', moneda: 'ME'},
          'C40120301':        {codigo: '401203.01', moneda: 'ME'},
          'C40120399':        {codigo: '401203.99', moneda: 'ME'},
          'C402':             {codigo: '402', moneda: ''},
          'C4021':            {codigo: '4021', moneda: 'MN'},
          'C402102':          {codigo: '402102', moneda: 'MN'},
          'C40210201':        {codigo: '402102.01', moneda: 'MN'},
          'C40210203':        {codigo: '402102.03', moneda: 'MN'},
          'C402103':          {codigo: '402103', moneda: 'MN'},
          'C40210301':        {codigo: '402103.01', moneda: 'MN'},
          'C40210399':        {codigo: '402103.99', moneda: 'MN'},
          'C4022':            {codigo: '4022', moneda: 'ME'},
          'C402202':          {codigo: '402202', moneda: 'ME'},
          'C40220201':        {codigo: '402202.01', moneda: 'ME'},
          'C40220203':        {codigo: '402202.03', moneda: 'ME'},
          'C402203':          {codigo: '402203', moneda: 'ME'},
          'C40220301':        {codigo: '402203.01', moneda: 'ME'},
          'C40220399':        {codigo: '402203.99', moneda: 'ME'},
          'I5':               {codigo: '5', moneda: ''},
          'I501':             {codigo: '501', moneda: ''},
          'I5011':            {codigo: '5011', moneda: 'MN'},
          'I501101':          {codigo: '501101', moneda: 'MN'},
          'I50110101':        {codigo: '501101.01', moneda: 'MN'},
          'I5011010101':      {codigo: '501101.0101', moneda: 'MN'},
          'I5011010102':      {codigo: '501101.0102', moneda: 'MN'},
          'I50110102':        {codigo: '501101.02', moneda: 'MN'},
          'I5011010201':      {codigo: '501101.0201', moneda: 'MN'},
          'I501101020101':    {codigo: '501101.020101', moneda: 'MN'},
          'I501101020102':    {codigo: '501101.020102', moneda: 'MN'},
          'I5011010202':      {codigo: '501101.0202', moneda: 'MN'},
          'I5011010203':      {codigo: '501101.0203', moneda: 'MN'},
          'I501101020301':    {codigo: '501101.020301', moneda: 'MN'},
          'I501101020302':    {codigo: '501101.020302', moneda: 'MN'},
          'I501101020399':    {codigo: '501101.020399', moneda: 'MN'},
          'I50110103':        {codigo: '501101.03', moneda: 'MN'},
          'I5011010305':      {codigo: '501101.0305', moneda: 'MN'},
          'I501101030501':    {codigo: '501101.030501', moneda: 'MN'},
          'I501101030502':    {codigo: '501101.030502', moneda: 'MN'},
          'I501101030503':    {codigo: '501101.030503', moneda: 'MN'},
          'I501101030504':    {codigo: '501101.030504', moneda: 'MN'},
          'I501101030505':    {codigo: '501101.030505', moneda: 'MN'},
          'I5011010306':      {codigo: '501101.0306', moneda: 'MN'},
          'I501101030601':    {codigo: '501101.030601', moneda: 'MN'},
          'I501101030602':    {codigo: '501101.030602', moneda: 'MN'},
          'I501101030603':    {codigo: '501101.030603', moneda: 'MN'},
          'I501101030604':    {codigo: '501101.030604', moneda: 'MN'},
          'I501101030605':    {codigo: '501101.030605', moneda: 'MN'},
          'I5011010307':      {codigo: '501101.0307', moneda: 'MN'},
          'I501101030701':    {codigo: '501101.030701', moneda: 'MN'},
          'I501101030702':    {codigo: '501101.030702', moneda: 'MN'},
          'I501101030703':    {codigo: '501101.030703', moneda: 'MN'},
          'I501101030704':    {codigo: '501101.030704', moneda: 'MN'},
          'I501101030705':    {codigo: '501101.030705', moneda: 'MN'},
          'I5011010310':      {codigo: '501101.031', moneda: 'MN'},
          'I501101031001':    {codigo: '501101.031001', moneda: 'MN'},
          'I501101031002':    {codigo: '501101.031002', moneda: 'MN'},
          'I501101031003':    {codigo: '501101.031003', moneda: 'MN'},
          'I501101031004':    {codigo: '501101.031004', moneda: 'MN'},
          'I501101031005':    {codigo: '501101.031005', moneda: 'MN'},
          'I5011010311':      {codigo: '501101.0311', moneda: 'MN'},
          'I501101031101':    {codigo: '501101.031101', moneda: 'MN'},
          'I501101031102':    {codigo: '501101.031102', moneda: 'MN'},
          'I501101031103':    {codigo: '501101.031103', moneda: 'MN'},
          'I501101031104':    {codigo: '501101.031104', moneda: 'MN'},
          'I501101031105':    {codigo: '501101.031105', moneda: 'MN'},
          'I5011010312':      {codigo: '501101.0312', moneda: 'MN'},
          'I501101031201':    {codigo: '501101.031201', moneda: 'MN'},
          'I501101031202':    {codigo: '501101.031202', moneda: 'MN'},
          'I501101031203':    {codigo: '501101.031203', moneda: 'MN'},
          'I501101031204':    {codigo: '501101.031204', moneda: 'MN'},
          'I501101031205':    {codigo: '501101.031205', moneda: 'MN'},
          'I5011010313':      {codigo: '501101.0313', moneda: 'MN'},
          'I501101031301':    {codigo: '501101.031301', moneda: 'MN'},
          'I501101031302':    {codigo: '501101.031302', moneda: 'MN'},
          'I501101031303':    {codigo: '501101.031303', moneda: 'MN'},
          'I501101031304':    {codigo: '501101.031304', moneda: 'MN'},
          'I501101031305':    {codigo: '501101.031305', moneda: 'MN'},
          'I5011010314':      {codigo: '501101.0314', moneda: 'MN'},
          'I5011010315':      {codigo: '501101.0315', moneda: 'MN'},
          'I5011010317':      {codigo: '501101.0317', moneda: 'MN'},
          'I501101031701':    {codigo: '501101.031701', moneda: 'MN'},
          'I501101031799':    {codigo: '501101.031799', moneda: 'MN'},
          'I5011010318':      {codigo: '501101.0318', moneda: 'MN'},
          'I501101031801':    {codigo: '501101.031801', moneda: 'MN'},
          'I501101031802':    {codigo: '501101.031802', moneda: 'MN'},
          'I501101031803':    {codigo: '501101.031803', moneda: 'MN'},
          'I501101031804':    {codigo: '501101.031804', moneda: 'MN'},
          'I501101031899':    {codigo: '501101.031899', moneda: 'MN'},
          'I5011010325':      {codigo: '501101.0325', moneda: 'MN'},
          'I501101032501':    {codigo: '501101.032501', moneda: 'MN'},
          'I501101032502':    {codigo: '501101.032502', moneda: 'MN'},
          'I501101032503':    {codigo: '501101.032503', moneda: 'MN'},
          'I501101032504':    {codigo: '501101.032504', moneda: 'MN'},
          'I501101032505':    {codigo: '501101.032505', moneda: 'MN'},
          'I5011010326':      {codigo: '501101.0326', moneda: 'MN'},
          'I501101032601':    {codigo: '501101.032601', moneda: 'MN'},
          'I501101032602':    {codigo: '501101.032602', moneda: 'MN'},
          'I501101032603':    {codigo: '501101.032603', moneda: 'MN'},
          'I501101032604':    {codigo: '501101.032604', moneda: 'MN'},
          'I501101032605':    {codigo: '501101.032605', moneda: 'MN'},
          'I501103':          {codigo: '501103', moneda: 'MN'},
          'I50110301':        {codigo: '501103.01', moneda: 'MN'},
          'I5011030101':      {codigo: '501103.0101', moneda: 'MN'},
          'I50110399':        {codigo: '501103.99', moneda: 'MN'},
          'I501105':          {codigo: '501105', moneda: 'MN'},
          'I50110501':        {codigo: '501105.01', moneda: 'MN'},
          'I5011050101':      {codigo: '501105.0101', moneda: 'MN'},
          'I5011050102':      {codigo: '501105.0102', moneda: 'MN'},
          'I501199':          {codigo: '501199', moneda: 'MN'},
          'I50119999':        {codigo: '501199.99', moneda: 'MN'},
          'I5012':            {codigo: '5012', moneda: 'ME'},
          'I501201':          {codigo: '501201', moneda: 'ME'},
          'I50120101':        {codigo: '501201.01', moneda: 'ME'},
          'I5012010101':      {codigo: '501201.0101', moneda: 'ME'},
          'I5012010102':      {codigo: '501201.0102', moneda: 'ME'},
          'I50120102':        {codigo: '501201.02', moneda: 'ME'},
          'I5012010201':      {codigo: '501201.0201', moneda: 'ME'},
          'I501201020101':    {codigo: '501201.020101', moneda: 'ME'},
          'I501201020102':    {codigo: '501201.020102', moneda: 'ME'},
          'I5012010202':      {codigo: '501201.0202', moneda: 'ME'},
          'I5012010203':      {codigo: '501201.0203', moneda: 'ME'},
          'I501201020301':    {codigo: '501201.020301', moneda: 'ME'},
          'I501201020302':    {codigo: '501201.020302', moneda: 'ME'},
          'I501201020399':    {codigo: '501201.020399', moneda: 'ME'},
          'I50120103':        {codigo: '501201.03', moneda: 'ME'},
          'I5012010305':      {codigo: '501201.0305', moneda: 'ME'},
          'I501201030501':    {codigo: '501201.030501', moneda: 'ME'},
          'I501201030502':    {codigo: '501201.030502', moneda: 'ME'},
          'I501201030503':    {codigo: '501201.030503', moneda: 'ME'},
          'I501201030504':    {codigo: '501201.030504', moneda: 'ME'},
          'I501201030505':    {codigo: '501201.030505', moneda: 'ME'},
          'I5012010306':      {codigo: '501201.0306', moneda: 'ME'},
          'I501201030601':    {codigo: '501201.030601', moneda: 'ME'},
          'I501201030602':    {codigo: '501201.030602', moneda: 'ME'},
          'I501201030603':    {codigo: '501201.030603', moneda: 'ME'},
          'I501201030604':    {codigo: '501201.030604', moneda: 'ME'},
          'I501201030605':    {codigo: '501201.030605', moneda: 'ME'},
          'I5012010307':      {codigo: '501201.0307', moneda: 'ME'},
          'I501201030701':    {codigo: '501201.030701', moneda: 'ME'},
          'I501201030702':    {codigo: '501201.030702', moneda: 'ME'},
          'I501201030703':    {codigo: '501201.030703', moneda: 'ME'},
          'I501201030704':    {codigo: '501201.030704', moneda: 'ME'},
          'I501201030705':    {codigo: '501201.030705', moneda: 'ME'},
          'I5012010310':      {codigo: '501201.031', moneda: 'ME'},
          'I501201031001':    {codigo: '501201.031001', moneda: 'ME'},
          'I501201031002':    {codigo: '501201.031002', moneda: 'ME'},
          'I501201031003':    {codigo: '501201.031003', moneda: 'ME'},
          'I501201031004':    {codigo: '501201.031004', moneda: 'ME'},
          'I501201031005':    {codigo: '501201.031005', moneda: 'ME'},
          'I5012010311':      {codigo: '501201.0311', moneda: 'ME'},
          'I501201031101':    {codigo: '501201.031101', moneda: 'ME'},
          'I501201031102':    {codigo: '501201.031102', moneda: 'ME'},
          'I501201031103':    {codigo: '501201.031103', moneda: 'ME'},
          'I501201031104':    {codigo: '501201.031104', moneda: 'ME'},
          'I501201031105':    {codigo: '501201.031105', moneda: 'ME'},
          'I5012010312':      {codigo: '501201.0312', moneda: 'ME'},
          'I501201031201':    {codigo: '501201.031201', moneda: 'ME'},
          'I501201031202':    {codigo: '501201.031202', moneda: 'ME'},
          'I501201031203':    {codigo: '501201.031203', moneda: 'ME'},
          'I501201031204':    {codigo: '501201.031204', moneda: 'ME'},
          'I501201031205':    {codigo: '501201.031205', moneda: 'ME'},
          'I5012010313':      {codigo: '501201.0313', moneda: 'ME'},
          'I501201031301':    {codigo: '501201.031301', moneda: 'ME'},
          'I501201031302':    {codigo: '501201.031302', moneda: 'ME'},
          'I501201031303':    {codigo: '501201.031303', moneda: 'ME'},
          'I501201031304':    {codigo: '501201.031304', moneda: 'ME'},
          'I501201031305':    {codigo: '501201.031305', moneda: 'ME'},
          'I5012010314':      {codigo: '501201.0314', moneda: 'ME'},
          'I5012010317':      {codigo: '501201.0317', moneda: 'ME'},
          'I501201031701':    {codigo: '501201.031701', moneda: 'ME'},
          'I501201031799':    {codigo: '501201.031799', moneda: 'ME'},
          'I5012010318':      {codigo: '501201.0318', moneda: 'ME'},
          'I501201031801':    {codigo: '501201.031801', moneda: 'ME'},
          'I501201031802':    {codigo: '501201.031802', moneda: 'ME'},
          'I501201031803':    {codigo: '501201.031803', moneda: 'ME'},
          'I501201031804':    {codigo: '501201.031804', moneda: 'ME'},
          'I501201031899':    {codigo: '501201.031899', moneda: 'ME'},
          'I5012010325':      {codigo: '501201.0325', moneda: 'ME'},
          'I501201032501':    {codigo: '501201.032501', moneda: 'ME'},
          'I501201032502':    {codigo: '501201.032502', moneda: 'ME'},
          'I501201032503':    {codigo: '501201.032503', moneda: 'ME'},
          'I501201032504':    {codigo: '501201.032504', moneda: 'ME'},
          'I501201032505':    {codigo: '501201.032505', moneda: 'ME'},
          'I5012010326':      {codigo: '501201.0326', moneda: 'ME'},
          'I501201032601':    {codigo: '501201.032601', moneda: 'ME'},
          'I501201032602':    {codigo: '501201.032602', moneda: 'ME'},
          'I501201032603':    {codigo: '501201.032603', moneda: 'ME'},
          'I501201032604':    {codigo: '501201.032604', moneda: 'ME'},
          'I501201032605':    {codigo: '501201.032605', moneda: 'ME'},
          'I501203':          {codigo: '501203', moneda: 'ME'},
          'I50120301':        {codigo: '501203.01', moneda: 'ME'},
          'I5012030101':      {codigo: '501203.0101', moneda: 'ME'},
          'I50120399':        {codigo: '501203.99', moneda: 'ME'},
          'I501299':          {codigo: '501299', moneda: 'ME'},
          'I50129999':        {codigo: '501299.99', moneda: 'ME'},
          'I502':             {codigo: '502', moneda: ''},
          'I5021':            {codigo: '5021', moneda: 'MN'},
          'I502101':          {codigo: '502101', moneda: 'MN'},
          'I50210101':        {codigo: '502101.01', moneda: 'MN'},
          'I50210102':        {codigo: '502101.02', moneda: 'MN'},
          'I50210199':        {codigo: '502101.99', moneda: 'MN'},
          'I502102':          {codigo: '502102', moneda: 'MN'},
          'I50210201':        {codigo: '502102.01', moneda: 'MN'},
          'I502103':          {codigo: '502103', moneda: 'MN'},
          'I50210301':        {codigo: '502103.01', moneda: 'MN'},
          'I50210399':        {codigo: '502103.99', moneda: 'MN'},
          'I5022':            {codigo: '5022', moneda: 'ME'},
          'I502201':          {codigo: '502201', moneda: 'ME'},
          'I50220101':        {codigo: '502201.01', moneda: 'ME'},
          'I50220102':        {codigo: '502201.02', moneda: 'ME'},
          'I50220199':        {codigo: '502201.99', moneda: 'ME'},
          'I503':             {codigo: '503', moneda: ''},
          'I5031':            {codigo: '5031', moneda: 'MN'},
          'I503101':          {codigo: '503101', moneda: 'MN'},
          'I503102':          {codigo: '503102', moneda: 'MN'},
          'I503103':          {codigo: '503103', moneda: 'MN'},
          'I503104':          {codigo: '503104', moneda: 'MN'},
          'I503198':          {codigo: '503198', moneda: 'MN'},
          'I503199':          {codigo: '503199', moneda: 'MN'},
          'I50319999':        {codigo: '503199.99', moneda: 'MN'},
          'I599':             {codigo: '599', moneda: ''},
          'I5991':            {codigo: '5991', moneda: 'MN'},
          'I599102':          {codigo: '599102', moneda: 'MN'},
          'I599199':          {codigo: '599199', moneda: 'MN'},
          'I59919999':        {codigo: '599199.99', moneda: 'MN'},
          'G6':               {codigo: '6', moneda: ''},
          'G601':             {codigo: '601', moneda: ''},
          'G6011':            {codigo: '6011', moneda: 'MN'},
          'G601101':          {codigo: '601101', moneda: 'MN'},
          'G60110102':        {codigo: '601101.02', moneda: 'MN'},
          'G60110103':        {codigo: '601101.03', moneda: 'MN'},
          'G60110108':        {codigo: '601101.08', moneda: 'MN'},
          'G60110113':        {codigo: '601101.13', moneda: 'MN'},
          'G60110114':        {codigo: '601101.14', moneda: 'MN'},
          'G60110115':        {codigo: '601101.15', moneda: 'MN'},
          'G60110199':        {codigo: '601101.99', moneda: 'MN'},
          'G601102':          {codigo: '601102', moneda: 'MN'},
          'G60110202':        {codigo: '601102.02', moneda: 'MN'},
          'G60110296':        {codigo: '601102.96', moneda: 'MN'},
          'G60110299':        {codigo: '601102.99', moneda: 'MN'},
          'G601105':          {codigo: '601105', moneda: 'MN'},
          'G60110501':        {codigo: '601105.01', moneda: 'MN'},
          'G6011050101':      {codigo: '601105.0101', moneda: 'MN'},
          'G6011050102':      {codigo: '601105.0102', moneda: 'MN'},
          'G601199':          {codigo: '601199', moneda: 'MN'},
          'G60119999':        {codigo: '601199.99', moneda: 'MN'},
          'G6012':            {codigo: '6012', moneda: 'ME'},
          'G601201':          {codigo: '601201', moneda: 'ME'},
          'G60120102':        {codigo: '601201.02', moneda: 'ME'},
          'G60120103':        {codigo: '601201.03', moneda: 'ME'},
          'G60120108':        {codigo: '601201.08', moneda: 'ME'},
          'G60120113':        {codigo: '601201.13', moneda: 'ME'},
          'G60120114':        {codigo: '601201.14', moneda: 'ME'},
          'G60120115':        {codigo: '601201.15', moneda: 'ME'},
          'G60120199':        {codigo: '601201.99', moneda: 'ME'},
          'G601202':          {codigo: '601202', moneda: 'ME'},
          'G60120202':        {codigo: '601202.02', moneda: 'ME'},
          'G60120296':        {codigo: '601202.96', moneda: 'ME'},
          'G60120299':        {codigo: '601202.99', moneda: 'ME'},
          'G602':             {codigo: '602', moneda: ''},
          'G6021':            {codigo: '6021', moneda: 'MN'},
          'G602101':          {codigo: '602101', moneda: 'MN'},
          'G60210101':        {codigo: '602101.01', moneda: 'MN'},
          'G6021010101':      {codigo: '602101.0101', moneda: 'MN'},
          'G6021010102':      {codigo: '602101.0102', moneda: 'MN'},
          'G6021010103':      {codigo: '602101.0103', moneda: 'MN'},
          'G6021010104':      {codigo: '602101.0104', moneda: 'MN'},
          'G6021010105':      {codigo: '602101.0105', moneda: 'MN'},
          'G6021010106':      {codigo: '602101.0106', moneda: 'MN'},
          'G6021010199':      {codigo: '602101.0199', moneda: 'MN'},
          'G60210102':        {codigo: '602101.02', moneda: 'MN'},
          'G6021010201':      {codigo: '602101.0201', moneda: 'MN'},
          'G6021010202':      {codigo: '602101.0202', moneda: 'MN'},
          'G6021010203':      {codigo: '602101.0203', moneda: 'MN'},
          'G6021010204':      {codigo: '602101.0204', moneda: 'MN'},
          'G6021010299':      {codigo: '602101.0299', moneda: 'MN'},
          'G60210103':        {codigo: '602101.03', moneda: 'MN'},
          'G6021010301':      {codigo: '602101.0301', moneda: 'MN'},
          'G6021010302':      {codigo: '602101.0302', moneda: 'MN'},
          'G6021010303':      {codigo: '602101.0303', moneda: 'MN'},
          'G6021010304':      {codigo: '602101.0304', moneda: 'MN'},
          'G6021010399':      {codigo: '602101.0399', moneda: 'MN'},
          'G60210104':        {codigo: '602101.04', moneda: 'MN'},
          'G602102':          {codigo: '602102', moneda: 'MN'},
          'G60210201':        {codigo: '602102.01', moneda: 'MN'},
          'G60210202':        {codigo: '602102.02', moneda: 'MN'},
          'G60210203':        {codigo: '602102.03', moneda: 'MN'},
          'G6021020301':      {codigo: '602102.0301', moneda: 'MN'},
          'G6021020302':      {codigo: '602102.0302', moneda: 'MN'},
          'G6021020303':      {codigo: '602102.0303', moneda: 'MN'},
          'G6021020304':      {codigo: '602102.0304', moneda: 'MN'},
          'G60210205':        {codigo: '602102.05', moneda: 'MN'},
          'G60210206':        {codigo: '602102.06', moneda: 'MN'},
          'G60210207':        {codigo: '602102.07', moneda: 'MN'},
          'G60210208':        {codigo: '602102.08', moneda: 'MN'},
          'G6021020801':      {codigo: '602102.0801', moneda: 'MN'},
          'G6021020802':      {codigo: '602102.0802', moneda: 'MN'},
          'G6021020803':      {codigo: '602102.0803', moneda: 'MN'},
          'G60210209':        {codigo: '602102.09', moneda: 'MN'},
          'G6021020901':      {codigo: '602102.0901', moneda: 'MN'},
          'G6021020902':      {codigo: '602102.0902', moneda: 'MN'},
          'G6021020903':      {codigo: '602102.0903', moneda: 'MN'},
          'G60210210':        {codigo: '602102.1', moneda: 'MN'},
          'G60210211':        {codigo: '602102.11', moneda: 'MN'},
          'G60210212':        {codigo: '602102.12', moneda: 'MN'},
          'G60210213':        {codigo: '602102.13', moneda: 'MN'},
          'G60210299':        {codigo: '602102.99', moneda: 'MN'},
          'G602103':          {codigo: '602103', moneda: 'MN'},
          'G60210301':        {codigo: '602103.01', moneda: 'MN'},
          'G60210302':        {codigo: '602103.02', moneda: 'MN'},
          'G60210303':        {codigo: '602103.03', moneda: 'MN'},
          'G602104':          {codigo: '602104', moneda: 'MN'},
          'G60210401':        {codigo: '602104.01', moneda: 'MN'},
          'G60210402':        {codigo: '602104.02', moneda: 'MN'},
          'G60210403':        {codigo: '602104.03', moneda: 'MN'},
          'G602105':          {codigo: '602105', moneda: 'MN'},
          'G60210501':        {codigo: '602105.01', moneda: 'MN'},
          'G60210502':        {codigo: '602105.02', moneda: 'MN'},
          'G60210503':        {codigo: '602105.03', moneda: 'MN'},
          'G60210505':        {codigo: '602105.05', moneda: 'MN'},
          'G60210599':        {codigo: '602105.99', moneda: 'MN'},
          'G602106':          {codigo: '602106', moneda: 'MN'},
          'G60210601':        {codigo: '602106.01', moneda: 'MN'},
          'G60210602':        {codigo: '602106.02', moneda: 'MN'},
          'G60210603':        {codigo: '602106.03', moneda: 'MN'},
          'G60210605':        {codigo: '602106.05', moneda: 'MN'},
          'G60210606':        {codigo: '602106.06', moneda: 'MN'},
          'G60210699':        {codigo: '602106.99', moneda: 'MN'},
          'G602107':          {codigo: '602107', moneda: 'MN'},
          'G60210701':        {codigo: '602107.01', moneda: 'MN'},
          'G602108':          {codigo: '602108', moneda: 'MN'},
          'G60210801':        {codigo: '602108.01', moneda: 'MN'},
          'G60210802':        {codigo: '602108.02', moneda: 'MN'},
          'G60210899':        {codigo: '602108.99', moneda: 'MN'},
          'G602109':          {codigo: '602109', moneda: 'MN'},
          'G60210901':        {codigo: '602109.01', moneda: 'MN'},
          'G60210902':        {codigo: '602109.02', moneda: 'MN'},
          'G60210903':        {codigo: '602109.03', moneda: 'MN'},
          'G60210904':        {codigo: '602109.04', moneda: 'MN'},
          'G60210905':        {codigo: '602109.05', moneda: 'MN'},
          'G60210906':        {codigo: '602109.06', moneda: 'MN'},
          'G60210999':        {codigo: '602109.99', moneda: 'MN'},
          'G602110':          {codigo: '602110', moneda: 'MN'},
          'G60211001':        {codigo: '602110.01', moneda: 'MN'},
          'G6021100101':      {codigo: '602110.0101', moneda: 'MN'},
          'G6021100102':      {codigo: '602110.0102', moneda: 'MN'},
          'G6021100103':      {codigo: '602110.0103', moneda: 'MN'},
          'G6021100104':      {codigo: '602110.0104', moneda: 'MN'},
          'G6021100105':      {codigo: '602110.0105', moneda: 'MN'},
          'G60211002':        {codigo: '602110.02', moneda: 'MN'},
          'G6021100201':      {codigo: '602110.0201', moneda: 'MN'},
          'G602110020101':    {codigo: '602110.020101', moneda: 'MN'},
          'G602110020102':    {codigo: '602110.020102', moneda: 'MN'},
          'G602110020103':    {codigo: '602110.020103', moneda: 'MN'},
          'G602110020104':    {codigo: '602110.020104', moneda: 'MN'},
          'G602110020105':    {codigo: '602110.020105', moneda: 'MN'},
          'G602110020106':    {codigo: '602110.020106', moneda: 'MN'},
          'G6021100202':      {codigo: '602110.0202', moneda: 'MN'},
          'G602110020201':    {codigo: '602110.020201', moneda: 'MN'},
          'G602110020202':    {codigo: '602110.020202', moneda: 'MN'},
          'G602110020203':    {codigo: '602110.020203', moneda: 'MN'},
          'G602110020204':    {codigo: '602110.020204', moneda: 'MN'},
          'G602110020205':    {codigo: '602110.020205', moneda: 'MN'},
          'G602110020206':    {codigo: '602110.020206', moneda: 'MN'},
          'G6021100203':      {codigo: '602110.0203', moneda: 'MN'},
          'G6021100204':      {codigo: '602110.0204', moneda: 'MN'},
          'G6021100205':      {codigo: '602110.0205', moneda: 'MN'},
          'G6021100206':      {codigo: '602110.0206', moneda: 'MN'},
          'G6021100207':      {codigo: '602110.0207', moneda: 'MN'},
          'G6021100208':      {codigo: '602110.0208', moneda: 'MN'},
          'G602112':          {codigo: '602112', moneda: 'MN'},
          'G60211201':        {codigo: '602112.01', moneda: 'MN'},
          'G60211202':        {codigo: '602112.02', moneda: 'MN'},
          'G602199':          {codigo: '602199', moneda: 'MN'},
          'G60219901':        {codigo: '602199.01', moneda: 'MN'},
          'G60219902':        {codigo: '602199.02', moneda: 'MN'},
          'G60219903':        {codigo: '602199.03', moneda: 'MN'},
          'G60219904':        {codigo: '602199.04', moneda: 'MN'},
          'G60219905':        {codigo: '602199.05', moneda: 'MN'},
          'G60219998':        {codigo: '602199.98', moneda: 'MN'},
          'G60219999':        {codigo: '602199.99', moneda: 'MN'},
          'G697':             {codigo: '697', moneda: ''},
          'G6971':            {codigo: '6971', moneda: 'MN'},
          'G697101':          {codigo: '697101', moneda: 'MN'},
          'G697102':          {codigo: '697102', moneda: 'MN'},
          'G697103':          {codigo: '697103', moneda: 'MN'},
          'G697199':          {codigo: '697199', moneda: 'MN'},
          'G69719999':        {codigo: '697199.99', moneda: 'MN'},
          'G699':             {codigo: '699', moneda: ''},
          'G6991':            {codigo: '6991', moneda: 'MN'},
          'G699101':          {codigo: '699101', moneda: 'MN'},
          'G69910199':        {codigo: '699101.99', moneda: 'MN'},
          'O7':               {codigo: '7', moneda: ''},
          'O701':             {codigo: '701', moneda: ''},
          'O7011':            {codigo: '7011', moneda: 'MN'},
          'O701102':          {codigo: '701102', moneda: 'MN'},
          'O70110201':        {codigo: '701102.01', moneda: 'MN'},
          'O70110202':        {codigo: '701102.02', moneda: 'MN'},
          'O701103':          {codigo: '701103', moneda: 'MN'},
          'O70110301':        {codigo: '701103.01', moneda: 'MN'},
          'O70110302':        {codigo: '701103.02', moneda: 'MN'},
          'O7012':            {codigo: '7012', moneda: 'ME'},
          'O701202':          {codigo: '701202', moneda: 'ME'},
          'O70120201':        {codigo: '701202.01', moneda: 'ME'},
          'O70120202':        {codigo: '701202.02', moneda: 'ME'},
          'O701203':          {codigo: '701203', moneda: 'ME'},
          'O70120301':        {codigo: '701203.01', moneda: 'ME'},
          'O70120302':        {codigo: '701203.02', moneda: 'ME'},
          'O702':             {codigo: '702', moneda: ''},
          'O7021':            {codigo: '7021', moneda: 'MN'},
          'O702106':          {codigo: '702106', moneda: 'MN'},
          'O70210601':        {codigo: '702106.01', moneda: 'MN'},
          'O7021060104':      {codigo: '702106.0104', moneda: 'MN'},
          'O7021060105':      {codigo: '702106.0105', moneda: 'MN'},
          'O7021060106':      {codigo: '702106.0106', moneda: 'MN'},
          'O70210602':        {codigo: '702106.02', moneda: 'MN'},
          'O7021060201':      {codigo: '702106.0201', moneda: 'MN'},
          'O7021060202':      {codigo: '702106.0202', moneda: 'MN'},
          'O70210603':        {codigo: '702106.03', moneda: 'MN'},
          'O70210604':        {codigo: '702106.04', moneda: 'MN'},
          'O70210605':        {codigo: '702106.05', moneda: 'MN'},
          'O70210606':        {codigo: '702106.06', moneda: 'MN'},
          'O70210607':        {codigo: '702106.07', moneda: 'MN'},
          'O70210608':        {codigo: '702106.08', moneda: 'MN'},
          'O70210609':        {codigo: '702106.09', moneda: 'MN'},
          'O7021060901':      {codigo: '702106.0901', moneda: 'MN'},
          'O7021060902':      {codigo: '702106.0902', moneda: 'MN'},
          'O70210610':        {codigo: '702106.1', moneda: 'MN'},
          'O70210699':        {codigo: '702106.99', moneda: 'MN'},
          'O7022':            {codigo: '7022', moneda: 'ME'},
          'O702206':          {codigo: '702206', moneda: 'ME'},
          'O70220601':        {codigo: '702206.01', moneda: 'ME'},
          'O7022060104':      {codigo: '702206.0104', moneda: 'ME'},
          'O7022060105':      {codigo: '702206.0105', moneda: 'ME'},
          'O7022060106':      {codigo: '702206.0106', moneda: 'ME'},
          'O70220602':        {codigo: '702206.02', moneda: 'ME'},
          'O7022060201':      {codigo: '702206.0201', moneda: 'ME'},
          'O7022060202':      {codigo: '702206.0202', moneda: 'ME'},
          'O70220603':        {codigo: '702206.03', moneda: 'ME'},
          'O70220604':        {codigo: '702206.04', moneda: 'ME'},
          'O70220605':        {codigo: '702206.05', moneda: 'ME'},
          'O70220606':        {codigo: '702206.06', moneda: 'ME'},
          'O70220607':        {codigo: '702206.07', moneda: 'ME'},
          'O70220608':        {codigo: '702206.08', moneda: 'ME'},
          'O70220609':        {codigo: '702206.09', moneda: 'ME'},
          'O7022060901':      {codigo: '702206.0901', moneda: 'ME'},
          'O7022060902':      {codigo: '702206.0902', moneda: 'ME'},
          'O70220610':        {codigo: '702206.1', moneda: 'ME'},
          'O70220699':        {codigo: '702206.99', moneda: 'ME'},
          'O703':             {codigo: '703', moneda: ''},
          'O7031':            {codigo: '7031', moneda: 'MN'},
          'O703101':          {codigo: '703101', moneda: 'MN'},
          'O70310101':        {codigo: '703101.01', moneda: 'MN'},
          'O70310102':        {codigo: '703101.02', moneda: 'MN'},
          'O70310103':        {codigo: '703101.03', moneda: 'MN'},
          'O70310104':        {codigo: '703101.04', moneda: 'MN'},
          'O70310105':        {codigo: '703101.05', moneda: 'MN'},
          'O703102':          {codigo: '703102', moneda: 'MN'},
          'O70310201':        {codigo: '703102.01', moneda: 'MN'},
          'O70310202':        {codigo: '703102.02', moneda: 'MN'},
          'O70310203':        {codigo: '703102.03', moneda: 'MN'},
          'O70310204':        {codigo: '703102.04', moneda: 'MN'},
          'O70310205':        {codigo: '703102.05', moneda: 'MN'},
          'O703103':          {codigo: '703103', moneda: 'MN'},
          'O70310301':        {codigo: '703103.01', moneda: 'MN'},
          'O70310302':        {codigo: '703103.02', moneda: 'MN'},
          'O70310303':        {codigo: '703103.03', moneda: 'MN'},
          'O70310304':        {codigo: '703103.04', moneda: 'MN'},
          'O70310305':        {codigo: '703103.05', moneda: 'MN'},
          'O703104':          {codigo: '703104', moneda: 'MN'},
          'O70310401':        {codigo: '703104.01', moneda: 'MN'},
          'O70310402':        {codigo: '703104.02', moneda: 'MN'},
          'O70310403':        {codigo: '703104.03', moneda: 'MN'},
          'O70310404':        {codigo: '703104.04', moneda: 'MN'},
          'O70310405':        {codigo: '703104.05', moneda: 'MN'},
          'O703105':          {codigo: '703105', moneda: 'MN'},
          'O70310501':        {codigo: '703105.01', moneda: 'MN'},
          'O70310502':        {codigo: '703105.02', moneda: 'MN'},
          'O70310503':        {codigo: '703105.03', moneda: 'MN'},
          'O70310504':        {codigo: '703105.04', moneda: 'MN'},
          'O70310505':        {codigo: '703105.05', moneda: 'MN'},
          'O703106':          {codigo: '703106', moneda: 'MN'},
          'O70310601':        {codigo: '703106.01', moneda: 'MN'},
          'O70310602':        {codigo: '703106.02', moneda: 'MN'},
          'O70310603':        {codigo: '703106.03', moneda: 'MN'},
          'O70310604':        {codigo: '703106.04', moneda: 'MN'},
          'O70310605':        {codigo: '703106.05', moneda: 'MN'},
          'O705':             {codigo: '705', moneda: ''},
          'O7051':            {codigo: '7051', moneda: 'MN'},
          'O705101':          {codigo: '705101', moneda: 'MN'},
          'O70510101':        {codigo: '705101.01', moneda: 'MN'},
          'O7052':            {codigo: '7052', moneda: 'ME'},
          'O705201':          {codigo: '705201', moneda: 'ME'},
          'O70520101':        {codigo: '705201.01', moneda: 'ME'},
          'O707':             {codigo: '707', moneda: ''},
          'O7071':            {codigo: '7071', moneda: 'MN'},
          'O707101':          {codigo: '707101', moneda: 'MN'},
          'O70710101':        {codigo: '707101.01', moneda: 'MN'},
          'O7071010125':      {codigo: '707101.0125', moneda: 'MN'},
          'O707101012501':    {codigo: '707101.012501', moneda: 'MN'},
          'O707101012502':    {codigo: '707101.012502', moneda: 'MN'},
          'O707101012503':    {codigo: '707101.012503', moneda: 'MN'},
          'O707101012504':    {codigo: '707101.012504', moneda: 'MN'},
          'O707101012505':    {codigo: '707101.012505', moneda: 'MN'},
          'O7071010126':      {codigo: '707101.0126', moneda: 'MN'},
          'O707101012601':    {codigo: '707101.012601', moneda: 'MN'},
          'O707101012602':    {codigo: '707101.012602', moneda: 'MN'},
          'O707101012603':    {codigo: '707101.012603', moneda: 'MN'},
          'O707101012604':    {codigo: '707101.012604', moneda: 'MN'},
          'O707101012605':    {codigo: '707101.012605', moneda: 'MN'},
          'O7072':            {codigo: '7072', moneda: 'ME'},
          'O707201':          {codigo: '707201', moneda: 'ME'},
          'O70720101':        {codigo: '707201.01', moneda: 'ME'},
          'O7072010125':      {codigo: '707201.0125', moneda: 'ME'},
          'O707201012501':    {codigo: '707201.012501', moneda: 'ME'},
          'O707201012502':    {codigo: '707201.012502', moneda: 'ME'},
          'O707201012503':    {codigo: '707201.012503', moneda: 'ME'},
          'O707201012504':    {codigo: '707201.012504', moneda: 'ME'},
          'O707201012505':    {codigo: '707201.012505', moneda: 'ME'},
          'O7072010126':      {codigo: '707201.0126', moneda: 'ME'},
          'O707201012601':    {codigo: '707201.012601', moneda: 'ME'},
          'O707201012602':    {codigo: '707201.012602', moneda: 'ME'},
          'O707201012603':    {codigo: '707201.012603', moneda: 'ME'},
          'O707201012604':    {codigo: '707201.012604', moneda: 'ME'},
          'O707201012605':    {codigo: '707201.012605', moneda: 'ME'},
          'O708':             {codigo: '708', moneda: ''},
          'O7081':            {codigo: '7081', moneda: 'MN'},
          'O708102':          {codigo: '708102', moneda: 'MN'},
          'O70810201':        {codigo: '708102.01', moneda: 'MN'},
          'O70810202':        {codigo: '708102.02', moneda: 'MN'},
          'O708199':          {codigo: '708199', moneda: 'MN'},
          'O70819901':        {codigo: '708199.01', moneda: 'MN'},
          'O7082':            {codigo: '7082', moneda: 'ME'},
          'O708202':          {codigo: '708202', moneda: 'ME'},
          'O70820201':        {codigo: '708202.01', moneda: 'ME'},
          'O70820202':        {codigo: '708202.02', moneda: 'ME'},
          'O708299':          {codigo: '708299', moneda: 'ME'},
          'O70829901':        {codigo: '708299.01', moneda: 'ME'},
          'O709':             {codigo: '709', moneda: ''},
          'O7091':            {codigo: '7091', moneda: 'MN'},
          'O709101':          {codigo: '709101', moneda: 'MN'},
          'O7092':            {codigo: '7092', moneda: 'ME'},
          'O709201':          {codigo: '709201', moneda: 'ME'},
          'O710':             {codigo: '710', moneda: ''},
          'O7101':            {codigo: '7101', moneda: 'MN'},
          'O710101':          {codigo: '710101', moneda: 'MN'},
          'O7102':            {codigo: '7102', moneda: 'ME'},
          'O710201':          {codigo: '710201', moneda: 'ME'},
          'O711':             {codigo: '711', moneda: ''},
          'O7111':            {codigo: '7111', moneda: 'MN'},
          'O711101':          {codigo: '711101', moneda: 'MN'},
          'O71110101':        {codigo: '711101.01', moneda: 'MN'},
          'O71110102':        {codigo: '711101.02', moneda: 'MN'},
          'O7112':            {codigo: '7112', moneda: 'ME'},
          'O711201':          {codigo: '711201', moneda: 'ME'},
          'O71120101':        {codigo: '711201.01', moneda: 'ME'},
          'O71120102':        {codigo: '711201.02', moneda: 'ME'},
          'O719':             {codigo: '719', moneda: ''},

        }
        return ids[id] ?? undefined;
      default: 
        return undefined;
    }
  }
}
export class activosPonderados{
  static tabla(plantilla: number, id: number){
    switch(plantilla){
      case 13: 
        return activos13[id] ?? undefined;
    }
  }

  static cuentasAT(plantilla: number){
    var cuentas = {};
    switch(plantilla){
      case 13:
        cuentas = {
          cuentas: ['A101101','A101201','A101102','A101202','A10210102','A10220102','A10310106','A10320106',
                    'A10210104','A10220104','A10210105','A10220105','A102102','A102202','A101103','A101203',
                    'A103102','A103202','A1031011701','A1032011701','A1031021701','A1032021701','A1031031701',
                    'A1032031701','A1031041701','A1032041701','A10310110','A10320110','A10310210','A10320210',
                    'A10310310','A10320310','A10310410','A10320410','A10310118','A10320118','A10320218','A10310218',
                    'A10310318','A10320318','A10310418','A10320418','A1','C401102','C401202','P207','A105','A1032',
                    'P301103','P302109','P302101','P302102','P302105','P302107','P302108',],
          varTemp: [],
          var: []
        }
        break;
    }
    return cuentas;
  }
}

var activos13 = {
  0:{codigo: 'titulo', descripcion: 'Suma de activos ponderados por riesgos', edit: false},
  1:{codigo: 'A101101',edit: false,},
  2:{codigo: 'A101201', edit: false},
  3:{codigo: 'A101102', edit: false},
  4:{codigo: 'A101202', edit: false},
  5:{codigo: 'A10210102', edit: false},
  6:{codigo: 'A10220102', edit: false},
  7:{codigo: 'A10310106', edit: false},
  8:{codigo: 'A10320106', edit: false},
  9:{codigo: 'A10210104', edit: false},
  10:{codigo: 'A10220104', edit: false},
  11:{codigo: 'A10210105', edit: false},
  12:{codigo: 'A10220105', edit: false},
  13:{codigo: 'A102102', edit: false},
  14:{codigo: 'A102202', edit: false},
  15:{codigo: 'editable1', edit: true, descripcion: 'Ajuste a activos con 0% de riesgo'},
  16:{codigo: 'suma', edit: false, descripcion: 'Activos ponderado con 0% de riesgo'},
  17:{codigo: 'A101103', edit: false},
  18:{codigo: 'A101203', edit: false},
  19:{codigo: 'A103102', edit: false},
  20:{codigo: 'A103202', edit: false},
  21:{codigo: 'editable2', edit: true, descripcion: 'Ajuste a activos con 10% de riesgo'},
  22:{codigo: 'suma', edit: false, descripcion: 'Activos ponderado con 10% de riesgo'},
  23:{codigo: 'A1031011701', edit: false},
  24:{codigo: 'A1032011701', edit: false},
  25:{codigo: 'A1031021701', edit: false},
  26:{codigo: 'A1032021701', edit: false},
  27:{codigo: 'A1031031701', edit: false},
  28:{codigo: 'A1032031701', edit: false},
  29:{codigo: 'A1031041701', edit: false},
  30:{codigo: 'A1032041701', edit: false},
  31:{codigo: 'editable3', edit: true, descripcion: 'Ajuste a activos con 20% de riesgo'},
  32:{codigo: 'suma', edit: false, descripcion: 'Activos ponderado con 20% de riesgo'},
  33:{codigo: 'A10310110', edit: false},
  34:{codigo: 'A10320110', edit: false},
  35:{codigo: 'A10310210', edit: false},
  36:{codigo: 'A10320210', edit: false},
  37:{codigo: 'A10310310', edit: false},
  38:{codigo: 'A10320310', edit: false},
  39:{codigo: 'A10310410', edit: false},
  40:{codigo: 'A10320410', edit: false},
  41:{codigo: 'A10310118', edit: false},
  42:{codigo: 'A10320118', edit: false},
  43:{codigo: 'A10320218', edit: false},
  44:{codigo: 'A10310218', edit: false},
  45:{codigo: 'A10310318', edit: false},
  46:{codigo: 'A10320318', edit: false},
  47:{codigo: 'A10310418', edit: false},
  48:{codigo: 'A10320418', edit: false},
  49:{codigo: 'editable4', edit: true, descripcion: 'Ajuste a activos con 50% de riesgo'},
  50:{codigo: 'suma', edit: false, descripcion: 'Activos ponderado con 50% de riesgo'},
  51:{codigo: 'A1', edit: false, descripcion: 'Total activo BG'},
  52:{codigo: 'sumas', edit: false, formula: '51 - 16 - 22 - 32 - 50 - 59', descripcion: 'Activo'},
  53:{codigo: 'C401102', edit:false},
  54:{codigo: 'C401202', edit:false},
  55:{codigo: 'P207', edit:false},
  56:{codigo: 'A105', edit:false},
  57:{codigo: 'editable5', edit: true, descripcion: 'Ajuste a activos con 100% de riesgo'},
  58:{codigo: 'suma', edit: false, formula:'52 + 53 + 54 - 55 - 56 + 57', descripcion: 'Activos ponderado con 100% de riesgo'},
  59:{codigo: 'A1032', edit: false},
  60:{codigo: 'editable5', edit: true, descripcion: '  Ajuste a activos con 150% de riesgo'},
  61:{codigo: 'suma', edit: false, descripcion: 'Activos ponderado con 150% de riesgo'},
  62:{codigo: 'total', edit: false, descripcion: 'Total activos con riesgos', formula: '16 + 22 + 32 + 50 + 58 + 61'},
  63:{codigo: 'titulo', edit: false, descripcion: 'Activos ponderados por riesgos'},
  64:{codigo: 'sub', edit: false, descripcion: 'Activos ponderados con 0% de riesgo', formula: '16 * 0.0'},
  65:{codigo: 'sub', edit: false, descripcion: 'Activos ponderados con 10% de riesgo', formula: '22 * 0.1'},
  66:{codigo: 'sub', edit: false, descripcion: 'Activos ponderados con 20% de riesgo', formula: '32 * 0.2'},
  67:{codigo: 'sub', edit: false, descripcion: 'Activos Ponderados con 50% de riesgo', formula: '50 * 0.5'},
  68:{codigo: 'sub', edit: false, descripcion: 'Activos ponderados con 100% de riesgo', formula: '58 * 1.0'},
  69:{codigo: 'sub', edit: false, descripcion: 'Activos ponderados con 150% de riesgo', formula: '61 * 1.5'},
  70:{codigo: 'total2', edit: false, descripcion: 'Total', formula: '63 + 64 + 65 + 66 + 67 + 68'},
  71:{codigo: 'titulo', edit: false, descripcion: 'Capital Institucional ajustado'},
  72:{codigo: 'sub', cuenta: 'P301103', edit: false, descripcion: 'Capital primario'},
  73:{codigo: 'subcapital', edit: false, descripcion: 'Capital complementario'},
  74:{codigo: 'sub', edit: false, descripcion: 'Mas: suficiencias de provision de carteras', formula: '7862795.0'},
  75:{codigo: 'sub', edit: false, descripcion: 'Menos: insuficiencias de provision de cartera', formula: '0.0'},
  76:{codigo: 'sub', edit: false, descripcion: 'Total capital institucional ajustado ', formula: '70 + 71 + 72 - 73'},
  77:{codigo: 'sub', edit: false, tarjeta: true, descripcion: 'Relación capital / activos ponderados', formula: '74 / 69', porcentaje: true},
  78:{codigo: 'sub', edit: false, descripcion: 'Indice de adecuacion de capital (IACI)', formula: '0.1', porcentaje: true},
  79:{codigo: 'sub', edit: false, tarjeta: true, descripcion: '10%', formula: '69 * 76'},

}